const servicesAndLanguages = 
{
    "meta": {
        "title": "Services and languages",
        "description": "Combined metadata about languages and language-related services. Generated by inventivio.lang.Updater",
        "version": "3.7.2"
    },
    "languages": {
        "af": {
            "fullTag": "af",
            "primaryTag": "af",
            "names": {
                "de": "Afrikaans",
                "en": "Afrikaans"
            }
        },
        "af-ZA": {
            "fullTag": "af-ZA",
            "primaryTag": "af",
            "names": {
                "de": "Afrikaans (Südafrika)",
                "en": "Afrikaans (South Africa)"
            }
        },
        "am": {
            "fullTag": "am",
            "primaryTag": "am",
            "names": {
                "de": "Amharisch",
                "en": "Amharic"
            }
        },
        "am-ET": {
            "fullTag": "am-ET",
            "primaryTag": "am",
            "names": {
                "de": "Amharisch (Äthiopien)",
                "en": "Amharic (Ethiopia)"
            }
        },
        "ar": {
            "fullTag": "ar",
            "primaryTag": "ar",
            "names": {
                "de": "Arabisch",
                "en": "Arabic"
            }
        },
        "ar-XA": {
            "fullTag": "ar-XA",
            "primaryTag": "ar",
            "names": {
                "de": "Arabisch (Modernes Hocharabisch)",
                "en": "Arabic (Modern Standard Arabic)"
            }
        },
        "as": {
            "fullTag": "as",
            "primaryTag": "as",
            "names": {
                "de": "Assamesisch",
                "en": "Assamese"
            }
        },
        "aw": {
            "fullTag": "aw",
            "primaryTag": "aw",
            "names": {
                "de": "aw",
                "en": "aw"
            }
        },
        "awa": {
            "fullTag": "awa",
            "primaryTag": "awa",
            "names": {
                "de": "Awadhi",
                "en": "Awadhi"
            }
        },
        "az": {
            "fullTag": "az",
            "primaryTag": "az",
            "names": {
                "de": "Aserbeidschanisch",
                "en": "Azeri"
            }
        },
        "ba": {
            "fullTag": "ba",
            "primaryTag": "ba",
            "names": {
                "de": "Baschkirisch",
                "en": "Bashkir"
            }
        },
        "be": {
            "fullTag": "be",
            "primaryTag": "be",
            "names": {
                "de": "Weißrussisch",
                "en": "Belarusian"
            }
        },
        "bg": {
            "fullTag": "bg",
            "primaryTag": "bg",
            "names": {
                "de": "Bulgarisch",
                "en": "Bulgarian"
            }
        },
        "bg-BG": {
            "fullTag": "bg-BG",
            "primaryTag": "bg",
            "names": {
                "de": "Bulgarisch (Bulgarien)",
                "en": "Bulgarian (Bulgaria)"
            }
        },
        "bh": {
            "fullTag": "bh",
            "primaryTag": "bh",
            "names": {
                "de": "Biharisch",
                "en": "Bihari"
            }
        },
        "bn": {
            "fullTag": "bn",
            "primaryTag": "bn",
            "names": {
                "de": "Bengalisch",
                "en": "Bangla"
            }
        },
        "bn-IN": {
            "fullTag": "bn-IN",
            "primaryTag": "bn",
            "names": {
                "de": "Bengalisch (Indien)",
                "en": "Bangla (India)"
            }
        },
        "bo": {
            "fullTag": "bo",
            "primaryTag": "bo",
            "names": {
                "de": "Tibetisch",
                "en": "Tibetan"
            }
        },
        "br": {
            "fullTag": "br",
            "primaryTag": "br",
            "names": {
                "de": "Bretonisch",
                "en": "Breton"
            }
        },
        "bra": {
            "fullTag": "bra",
            "primaryTag": "bra",
            "names": {
                "de": "Braj-Bhakha",
                "en": "Braj"
            }
        },
        "bs": {
            "fullTag": "bs",
            "primaryTag": "bs",
            "names": {
                "de": "Bosnisch",
                "en": "Bosnian"
            }
        },
        "ca": {
            "fullTag": "ca",
            "primaryTag": "ca",
            "names": {
                "de": "Katalanisch",
                "en": "Catalan"
            }
        },
        "ca-ES": {
            "fullTag": "ca-ES",
            "primaryTag": "ca",
            "names": {
                "de": "Katalanisch (Spanien)",
                "en": "Catalan (Spain)"
            }
        },
        "chr": {
            "fullTag": "chr",
            "primaryTag": "chr",
            "names": {
                "de": "Cherokee",
                "en": "Cherokee"
            }
        },
        "ckb": {
            "fullTag": "ckb",
            "primaryTag": "ckb",
            "names": {
                "de": "Zentralkurdisch",
                "en": "Soranî"
            }
        },
        "cmn": {
            "fullTag": "cmn",
            "primaryTag": "cmn",
            "names": {
                "de": "Mandarin",
                "en": "Mandarin"
            }
        },
        "cmn-CN": {
            "fullTag": "cmn-CN",
            "primaryTag": "cmn",
            "names": {
                "de": "Mandarin (China)",
                "en": "Mandarin (China)"
            }
        },
        "cmn-TW": {
            "fullTag": "cmn-TW",
            "primaryTag": "cmn",
            "names": {
                "de": "Mandarin (Taiwan)",
                "en": "Mandarin (Taiwan)"
            }
        },
        "cop": {
            "fullTag": "cop",
            "primaryTag": "cop",
            "names": {
                "de": "Koptisch",
                "en": "Coptic"
            }
        },
        "cs": {
            "fullTag": "cs",
            "primaryTag": "cs",
            "names": {
                "de": "Tschechisch",
                "en": "Czech"
            }
        },
        "cs-CZ": {
            "fullTag": "cs-CZ",
            "primaryTag": "cs",
            "names": {
                "de": "Tschechisch (Tschechien)",
                "en": "Czech (Czechia)"
            }
        },
        "cy": {
            "fullTag": "cy",
            "primaryTag": "cy",
            "names": {
                "de": "Walisisch",
                "en": "Welsh"
            }
        },
        "da": {
            "fullTag": "da",
            "primaryTag": "da",
            "names": {
                "de": "Dänisch",
                "en": "Danish"
            }
        },
        "da-DK": {
            "fullTag": "da-DK",
            "primaryTag": "da",
            "names": {
                "de": "Dänisch (Dänemark)",
                "en": "Danish (Denmark)"
            }
        },
        "de": {
            "fullTag": "de",
            "primaryTag": "de",
            "names": {
                "de": "Deutsch",
                "en": "German"
            }
        },
        "de-DE": {
            "fullTag": "de-DE",
            "primaryTag": "de",
            "names": {
                "de": "Deutsch (Deutschland)",
                "en": "German (Germany)"
            }
        },
        "dra": {
            "fullTag": "dra",
            "primaryTag": "dra",
            "names": {
                "de": "Drawidisch",
                "en": "Dravidian"
            }
        },
        "el": {
            "fullTag": "el",
            "primaryTag": "el",
            "names": {
                "de": "Griechisch",
                "en": "Greek"
            }
        },
        "el-GR": {
            "fullTag": "el-GR",
            "primaryTag": "el",
            "names": {
                "de": "Griechisch (Griechenland)",
                "en": "Greek (Greece)"
            }
        },
        "en": {
            "fullTag": "en",
            "primaryTag": "en",
            "names": {
                "de": "Englisch",
                "en": "English"
            }
        },
        "en-AU": {
            "fullTag": "en-AU",
            "primaryTag": "en",
            "names": {
                "de": "Englisch (Australien)",
                "en": "English (Australia)"
            }
        },
        "en-CA": {
            "fullTag": "en-CA",
            "primaryTag": "en",
            "names": {
                "de": "Englisch (Kanada)",
                "en": "English (Canada)"
            }
        },
        "en-GB": {
            "fullTag": "en-GB",
            "primaryTag": "en",
            "names": {
                "de": "Englisch (Vereinigtes Königreich Großbritannien und Nordirland)",
                "en": "English (United Kingdom of Great Britain and Northern Ireland)"
            }
        },
        "en-IN": {
            "fullTag": "en-IN",
            "primaryTag": "en",
            "names": {
                "de": "Englisch (Indien)",
                "en": "English (India)"
            }
        },
        "en-US": {
            "fullTag": "en-US",
            "primaryTag": "en",
            "names": {
                "de": "Englisch (Vereinigte Staaten)",
                "en": "English (United States of America)"
            }
        },
        "eo": {
            "fullTag": "eo",
            "primaryTag": "eo",
            "names": {
                "de": "Esperanto",
                "en": "Esperanto"
            }
        },
        "es": {
            "fullTag": "es",
            "primaryTag": "es",
            "names": {
                "de": "Spanisch",
                "en": "Spanish"
            }
        },
        "es-ES": {
            "fullTag": "es-ES",
            "primaryTag": "es",
            "names": {
                "de": "Spanisch (Spanien)",
                "en": "Spanish (Spain)"
            }
        },
        "es-MX": {
            "fullTag": "es-MX",
            "primaryTag": "es",
            "names": {
                "de": "Spanisch (Mexiko)",
                "en": "Spanish (Mexico)"
            }
        },
        "es-US": {
            "fullTag": "es-US",
            "primaryTag": "es",
            "names": {
                "de": "Spanisch (Vereinigte Staaten)",
                "en": "Spanish (United States of America)"
            }
        },
        "et": {
            "fullTag": "et",
            "primaryTag": "et",
            "names": {
                "de": "Estnisch",
                "en": "Estonian"
            }
        },
        "et-EE": {
            "fullTag": "et-EE",
            "primaryTag": "et",
            "names": {
                "de": "Estnisch (Estland)",
                "en": "Estonian (Estonia)"
            }
        },
        "eu": {
            "fullTag": "eu",
            "primaryTag": "eu",
            "names": {
                "de": "Baskisch",
                "en": "Basque"
            }
        },
        "eu-ES": {
            "fullTag": "eu-ES",
            "primaryTag": "eu",
            "names": {
                "de": "Baskisch (Spanien)",
                "en": "Basque (Spain)"
            }
        },
        "fa": {
            "fullTag": "fa",
            "primaryTag": "fa",
            "names": {
                "de": "Persisch",
                "en": "Farsi"
            }
        },
        "fa-AF": {
            "fullTag": "fa-AF",
            "primaryTag": "fa",
            "names": {
                "de": "Persisch (Afghanistan)",
                "en": "Farsi (Afghanistan)"
            }
        },
        "fi": {
            "fullTag": "fi",
            "primaryTag": "fi",
            "names": {
                "de": "Finnisch",
                "en": "Finnish"
            }
        },
        "fi-FI": {
            "fullTag": "fi-FI",
            "primaryTag": "fi",
            "names": {
                "de": "Finnisch (Finnland)",
                "en": "Finnish (Finland)"
            }
        },
        "fil": {
            "fullTag": "fil",
            "primaryTag": "fil",
            "names": {
                "de": "Filipino",
                "en": "Filipino"
            }
        },
        "fil-PH": {
            "fullTag": "fil-PH",
            "primaryTag": "fil",
            "names": {
                "de": "Filipino (Philippinen)",
                "en": "Filipino (Philippines)"
            }
        },
        "fr": {
            "fullTag": "fr",
            "primaryTag": "fr",
            "names": {
                "de": "Französisch",
                "en": "French"
            }
        },
        "fr-CA": {
            "fullTag": "fr-CA",
            "primaryTag": "fr",
            "names": {
                "de": "Französisch (Kanada)",
                "en": "French (Canada)"
            }
        },
        "fr-FR": {
            "fullTag": "fr-FR",
            "primaryTag": "fr",
            "names": {
                "de": "Französisch (Frankreich)",
                "en": "French (France)"
            }
        },
        "ga": {
            "fullTag": "ga",
            "primaryTag": "ga",
            "names": {
                "de": "Irisch",
                "en": "Irish"
            }
        },
        "gd": {
            "fullTag": "gd",
            "primaryTag": "gd",
            "names": {
                "de": "Gälisch (Schottland)",
                "en": "Scottish Gaelic"
            }
        },
        "gez": {
            "fullTag": "gez",
            "primaryTag": "gez",
            "names": {
                "de": "Geez",
                "en": "Geez"
            }
        },
        "gl": {
            "fullTag": "gl",
            "primaryTag": "gl",
            "names": {
                "de": "Galicisch",
                "en": "Galician"
            }
        },
        "gl-ES": {
            "fullTag": "gl-ES",
            "primaryTag": "gl",
            "names": {
                "de": "Galicisch (Spanien)",
                "en": "Galician (Spain)"
            }
        },
        "gon": {
            "fullTag": "gon",
            "primaryTag": "gon",
            "names": {
                "de": "Gondi",
                "en": "Gondi"
            }
        },
        "gr": {
            "fullTag": "gr",
            "primaryTag": "gr",
            "names": {
                "de": "gr",
                "en": "gr"
            }
        },
        "grc": {
            "fullTag": "grc",
            "primaryTag": "grc",
            "names": {
                "de": "Altgriechisch",
                "en": "Ancient Greek"
            }
        },
        "gu": {
            "fullTag": "gu",
            "primaryTag": "gu",
            "names": {
                "de": "Gujarati",
                "en": "Gujarati"
            }
        },
        "gu-IN": {
            "fullTag": "gu-IN",
            "primaryTag": "gu",
            "names": {
                "de": "Gujarati (Indien)",
                "en": "Gujarati (India)"
            }
        },
        "ha": {
            "fullTag": "ha",
            "primaryTag": "ha",
            "names": {
                "de": "Hausa",
                "en": "Haussa"
            }
        },
        "haw": {
            "fullTag": "haw",
            "primaryTag": "haw",
            "names": {
                "de": "Hawaiisch",
                "en": "Hawaiian"
            }
        },
        "hbo": {
            "fullTag": "hbo",
            "primaryTag": "hbo",
            "names": {
                "de": "hbo",
                "en": "hbo"
            }
        },
        "he": {
            "fullTag": "he",
            "primaryTag": "he",
            "names": {
                "de": "Hebräisch",
                "en": "Hebrew"
            }
        },
        "he-IL": {
            "fullTag": "he-IL",
            "primaryTag": "he",
            "names": {
                "de": "Hebräisch (Israel)",
                "en": "Hebrew (Israel)"
            }
        },
        "hi": {
            "fullTag": "hi",
            "primaryTag": "hi",
            "names": {
                "de": "Hindi",
                "en": "Hindi"
            }
        },
        "hi-IN": {
            "fullTag": "hi-IN",
            "primaryTag": "hi",
            "names": {
                "de": "Hindi (Indien)",
                "en": "Hindi (India)"
            }
        },
        "hr": {
            "fullTag": "hr",
            "primaryTag": "hr",
            "names": {
                "de": "Kroatisch",
                "en": "Croatian"
            }
        },
        "ht": {
            "fullTag": "ht",
            "primaryTag": "ht",
            "names": {
                "de": "Haiti-Kreolisch",
                "en": "Haitian Creole"
            }
        },
        "hu": {
            "fullTag": "hu",
            "primaryTag": "hu",
            "names": {
                "de": "Ungarisch",
                "en": "Hungarian"
            }
        },
        "hu-HU": {
            "fullTag": "hu-HU",
            "primaryTag": "hu",
            "names": {
                "de": "Ungarisch (Ungarn)",
                "en": "Hungarian (Hungary)"
            }
        },
        "hy": {
            "fullTag": "hy",
            "primaryTag": "hy",
            "names": {
                "de": "Armenisch",
                "en": "Armenian"
            }
        },
        "id": {
            "fullTag": "id",
            "primaryTag": "id",
            "names": {
                "de": "Indonesisch",
                "en": "Indonesian"
            }
        },
        "id-ID": {
            "fullTag": "id-ID",
            "primaryTag": "id",
            "names": {
                "de": "Indonesisch (Indonesien)",
                "en": "Indonesian (Indonesia)"
            }
        },
        "ipa": {
            "fullTag": "ipa",
            "primaryTag": "ipa",
            "names": {
                "de": "ipa",
                "en": "ipa"
            }
        },
        "is": {
            "fullTag": "is",
            "primaryTag": "is",
            "names": {
                "de": "Isländisch",
                "en": "Icelandic"
            }
        },
        "is-IS": {
            "fullTag": "is-IS",
            "primaryTag": "is",
            "names": {
                "de": "Isländisch (Island)",
                "en": "Icelandic (Iceland)"
            }
        },
        "it": {
            "fullTag": "it",
            "primaryTag": "it",
            "names": {
                "de": "Italienisch",
                "en": "Italian"
            }
        },
        "it-IT": {
            "fullTag": "it-IT",
            "primaryTag": "it",
            "names": {
                "de": "Italienisch (Italien)",
                "en": "Italian (Italy)"
            }
        },
        "iu": {
            "fullTag": "iu",
            "primaryTag": "iu",
            "names": {
                "de": "Inuktitut",
                "en": "Inuktitut"
            }
        },
        "ja": {
            "fullTag": "ja",
            "primaryTag": "ja",
            "names": {
                "de": "Japanisch",
                "en": "Japanese"
            }
        },
        "ja-JP": {
            "fullTag": "ja-JP",
            "primaryTag": "ja",
            "names": {
                "de": "Japanisch (Japan)",
                "en": "Japanese (Japan)"
            }
        },
        "ka": {
            "fullTag": "ka",
            "primaryTag": "ka",
            "names": {
                "de": "Georgisch",
                "en": "Georgian"
            }
        },
        "kh": {
            "fullTag": "kh",
            "primaryTag": "kh",
            "names": {
                "de": "kh",
                "en": "kh"
            }
        },
        "kha": {
            "fullTag": "kha",
            "primaryTag": "kha",
            "names": {
                "de": "Khasi",
                "en": "Khasi"
            }
        },
        "kk": {
            "fullTag": "kk",
            "primaryTag": "kk",
            "names": {
                "de": "Kasachisch",
                "en": "Kazakh"
            }
        },
        "km": {
            "fullTag": "km",
            "primaryTag": "km",
            "names": {
                "de": "Khmer",
                "en": "Khmer"
            }
        },
        "kmr": {
            "fullTag": "kmr",
            "primaryTag": "kmr",
            "names": {
                "de": "kmr",
                "en": "kmr"
            }
        },
        "kn": {
            "fullTag": "kn",
            "primaryTag": "kn",
            "names": {
                "de": "Kannada",
                "en": "Kannada"
            }
        },
        "kn-IN": {
            "fullTag": "kn-IN",
            "primaryTag": "kn",
            "names": {
                "de": "Kannada (Indien)",
                "en": "Kannada (India)"
            }
        },
        "ko": {
            "fullTag": "ko",
            "primaryTag": "ko",
            "names": {
                "de": "Koreanisch",
                "en": "Korean"
            }
        },
        "ko-KR": {
            "fullTag": "ko-KR",
            "primaryTag": "ko",
            "names": {
                "de": "Koreanisch (Republik Korea)",
                "en": "Korean (Korea, Republic of)"
            }
        },
        "kok": {
            "fullTag": "kok",
            "primaryTag": "kok",
            "names": {
                "de": "Konkani",
                "en": "Konkani"
            }
        },
        "kru": {
            "fullTag": "kru",
            "primaryTag": "kru",
            "names": {
                "de": "Oraon",
                "en": "Kurukh"
            }
        },
        "ks": {
            "fullTag": "ks",
            "primaryTag": "ks",
            "names": {
                "de": "Kaschmiri",
                "en": "Kashmiri"
            }
        },
        "lg": {
            "fullTag": "lg",
            "primaryTag": "lg",
            "names": {
                "de": "Ganda",
                "en": "Ganda"
            }
        },
        "lo": {
            "fullTag": "lo",
            "primaryTag": "lo",
            "names": {
                "de": "Laotisch",
                "en": "Lao"
            }
        },
        "lt": {
            "fullTag": "lt",
            "primaryTag": "lt",
            "names": {
                "de": "Litauisch",
                "en": "Lithuanian"
            }
        },
        "lt-LT": {
            "fullTag": "lt-LT",
            "primaryTag": "lt",
            "names": {
                "de": "Litauisch (Litauen)",
                "en": "Lithuanian (Lithuania)"
            }
        },
        "lv": {
            "fullTag": "lv",
            "primaryTag": "lv",
            "names": {
                "de": "Lettisch",
                "en": "Latvian"
            }
        },
        "lv-LV": {
            "fullTag": "lv-LV",
            "primaryTag": "lv",
            "names": {
                "de": "Lettisch (Lettland)",
                "en": "Latvian (Latvia)"
            }
        },
        "mi": {
            "fullTag": "mi",
            "primaryTag": "mi",
            "names": {
                "de": "Maori",
                "en": "Maori"
            }
        },
        "mk": {
            "fullTag": "mk",
            "primaryTag": "mk",
            "names": {
                "de": "Makedonisch",
                "en": "Macedonian"
            }
        },
        "ml": {
            "fullTag": "ml",
            "primaryTag": "ml",
            "names": {
                "de": "Malayalam",
                "en": "Malayalam"
            }
        },
        "ml-IN": {
            "fullTag": "ml-IN",
            "primaryTag": "ml",
            "names": {
                "de": "Malayalam (Indien)",
                "en": "Malayalam (India)"
            }
        },
        "mn": {
            "fullTag": "mn",
            "primaryTag": "mn",
            "names": {
                "de": "Mongoloisch",
                "en": "Mongolian"
            }
        },
        "mni": {
            "fullTag": "mni",
            "primaryTag": "mni",
            "names": {
                "de": "Meithei",
                "en": "Manipuri"
            }
        },
        "mr": {
            "fullTag": "mr",
            "primaryTag": "mr",
            "names": {
                "de": "Marathi",
                "en": "Marathi"
            }
        },
        "mr-IN": {
            "fullTag": "mr-IN",
            "primaryTag": "mr",
            "names": {
                "de": "Marathi (Indien)",
                "en": "Marathi (India)"
            }
        },
        "ms": {
            "fullTag": "ms",
            "primaryTag": "ms",
            "names": {
                "de": "Malaiisch",
                "en": "Malay"
            }
        },
        "ms-MY": {
            "fullTag": "ms-MY",
            "primaryTag": "ms",
            "names": {
                "de": "Malaiisch (Malaysia)",
                "en": "Malay (Malaysia)"
            }
        },
        "mt": {
            "fullTag": "mt",
            "primaryTag": "mt",
            "names": {
                "de": "Maltesisch",
                "en": "Maltese"
            }
        },
        "mul-IL": {
            "fullTag": "mul-IL",
            "primaryTag": "mul",
            "names": {
                "de": "Mehrsprachig (Israel)",
                "en": "Multiple languages (Israel)"
            }
        },
        "mun": {
            "fullTag": "mun",
            "primaryTag": "mun",
            "names": {
                "de": "Munda",
                "en": "Munda"
            }
        },
        "mwr": {
            "fullTag": "mwr",
            "primaryTag": "mwr",
            "names": {
                "de": "Marwari",
                "en": "Marwari"
            }
        },
        "my": {
            "fullTag": "my",
            "primaryTag": "my",
            "names": {
                "de": "Birmanisch",
                "en": "Burmese"
            }
        },
        "nb": {
            "fullTag": "nb",
            "primaryTag": "nb",
            "names": {
                "de": "Norwegisch (Bokmål)",
                "en": "Norwegian (Bokmal)"
            }
        },
        "nb-NO": {
            "fullTag": "nb-NO",
            "primaryTag": "nb",
            "names": {
                "de": "Norwegisch (Bokmål) (Norwegen)",
                "en": "Norwegian (Bokmal) (Norway)"
            }
        },
        "ne": {
            "fullTag": "ne",
            "primaryTag": "ne",
            "names": {
                "de": "Nepalesisch",
                "en": "Nepali"
            }
        },
        "nl": {
            "fullTag": "nl",
            "primaryTag": "nl",
            "names": {
                "de": "Niederländisch",
                "en": "Dutch"
            }
        },
        "nl-BE": {
            "fullTag": "nl-BE",
            "primaryTag": "nl",
            "names": {
                "de": "Niederländisch (Belgien)",
                "en": "Dutch (Belgium)"
            }
        },
        "nl-NL": {
            "fullTag": "nl-NL",
            "primaryTag": "nl",
            "names": {
                "de": "Niederländisch (Niederlande)",
                "en": "Dutch (Netherlands)"
            }
        },
        "nn": {
            "fullTag": "nn",
            "primaryTag": "nn",
            "names": {
                "de": "Norwegisch (Nynorsk)",
                "en": "Norwegian (Nynorsk)"
            }
        },
        "np": {
            "fullTag": "np",
            "primaryTag": "np",
            "names": {
                "de": "np",
                "en": "np"
            }
        },
        "nso": {
            "fullTag": "nso",
            "primaryTag": "nso",
            "names": {
                "de": "Nord-Sotho",
                "en": "Northern Sotho"
            }
        },
        "ny": {
            "fullTag": "ny",
            "primaryTag": "ny",
            "names": {
                "de": "Nyanja",
                "en": "Nyanja"
            }
        },
        "or": {
            "fullTag": "or",
            "primaryTag": "or",
            "names": {
                "de": "Oriya",
                "en": "Odia"
            }
        },
        "pa": {
            "fullTag": "pa",
            "primaryTag": "pa",
            "names": {
                "de": "Punjabi",
                "en": "Punjabi"
            }
        },
        "pa-IN": {
            "fullTag": "pa-IN",
            "primaryTag": "pa",
            "names": {
                "de": "Punjabi (Indien)",
                "en": "Punjabi (India)"
            }
        },
        "pi": {
            "fullTag": "pi",
            "primaryTag": "pi",
            "names": {
                "de": "Pali",
                "en": "Pali"
            }
        },
        "pl": {
            "fullTag": "pl",
            "primaryTag": "pl",
            "names": {
                "de": "Polnisch",
                "en": "Polish"
            }
        },
        "pl-PL": {
            "fullTag": "pl-PL",
            "primaryTag": "pl",
            "names": {
                "de": "Polnisch (Polen)",
                "en": "Polish (Poland)"
            }
        },
        "ps": {
            "fullTag": "ps",
            "primaryTag": "ps",
            "names": {
                "de": "Pashtu",
                "en": "Pashto"
            }
        },
        "pt": {
            "fullTag": "pt",
            "primaryTag": "pt",
            "names": {
                "de": "Portugiesisch",
                "en": "Portuguese"
            }
        },
        "pt-BR": {
            "fullTag": "pt-BR",
            "primaryTag": "pt",
            "names": {
                "de": "Portugiesisch (Brasilien)",
                "en": "Portuguese (Brazil)"
            }
        },
        "pt-PT": {
            "fullTag": "pt-PT",
            "primaryTag": "pt",
            "names": {
                "de": "Portugiesisch (Portugal)",
                "en": "Portuguese (Portugal)"
            }
        },
        "pu": {
            "fullTag": "pu",
            "primaryTag": "pu",
            "names": {
                "de": "pu",
                "en": "pu"
            }
        },
        "ro": {
            "fullTag": "ro",
            "primaryTag": "ro",
            "names": {
                "de": "Rumänisch",
                "en": "Romanian"
            }
        },
        "ro-RO": {
            "fullTag": "ro-RO",
            "primaryTag": "ro",
            "names": {
                "de": "Rumänisch (Rumänien)",
                "en": "Romanian (Romania)"
            }
        },
        "ru": {
            "fullTag": "ru",
            "primaryTag": "ru",
            "names": {
                "de": "Russisch",
                "en": "Russian"
            }
        },
        "ru-RU": {
            "fullTag": "ru-RU",
            "primaryTag": "ru",
            "names": {
                "de": "Russisch (Russland)",
                "en": "Russian (Russia)"
            }
        },
        "rw": {
            "fullTag": "rw",
            "primaryTag": "rw",
            "names": {
                "de": "Kinyarwanda",
                "en": "Kinyarwanda"
            }
        },
        "sa": {
            "fullTag": "sa",
            "primaryTag": "sa",
            "names": {
                "de": "Sanskrit",
                "en": "Sanskrit"
            }
        },
        "sah": {
            "fullTag": "sah",
            "primaryTag": "sah",
            "names": {
                "de": "Jakutisch",
                "en": "Yakut"
            }
        },
        "sd": {
            "fullTag": "sd",
            "primaryTag": "sd",
            "names": {
                "de": "Sindhi",
                "en": "Sindhi"
            }
        },
        "se": {
            "fullTag": "se",
            "primaryTag": "se",
            "names": {
                "de": "Samisch",
                "en": "Sami"
            }
        },
        "si": {
            "fullTag": "si",
            "primaryTag": "si",
            "names": {
                "de": "Singhalesisch",
                "en": "Sinhala"
            }
        },
        "sin": {
            "fullTag": "sin",
            "primaryTag": "sin",
            "names": {
                "de": "Singhalesisch",
                "en": "Sinhala"
            }
        },
        "sk": {
            "fullTag": "sk",
            "primaryTag": "sk",
            "names": {
                "de": "Slowakisch",
                "en": "Slovak"
            }
        },
        "sk-SK": {
            "fullTag": "sk-SK",
            "primaryTag": "sk",
            "names": {
                "de": "Slowakisch (Slowakei)",
                "en": "Slovak (Slovakia)"
            }
        },
        "sl": {
            "fullTag": "sl",
            "primaryTag": "sl",
            "names": {
                "de": "Slovenisch",
                "en": "Slovenian"
            }
        },
        "so": {
            "fullTag": "so",
            "primaryTag": "so",
            "names": {
                "de": "Somali",
                "en": "Somali"
            }
        },
        "sq": {
            "fullTag": "sq",
            "primaryTag": "sq",
            "names": {
                "de": "Albanian",
                "en": "Albanian"
            }
        },
        "sr": {
            "fullTag": "sr",
            "primaryTag": "sr",
            "names": {
                "de": "Serbisch",
                "en": "Serbian"
            }
        },
        "sr-RS": {
            "fullTag": "sr-RS",
            "primaryTag": "sr",
            "names": {
                "de": "Serbisch (Serbien)",
                "en": "Serbian (Serbia)"
            }
        },
        "st": {
            "fullTag": "st",
            "primaryTag": "st",
            "names": {
                "de": "Süd-Sotho",
                "en": "Southern Sotho"
            }
        },
        "sv": {
            "fullTag": "sv",
            "primaryTag": "sv",
            "names": {
                "de": "Schwedisch",
                "en": "Swedish"
            }
        },
        "sv-SE": {
            "fullTag": "sv-SE",
            "primaryTag": "sv",
            "names": {
                "de": "Schwedisch (Schweden)",
                "en": "Swedish (Sweden)"
            }
        },
        "sw": {
            "fullTag": "sw",
            "primaryTag": "sw",
            "names": {
                "de": "Swahili",
                "en": "Swahili"
            }
        },
        "sw-KE": {
            "fullTag": "sw-KE",
            "primaryTag": "sw",
            "names": {
                "de": "Swahili (Kenia)",
                "en": "Swahili (Kenya)"
            }
        },
        "syr": {
            "fullTag": "syr",
            "primaryTag": "syr",
            "names": {
                "de": "Syrisch",
                "en": "Syriac"
            }
        },
        "ta": {
            "fullTag": "ta",
            "primaryTag": "ta",
            "names": {
                "de": "Tamilisch",
                "en": "Tamil"
            }
        },
        "ta-IN": {
            "fullTag": "ta-IN",
            "primaryTag": "ta",
            "names": {
                "de": "Tamilisch (Indien)",
                "en": "Tamil (India)"
            }
        },
        "te": {
            "fullTag": "te",
            "primaryTag": "te",
            "names": {
                "de": "Telugu",
                "en": "Telugu"
            }
        },
        "te-IN": {
            "fullTag": "te-IN",
            "primaryTag": "te",
            "names": {
                "de": "Telugu (Indien)",
                "en": "Telugu (India)"
            }
        },
        "th": {
            "fullTag": "th",
            "primaryTag": "th",
            "names": {
                "de": "Thailändisch",
                "en": "Thai"
            }
        },
        "th-TH": {
            "fullTag": "th-TH",
            "primaryTag": "th",
            "names": {
                "de": "Thailändisch (Thailand)",
                "en": "Thai (Thailand)"
            }
        },
        "tl": {
            "fullTag": "tl",
            "primaryTag": "tl",
            "names": {
                "de": "Tagalog",
                "en": "Tagalog"
            }
        },
        "tlg": {
            "fullTag": "tlg",
            "primaryTag": "tlg",
            "names": {
                "de": "tlg",
                "en": "tlg"
            }
        },
        "tn": {
            "fullTag": "tn",
            "primaryTag": "tn",
            "names": {
                "de": "Tswana",
                "en": "Tswana"
            }
        },
        "tr": {
            "fullTag": "tr",
            "primaryTag": "tr",
            "names": {
                "de": "Türkisch",
                "en": "Turkish"
            }
        },
        "tr-TR": {
            "fullTag": "tr-TR",
            "primaryTag": "tr",
            "names": {
                "de": "Türkisch (Türkei)",
                "en": "Turkish (Turkey)"
            }
        },
        "tt": {
            "fullTag": "tt",
            "primaryTag": "tt",
            "names": {
                "de": "Tatarisch",
                "en": "Tatar"
            }
        },
        "uga": {
            "fullTag": "uga",
            "primaryTag": "uga",
            "names": {
                "de": "Ugaritisch",
                "en": "Ugaritic"
            }
        },
        "uk": {
            "fullTag": "uk",
            "primaryTag": "uk",
            "names": {
                "de": "Ukrainisch",
                "en": "Ukrainian"
            }
        },
        "uk-UA": {
            "fullTag": "uk-UA",
            "primaryTag": "uk",
            "names": {
                "de": "Ukrainisch (Ukraine)",
                "en": "Ukrainian (Ukraine)"
            }
        },
        "uni": {
            "fullTag": "uni",
            "primaryTag": "uni",
            "names": {
                "de": "uni",
                "en": "uni"
            }
        },
        "ur": {
            "fullTag": "ur",
            "primaryTag": "ur",
            "names": {
                "de": "Urdu",
                "en": "Urdu"
            }
        },
        "ur-IN": {
            "fullTag": "ur-IN",
            "primaryTag": "ur",
            "names": {
                "de": "Urdu (Indien)",
                "en": "Urdu (India)"
            }
        },
        "us": {
            "fullTag": "us",
            "primaryTag": "us",
            "names": {
                "de": "us",
                "en": "us"
            }
        },
        "uz": {
            "fullTag": "uz",
            "primaryTag": "uz",
            "names": {
                "de": "Usbekisch",
                "en": "Uzbek"
            }
        },
        "ve": {
            "fullTag": "ve",
            "primaryTag": "ve",
            "names": {
                "de": "Venda",
                "en": "Venda"
            }
        },
        "vi": {
            "fullTag": "vi",
            "primaryTag": "vi",
            "names": {
                "de": "Vietnamesisch",
                "en": "Vietnamese"
            }
        },
        "vi-VN": {
            "fullTag": "vi-VN",
            "primaryTag": "vi",
            "names": {
                "de": "Vietnamesisch (Vietnam)",
                "en": "Vietnamese (Viet Nam)"
            }
        },
        "xh": {
            "fullTag": "xh",
            "primaryTag": "xh",
            "names": {
                "de": "Xhosa",
                "en": "Xhosa"
            }
        },
        "xlu": {
            "fullTag": "xlu",
            "primaryTag": "xlu",
            "names": {
                "de": "xlu",
                "en": "xlu"
            }
        },
        "yi": {
            "fullTag": "yi",
            "primaryTag": "yi",
            "names": {
                "de": "Jiddisch",
                "en": "Yiddish"
            }
        },
        "yue": {
            "fullTag": "yue",
            "primaryTag": "yue",
            "names": {
                "de": "Kantonesisch",
                "en": "Cantonese"
            }
        },
        "yue-HK": {
            "fullTag": "yue-HK",
            "primaryTag": "yue",
            "names": {
                "de": "Kantonesisch (Hongkong)",
                "en": "Cantonese (Hong Kong)"
            }
        },
        "zh": {
            "fullTag": "zh",
            "primaryTag": "zh",
            "names": {
                "de": "Chinesisch",
                "en": "Chinese"
            }
        },
        "zh-TW": {
            "fullTag": "zh-TW",
            "primaryTag": "zh",
            "names": {
                "de": "Chinesisch (Taiwan)",
                "en": "Chinese (Taiwan)"
            }
        },
        "zu": {
            "fullTag": "zu",
            "primaryTag": "zu",
            "names": {
                "de": "Zulu",
                "en": "Zulu"
            }
        }
    },
    "services": {
        "Google Cloud Text-to-Speech": {
            "canonicalName": "Google Cloud Text-to-Speech",
            "shortEngineName": "google",
            "names": [
                "Google Cloud Text-to-Speech",
                "google",
                "GOOGLE"
            ],
            "voices": {
                "Achernar": {
                    "name": "Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Achird": {
                    "name": "Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Algenib": {
                    "name": "Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Algieba": {
                    "name": "Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Alnilam": {
                    "name": "Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Aoede": {
                    "name": "Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Autonoe": {
                    "name": "Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Callirrhoe": {
                    "name": "Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Charon": {
                    "name": "Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Despina": {
                    "name": "Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Enceladus": {
                    "name": "Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Erinome": {
                    "name": "Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Fenrir": {
                    "name": "Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Gacrux": {
                    "name": "Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Iapetus": {
                    "name": "Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Kore": {
                    "name": "Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Laomedeia": {
                    "name": "Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Leda": {
                    "name": "Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Orus": {
                    "name": "Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Puck": {
                    "name": "Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Pulcherrima": {
                    "name": "Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Rasalgethi": {
                    "name": "Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Sadachbia": {
                    "name": "Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Sadaltager": {
                    "name": "Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Schedar": {
                    "name": "Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Sulafat": {
                    "name": "Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Umbriel": {
                    "name": "Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Vindemiatrix": {
                    "name": "Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Zephyr": {
                    "name": "Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "Zubenelgenubi": {
                    "name": "Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "af-ZA-Standard-A": {
                    "name": "af-ZA-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "af",
                        "af-ZA"
                    ],
                    "replaced": false
                },
                "am-ET-Standard-A": {
                    "name": "am-ET-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "am",
                        "am-ET"
                    ],
                    "replaced": false
                },
                "am-ET-Standard-B": {
                    "name": "am-ET-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "am",
                        "am-ET"
                    ],
                    "replaced": false
                },
                "am-ET-Wavenet-A": {
                    "name": "am-ET-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "am",
                        "am-ET"
                    ],
                    "replaced": false
                },
                "am-ET-Wavenet-B": {
                    "name": "am-ET-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "am",
                        "am-ET"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Achernar": {
                    "name": "ar-XA-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Achird": {
                    "name": "ar-XA-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Algenib": {
                    "name": "ar-XA-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Algieba": {
                    "name": "ar-XA-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Alnilam": {
                    "name": "ar-XA-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Aoede": {
                    "name": "ar-XA-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Autonoe": {
                    "name": "ar-XA-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Callirrhoe": {
                    "name": "ar-XA-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Charon": {
                    "name": "ar-XA-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Despina": {
                    "name": "ar-XA-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Enceladus": {
                    "name": "ar-XA-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Erinome": {
                    "name": "ar-XA-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Fenrir": {
                    "name": "ar-XA-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Gacrux": {
                    "name": "ar-XA-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Iapetus": {
                    "name": "ar-XA-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Kore": {
                    "name": "ar-XA-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Laomedeia": {
                    "name": "ar-XA-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Leda": {
                    "name": "ar-XA-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Orus": {
                    "name": "ar-XA-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Puck": {
                    "name": "ar-XA-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Pulcherrima": {
                    "name": "ar-XA-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Rasalgethi": {
                    "name": "ar-XA-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Sadachbia": {
                    "name": "ar-XA-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Sadaltager": {
                    "name": "ar-XA-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Schedar": {
                    "name": "ar-XA-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Sulafat": {
                    "name": "ar-XA-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Umbriel": {
                    "name": "ar-XA-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Vindemiatrix": {
                    "name": "ar-XA-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Zephyr": {
                    "name": "ar-XA-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Chirp3-HD-Zubenelgenubi": {
                    "name": "ar-XA-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Standard-A": {
                    "name": "ar-XA-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Standard-B": {
                    "name": "ar-XA-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Standard-C": {
                    "name": "ar-XA-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Standard-D": {
                    "name": "ar-XA-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Wavenet-A": {
                    "name": "ar-XA-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Wavenet-B": {
                    "name": "ar-XA-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Wavenet-C": {
                    "name": "ar-XA-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "ar-XA-Wavenet-D": {
                    "name": "ar-XA-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ar",
                        "ar-XA"
                    ],
                    "replaced": false
                },
                "bg-BG-Standard-B": {
                    "name": "bg-BG-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "bg",
                        "bg-BG"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Achernar": {
                    "name": "bn-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Achird": {
                    "name": "bn-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Algenib": {
                    "name": "bn-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Algieba": {
                    "name": "bn-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Alnilam": {
                    "name": "bn-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Aoede": {
                    "name": "bn-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Autonoe": {
                    "name": "bn-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Callirrhoe": {
                    "name": "bn-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Charon": {
                    "name": "bn-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Despina": {
                    "name": "bn-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Enceladus": {
                    "name": "bn-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Erinome": {
                    "name": "bn-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Fenrir": {
                    "name": "bn-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Gacrux": {
                    "name": "bn-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Iapetus": {
                    "name": "bn-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Kore": {
                    "name": "bn-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Laomedeia": {
                    "name": "bn-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Leda": {
                    "name": "bn-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Orus": {
                    "name": "bn-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Puck": {
                    "name": "bn-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Pulcherrima": {
                    "name": "bn-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Rasalgethi": {
                    "name": "bn-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Sadachbia": {
                    "name": "bn-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Sadaltager": {
                    "name": "bn-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Schedar": {
                    "name": "bn-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Sulafat": {
                    "name": "bn-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Umbriel": {
                    "name": "bn-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "bn-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Zephyr": {
                    "name": "bn-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "bn-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Standard-A": {
                    "name": "bn-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Standard-B": {
                    "name": "bn-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Standard-C": {
                    "name": "bn-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Standard-D": {
                    "name": "bn-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Wavenet-A": {
                    "name": "bn-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Wavenet-B": {
                    "name": "bn-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Wavenet-C": {
                    "name": "bn-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "bn-IN-Wavenet-D": {
                    "name": "bn-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "bn",
                        "bn-IN"
                    ],
                    "replaced": false
                },
                "ca-ES-Standard-B": {
                    "name": "ca-ES-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ca",
                        "ca-ES"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Achernar": {
                    "name": "cmn-CN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Achird": {
                    "name": "cmn-CN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Algenib": {
                    "name": "cmn-CN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Algieba": {
                    "name": "cmn-CN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Alnilam": {
                    "name": "cmn-CN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Aoede": {
                    "name": "cmn-CN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Autonoe": {
                    "name": "cmn-CN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Callirrhoe": {
                    "name": "cmn-CN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Charon": {
                    "name": "cmn-CN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Despina": {
                    "name": "cmn-CN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Enceladus": {
                    "name": "cmn-CN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Erinome": {
                    "name": "cmn-CN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Fenrir": {
                    "name": "cmn-CN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Gacrux": {
                    "name": "cmn-CN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Iapetus": {
                    "name": "cmn-CN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Kore": {
                    "name": "cmn-CN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Laomedeia": {
                    "name": "cmn-CN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Leda": {
                    "name": "cmn-CN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Orus": {
                    "name": "cmn-CN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Puck": {
                    "name": "cmn-CN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Pulcherrima": {
                    "name": "cmn-CN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Rasalgethi": {
                    "name": "cmn-CN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Sadachbia": {
                    "name": "cmn-CN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Sadaltager": {
                    "name": "cmn-CN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Schedar": {
                    "name": "cmn-CN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Sulafat": {
                    "name": "cmn-CN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Umbriel": {
                    "name": "cmn-CN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Vindemiatrix": {
                    "name": "cmn-CN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Zephyr": {
                    "name": "cmn-CN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Chirp3-HD-Zubenelgenubi": {
                    "name": "cmn-CN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Standard-A": {
                    "name": "cmn-CN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Standard-B": {
                    "name": "cmn-CN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Standard-C": {
                    "name": "cmn-CN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Standard-D": {
                    "name": "cmn-CN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Wavenet-A": {
                    "name": "cmn-CN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Wavenet-B": {
                    "name": "cmn-CN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Wavenet-C": {
                    "name": "cmn-CN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-CN-Wavenet-D": {
                    "name": "cmn-CN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-CN"
                    ],
                    "replaced": false
                },
                "cmn-TW-Standard-A": {
                    "name": "cmn-TW-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cmn-TW-Standard-B": {
                    "name": "cmn-TW-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cmn-TW-Standard-C": {
                    "name": "cmn-TW-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cmn-TW-Wavenet-A": {
                    "name": "cmn-TW-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cmn-TW-Wavenet-B": {
                    "name": "cmn-TW-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cmn-TW-Wavenet-C": {
                    "name": "cmn-TW-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "cmn",
                        "cmn-TW"
                    ],
                    "replaced": false
                },
                "cs-CZ-Standard-B": {
                    "name": "cs-CZ-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "cs",
                        "cs-CZ"
                    ],
                    "replaced": false
                },
                "cs-CZ-Wavenet-B": {
                    "name": "cs-CZ-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "cs",
                        "cs-CZ"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Achernar": {
                    "name": "da-DK-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Achird": {
                    "name": "da-DK-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Algenib": {
                    "name": "da-DK-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Algieba": {
                    "name": "da-DK-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Alnilam": {
                    "name": "da-DK-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Aoede": {
                    "name": "da-DK-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Autonoe": {
                    "name": "da-DK-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Callirrhoe": {
                    "name": "da-DK-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Charon": {
                    "name": "da-DK-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Despina": {
                    "name": "da-DK-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Enceladus": {
                    "name": "da-DK-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Erinome": {
                    "name": "da-DK-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Fenrir": {
                    "name": "da-DK-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Gacrux": {
                    "name": "da-DK-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Iapetus": {
                    "name": "da-DK-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Kore": {
                    "name": "da-DK-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Laomedeia": {
                    "name": "da-DK-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Leda": {
                    "name": "da-DK-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Orus": {
                    "name": "da-DK-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Puck": {
                    "name": "da-DK-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Pulcherrima": {
                    "name": "da-DK-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Rasalgethi": {
                    "name": "da-DK-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Sadachbia": {
                    "name": "da-DK-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Sadaltager": {
                    "name": "da-DK-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Schedar": {
                    "name": "da-DK-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Sulafat": {
                    "name": "da-DK-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Umbriel": {
                    "name": "da-DK-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Vindemiatrix": {
                    "name": "da-DK-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Zephyr": {
                    "name": "da-DK-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Chirp3-HD-Zubenelgenubi": {
                    "name": "da-DK-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Neural2-F": {
                    "name": "da-DK-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Standard-F": {
                    "name": "da-DK-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Standard-G": {
                    "name": "da-DK-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Wavenet-F": {
                    "name": "da-DK-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "da-DK-Wavenet-G": {
                    "name": "da-DK-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "da",
                        "da-DK"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp-HD-D": {
                    "name": "de-DE-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp-HD-F": {
                    "name": "de-DE-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp-HD-O": {
                    "name": "de-DE-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Achernar": {
                    "name": "de-DE-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Achird": {
                    "name": "de-DE-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Algenib": {
                    "name": "de-DE-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Algieba": {
                    "name": "de-DE-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Alnilam": {
                    "name": "de-DE-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Aoede": {
                    "name": "de-DE-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Autonoe": {
                    "name": "de-DE-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Callirrhoe": {
                    "name": "de-DE-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Charon": {
                    "name": "de-DE-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Despina": {
                    "name": "de-DE-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Enceladus": {
                    "name": "de-DE-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Erinome": {
                    "name": "de-DE-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Fenrir": {
                    "name": "de-DE-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Gacrux": {
                    "name": "de-DE-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Iapetus": {
                    "name": "de-DE-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Kore": {
                    "name": "de-DE-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Laomedeia": {
                    "name": "de-DE-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Leda": {
                    "name": "de-DE-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Orus": {
                    "name": "de-DE-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Puck": {
                    "name": "de-DE-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Pulcherrima": {
                    "name": "de-DE-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Rasalgethi": {
                    "name": "de-DE-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Sadachbia": {
                    "name": "de-DE-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Sadaltager": {
                    "name": "de-DE-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Schedar": {
                    "name": "de-DE-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Sulafat": {
                    "name": "de-DE-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Umbriel": {
                    "name": "de-DE-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Vindemiatrix": {
                    "name": "de-DE-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Zephyr": {
                    "name": "de-DE-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Chirp3-HD-Zubenelgenubi": {
                    "name": "de-DE-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Neural2-G": {
                    "name": "de-DE-Neural2-G",
                    "costMultiplier": 4,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Neural2-H": {
                    "name": "de-DE-Neural2-H",
                    "costMultiplier": 4,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Polyglot-1": {
                    "name": "de-DE-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Standard-G": {
                    "name": "de-DE-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Standard-H": {
                    "name": "de-DE-Standard-H",
                    "costMultiplier": 1,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Studio-B": {
                    "name": "de-DE-Studio-B",
                    "costMultiplier": 40,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "de-DE-Studio-C": {
                    "name": "de-DE-Studio-C",
                    "costMultiplier": 40,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "de-DE-Wavenet-G": {
                    "name": "de-DE-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "de-DE-Wavenet-H": {
                    "name": "de-DE-Wavenet-H",
                    "costMultiplier": 4,
                    "languages": [
                        "de",
                        "de-DE"
                    ],
                    "replaced": false
                },
                "el-GR-Standard-B": {
                    "name": "el-GR-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "el",
                        "el-GR"
                    ],
                    "replaced": false
                },
                "el-GR-Wavenet-B": {
                    "name": "el-GR-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "el",
                        "el-GR"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp-HD-D": {
                    "name": "en-AU-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp-HD-F": {
                    "name": "en-AU-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp-HD-O": {
                    "name": "en-AU-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Achernar": {
                    "name": "en-AU-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Achird": {
                    "name": "en-AU-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Algenib": {
                    "name": "en-AU-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Algieba": {
                    "name": "en-AU-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Alnilam": {
                    "name": "en-AU-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Aoede": {
                    "name": "en-AU-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Autonoe": {
                    "name": "en-AU-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Callirrhoe": {
                    "name": "en-AU-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Charon": {
                    "name": "en-AU-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Despina": {
                    "name": "en-AU-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Enceladus": {
                    "name": "en-AU-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Erinome": {
                    "name": "en-AU-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Fenrir": {
                    "name": "en-AU-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Gacrux": {
                    "name": "en-AU-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Iapetus": {
                    "name": "en-AU-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Kore": {
                    "name": "en-AU-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Laomedeia": {
                    "name": "en-AU-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Leda": {
                    "name": "en-AU-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Orus": {
                    "name": "en-AU-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Puck": {
                    "name": "en-AU-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Pulcherrima": {
                    "name": "en-AU-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Rasalgethi": {
                    "name": "en-AU-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Sadachbia": {
                    "name": "en-AU-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Sadaltager": {
                    "name": "en-AU-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Schedar": {
                    "name": "en-AU-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Sulafat": {
                    "name": "en-AU-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Umbriel": {
                    "name": "en-AU-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Vindemiatrix": {
                    "name": "en-AU-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Zephyr": {
                    "name": "en-AU-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Chirp3-HD-Zubenelgenubi": {
                    "name": "en-AU-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Neural2-A": {
                    "name": "en-AU-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Neural2-B": {
                    "name": "en-AU-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Neural2-C": {
                    "name": "en-AU-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Neural2-D": {
                    "name": "en-AU-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-News-E": {
                    "name": "en-AU-News-E",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-News-F": {
                    "name": "en-AU-News-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-News-G": {
                    "name": "en-AU-News-G",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Polyglot-1": {
                    "name": "en-AU-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Standard-A": {
                    "name": "en-AU-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Standard-B": {
                    "name": "en-AU-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Standard-C": {
                    "name": "en-AU-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Standard-D": {
                    "name": "en-AU-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Wavenet-A": {
                    "name": "en-AU-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Wavenet-B": {
                    "name": "en-AU-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Wavenet-C": {
                    "name": "en-AU-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-AU-Wavenet-D": {
                    "name": "en-AU-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-AU"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp-HD-D": {
                    "name": "en-GB-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp-HD-F": {
                    "name": "en-GB-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp-HD-O": {
                    "name": "en-GB-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Achernar": {
                    "name": "en-GB-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Achird": {
                    "name": "en-GB-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Algenib": {
                    "name": "en-GB-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Algieba": {
                    "name": "en-GB-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Alnilam": {
                    "name": "en-GB-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Aoede": {
                    "name": "en-GB-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Autonoe": {
                    "name": "en-GB-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Callirrhoe": {
                    "name": "en-GB-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Charon": {
                    "name": "en-GB-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Despina": {
                    "name": "en-GB-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Enceladus": {
                    "name": "en-GB-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Erinome": {
                    "name": "en-GB-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Fenrir": {
                    "name": "en-GB-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Gacrux": {
                    "name": "en-GB-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Iapetus": {
                    "name": "en-GB-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Kore": {
                    "name": "en-GB-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Laomedeia": {
                    "name": "en-GB-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Leda": {
                    "name": "en-GB-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Orus": {
                    "name": "en-GB-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Puck": {
                    "name": "en-GB-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Pulcherrima": {
                    "name": "en-GB-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Rasalgethi": {
                    "name": "en-GB-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Sadachbia": {
                    "name": "en-GB-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Sadaltager": {
                    "name": "en-GB-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Schedar": {
                    "name": "en-GB-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Sulafat": {
                    "name": "en-GB-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Umbriel": {
                    "name": "en-GB-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Vindemiatrix": {
                    "name": "en-GB-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Zephyr": {
                    "name": "en-GB-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Chirp3-HD-Zubenelgenubi": {
                    "name": "en-GB-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Neural2-A": {
                    "name": "en-GB-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Neural2-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Neural2-B": {
                    "name": "en-GB-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Neural2-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Neural2-C": {
                    "name": "en-GB-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Neural2-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Neural2-D": {
                    "name": "en-GB-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Neural2-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Neural2-F": {
                    "name": "en-GB-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Neural2-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Neural2-N": {
                    "name": "en-GB-Neural2-N",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Neural2-O": {
                    "name": "en-GB-Neural2-O",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-News-G": {
                    "name": "en-GB-News-G",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-H": {
                    "name": "en-GB-News-H",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-I": {
                    "name": "en-GB-News-I",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-J": {
                    "name": "en-GB-News-J",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-K": {
                    "name": "en-GB-News-K",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-L": {
                    "name": "en-GB-News-L",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-News-M": {
                    "name": "en-GB-News-M",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-Standard-A": {
                    "name": "en-GB-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Standard-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Standard-B": {
                    "name": "en-GB-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Standard-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Standard-C": {
                    "name": "en-GB-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Standard-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Standard-D": {
                    "name": "en-GB-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Standard-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Standard-F": {
                    "name": "en-GB-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Standard-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Standard-N": {
                    "name": "en-GB-Standard-N",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Standard-O": {
                    "name": "en-GB-Standard-O",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Studio-B": {
                    "name": "en-GB-Studio-B",
                    "costMultiplier": 40,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-Studio-C": {
                    "name": "en-GB-Studio-C",
                    "costMultiplier": 40,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "en-GB-Wavenet-A": {
                    "name": "en-GB-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Wavenet-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Wavenet-B": {
                    "name": "en-GB-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Wavenet-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Wavenet-C": {
                    "name": "en-GB-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Wavenet-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Wavenet-D": {
                    "name": "en-GB-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Wavenet-O",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Wavenet-F": {
                    "name": "en-GB-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": true,
                    "replacementVoice": "en-GB-Wavenet-N",
                    "replacementDate": "2025-01-27"
                },
                "en-GB-Wavenet-N": {
                    "name": "en-GB-Wavenet-N",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-GB-Wavenet-O": {
                    "name": "en-GB-Wavenet-O",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-GB"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp-HD-D": {
                    "name": "en-IN-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp-HD-F": {
                    "name": "en-IN-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp-HD-O": {
                    "name": "en-IN-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Achernar": {
                    "name": "en-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Achird": {
                    "name": "en-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Algenib": {
                    "name": "en-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Algieba": {
                    "name": "en-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Alnilam": {
                    "name": "en-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Aoede": {
                    "name": "en-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Autonoe": {
                    "name": "en-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Callirrhoe": {
                    "name": "en-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Charon": {
                    "name": "en-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Despina": {
                    "name": "en-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Enceladus": {
                    "name": "en-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Erinome": {
                    "name": "en-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Fenrir": {
                    "name": "en-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Gacrux": {
                    "name": "en-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Iapetus": {
                    "name": "en-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Kore": {
                    "name": "en-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Laomedeia": {
                    "name": "en-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Leda": {
                    "name": "en-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Orus": {
                    "name": "en-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Puck": {
                    "name": "en-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Pulcherrima": {
                    "name": "en-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Rasalgethi": {
                    "name": "en-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Sadachbia": {
                    "name": "en-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Sadaltager": {
                    "name": "en-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Schedar": {
                    "name": "en-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Sulafat": {
                    "name": "en-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Umbriel": {
                    "name": "en-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "en-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Zephyr": {
                    "name": "en-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "en-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Neural2-A": {
                    "name": "en-IN-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Neural2-B": {
                    "name": "en-IN-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Neural2-C": {
                    "name": "en-IN-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Neural2-D": {
                    "name": "en-IN-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-A": {
                    "name": "en-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-B": {
                    "name": "en-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-C": {
                    "name": "en-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-D": {
                    "name": "en-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-E": {
                    "name": "en-IN-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Standard-F": {
                    "name": "en-IN-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-A": {
                    "name": "en-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-B": {
                    "name": "en-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-C": {
                    "name": "en-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-D": {
                    "name": "en-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-E": {
                    "name": "en-IN-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-IN-Wavenet-F": {
                    "name": "en-IN-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-IN"
                    ],
                    "replaced": false
                },
                "en-US-Casual-K": {
                    "name": "en-US-Casual-K",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp-HD-D": {
                    "name": "en-US-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp-HD-F": {
                    "name": "en-US-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp-HD-O": {
                    "name": "en-US-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Achernar": {
                    "name": "en-US-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Achird": {
                    "name": "en-US-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Algenib": {
                    "name": "en-US-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Algieba": {
                    "name": "en-US-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Alnilam": {
                    "name": "en-US-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Aoede": {
                    "name": "en-US-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Autonoe": {
                    "name": "en-US-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Callirrhoe": {
                    "name": "en-US-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Charon": {
                    "name": "en-US-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Despina": {
                    "name": "en-US-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Enceladus": {
                    "name": "en-US-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Erinome": {
                    "name": "en-US-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Fenrir": {
                    "name": "en-US-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Gacrux": {
                    "name": "en-US-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Iapetus": {
                    "name": "en-US-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Kore": {
                    "name": "en-US-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Laomedeia": {
                    "name": "en-US-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Leda": {
                    "name": "en-US-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Orus": {
                    "name": "en-US-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Puck": {
                    "name": "en-US-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Pulcherrima": {
                    "name": "en-US-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Rasalgethi": {
                    "name": "en-US-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Sadachbia": {
                    "name": "en-US-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Sadaltager": {
                    "name": "en-US-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Schedar": {
                    "name": "en-US-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Sulafat": {
                    "name": "en-US-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Umbriel": {
                    "name": "en-US-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Vindemiatrix": {
                    "name": "en-US-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Zephyr": {
                    "name": "en-US-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Chirp3-HD-Zubenelgenubi": {
                    "name": "en-US-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-A": {
                    "name": "en-US-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-C": {
                    "name": "en-US-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-D": {
                    "name": "en-US-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-E": {
                    "name": "en-US-Neural2-E",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-F": {
                    "name": "en-US-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-G": {
                    "name": "en-US-Neural2-G",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-H": {
                    "name": "en-US-Neural2-H",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-I": {
                    "name": "en-US-Neural2-I",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Neural2-J": {
                    "name": "en-US-Neural2-J",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-News-K": {
                    "name": "en-US-News-K",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-News-L": {
                    "name": "en-US-News-L",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-News-N": {
                    "name": "en-US-News-N",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Polyglot-1": {
                    "name": "en-US-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-A": {
                    "name": "en-US-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-B": {
                    "name": "en-US-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-C": {
                    "name": "en-US-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-D": {
                    "name": "en-US-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-E": {
                    "name": "en-US-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-F": {
                    "name": "en-US-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-G": {
                    "name": "en-US-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-H": {
                    "name": "en-US-Standard-H",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-I": {
                    "name": "en-US-Standard-I",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Standard-J": {
                    "name": "en-US-Standard-J",
                    "costMultiplier": 1,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Studio-O": {
                    "name": "en-US-Studio-O",
                    "costMultiplier": 40,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Studio-Q": {
                    "name": "en-US-Studio-Q",
                    "costMultiplier": 40,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-A": {
                    "name": "en-US-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-B": {
                    "name": "en-US-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-C": {
                    "name": "en-US-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-D": {
                    "name": "en-US-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-E": {
                    "name": "en-US-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-F": {
                    "name": "en-US-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-G": {
                    "name": "en-US-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-H": {
                    "name": "en-US-Wavenet-H",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-I": {
                    "name": "en-US-Wavenet-I",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "en-US-Wavenet-J": {
                    "name": "en-US-Wavenet-J",
                    "costMultiplier": 4,
                    "languages": [
                        "en",
                        "en-US"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp-HD-D": {
                    "name": "es-ES-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp-HD-F": {
                    "name": "es-ES-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp-HD-O": {
                    "name": "es-ES-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Achernar": {
                    "name": "es-ES-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Achird": {
                    "name": "es-ES-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Algenib": {
                    "name": "es-ES-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Algieba": {
                    "name": "es-ES-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Alnilam": {
                    "name": "es-ES-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Aoede": {
                    "name": "es-ES-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Autonoe": {
                    "name": "es-ES-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Callirrhoe": {
                    "name": "es-ES-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Charon": {
                    "name": "es-ES-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Despina": {
                    "name": "es-ES-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Enceladus": {
                    "name": "es-ES-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Erinome": {
                    "name": "es-ES-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Fenrir": {
                    "name": "es-ES-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Gacrux": {
                    "name": "es-ES-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Iapetus": {
                    "name": "es-ES-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Kore": {
                    "name": "es-ES-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Laomedeia": {
                    "name": "es-ES-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Leda": {
                    "name": "es-ES-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Orus": {
                    "name": "es-ES-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Puck": {
                    "name": "es-ES-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Pulcherrima": {
                    "name": "es-ES-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Rasalgethi": {
                    "name": "es-ES-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Sadachbia": {
                    "name": "es-ES-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Sadaltager": {
                    "name": "es-ES-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Schedar": {
                    "name": "es-ES-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Sulafat": {
                    "name": "es-ES-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Umbriel": {
                    "name": "es-ES-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Vindemiatrix": {
                    "name": "es-ES-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Zephyr": {
                    "name": "es-ES-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Chirp3-HD-Zubenelgenubi": {
                    "name": "es-ES-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Neural2-A": {
                    "name": "es-ES-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": true,
                    "replacementVoice": "es-ES-Neural2-F",
                    "replacementDate": "2025-01-27"
                },
                "es-ES-Neural2-E": {
                    "name": "es-ES-Neural2-E",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": true,
                    "replacementVoice": "es-ES-Neural2-E",
                    "replacementDate": "2025-01-27"
                },
                "es-ES-Neural2-F": {
                    "name": "es-ES-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": true,
                    "replacementVoice": "es-ES-Neural2-F",
                    "replacementDate": "2025-01-27"
                },
                "es-ES-Neural2-G": {
                    "name": "es-ES-Neural2-G",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Neural2-H": {
                    "name": "es-ES-Neural2-H",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Polyglot-1": {
                    "name": "es-ES-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Standard-E": {
                    "name": "es-ES-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Standard-F": {
                    "name": "es-ES-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Standard-G": {
                    "name": "es-ES-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Standard-H": {
                    "name": "es-ES-Standard-H",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Studio-C": {
                    "name": "es-ES-Studio-C",
                    "costMultiplier": 40,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Studio-F": {
                    "name": "es-ES-Studio-F",
                    "costMultiplier": 40,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Wavenet-E": {
                    "name": "es-ES-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Wavenet-F": {
                    "name": "es-ES-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Wavenet-G": {
                    "name": "es-ES-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-ES-Wavenet-H": {
                    "name": "es-ES-Wavenet-H",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-ES"
                    ],
                    "replaced": false
                },
                "es-US-Chirp-HD-D": {
                    "name": "es-US-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp-HD-F": {
                    "name": "es-US-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp-HD-O": {
                    "name": "es-US-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Achernar": {
                    "name": "es-US-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Achird": {
                    "name": "es-US-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Algenib": {
                    "name": "es-US-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Algieba": {
                    "name": "es-US-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Alnilam": {
                    "name": "es-US-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Aoede": {
                    "name": "es-US-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Autonoe": {
                    "name": "es-US-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Callirrhoe": {
                    "name": "es-US-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Charon": {
                    "name": "es-US-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Despina": {
                    "name": "es-US-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Enceladus": {
                    "name": "es-US-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Erinome": {
                    "name": "es-US-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Fenrir": {
                    "name": "es-US-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Gacrux": {
                    "name": "es-US-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Iapetus": {
                    "name": "es-US-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Kore": {
                    "name": "es-US-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Laomedeia": {
                    "name": "es-US-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Leda": {
                    "name": "es-US-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Orus": {
                    "name": "es-US-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Puck": {
                    "name": "es-US-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Pulcherrima": {
                    "name": "es-US-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Rasalgethi": {
                    "name": "es-US-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Sadachbia": {
                    "name": "es-US-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Sadaltager": {
                    "name": "es-US-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Schedar": {
                    "name": "es-US-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Sulafat": {
                    "name": "es-US-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Umbriel": {
                    "name": "es-US-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Vindemiatrix": {
                    "name": "es-US-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Zephyr": {
                    "name": "es-US-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Chirp3-HD-Zubenelgenubi": {
                    "name": "es-US-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Neural2-A": {
                    "name": "es-US-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Neural2-B": {
                    "name": "es-US-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Neural2-C": {
                    "name": "es-US-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-News-D": {
                    "name": "es-US-News-D",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-News-E": {
                    "name": "es-US-News-E",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-News-F": {
                    "name": "es-US-News-F",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-News-G": {
                    "name": "es-US-News-G",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Polyglot-1": {
                    "name": "es-US-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Standard-A": {
                    "name": "es-US-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Standard-B": {
                    "name": "es-US-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Standard-C": {
                    "name": "es-US-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Studio-B": {
                    "name": "es-US-Studio-B",
                    "costMultiplier": 40,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Wavenet-A": {
                    "name": "es-US-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Wavenet-B": {
                    "name": "es-US-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "es-US-Wavenet-C": {
                    "name": "es-US-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "es",
                        "es-US"
                    ],
                    "replaced": false
                },
                "et-EE-Standard-A": {
                    "name": "et-EE-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "et",
                        "et-EE"
                    ],
                    "replaced": false
                },
                "eu-ES-Standard-B": {
                    "name": "eu-ES-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "eu",
                        "eu-ES"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Achernar": {
                    "name": "fi-FI-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Achird": {
                    "name": "fi-FI-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Algenib": {
                    "name": "fi-FI-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Algieba": {
                    "name": "fi-FI-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Alnilam": {
                    "name": "fi-FI-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Aoede": {
                    "name": "fi-FI-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Autonoe": {
                    "name": "fi-FI-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Callirrhoe": {
                    "name": "fi-FI-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Charon": {
                    "name": "fi-FI-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Despina": {
                    "name": "fi-FI-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Enceladus": {
                    "name": "fi-FI-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Erinome": {
                    "name": "fi-FI-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Fenrir": {
                    "name": "fi-FI-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Gacrux": {
                    "name": "fi-FI-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Iapetus": {
                    "name": "fi-FI-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Kore": {
                    "name": "fi-FI-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Laomedeia": {
                    "name": "fi-FI-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Leda": {
                    "name": "fi-FI-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Orus": {
                    "name": "fi-FI-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Puck": {
                    "name": "fi-FI-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Pulcherrima": {
                    "name": "fi-FI-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Rasalgethi": {
                    "name": "fi-FI-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Sadachbia": {
                    "name": "fi-FI-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Sadaltager": {
                    "name": "fi-FI-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Schedar": {
                    "name": "fi-FI-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Sulafat": {
                    "name": "fi-FI-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Umbriel": {
                    "name": "fi-FI-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Vindemiatrix": {
                    "name": "fi-FI-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Zephyr": {
                    "name": "fi-FI-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Chirp3-HD-Zubenelgenubi": {
                    "name": "fi-FI-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Standard-B": {
                    "name": "fi-FI-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fi-FI-Wavenet-B": {
                    "name": "fi-FI-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "fi",
                        "fi-FI"
                    ],
                    "replaced": false
                },
                "fil-PH-Standard-A": {
                    "name": "fil-PH-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Standard-B": {
                    "name": "fil-PH-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Standard-C": {
                    "name": "fil-PH-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Standard-D": {
                    "name": "fil-PH-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Wavenet-A": {
                    "name": "fil-PH-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Wavenet-B": {
                    "name": "fil-PH-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Wavenet-C": {
                    "name": "fil-PH-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-PH-Wavenet-D": {
                    "name": "fil-PH-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-ph-Neural2-A": {
                    "name": "fil-ph-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fil-ph-Neural2-D": {
                    "name": "fil-ph-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "fil",
                        "fil-PH"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp-HD-D": {
                    "name": "fr-CA-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp-HD-F": {
                    "name": "fr-CA-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp-HD-O": {
                    "name": "fr-CA-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Achernar": {
                    "name": "fr-CA-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Achird": {
                    "name": "fr-CA-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Algenib": {
                    "name": "fr-CA-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Algieba": {
                    "name": "fr-CA-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Alnilam": {
                    "name": "fr-CA-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Aoede": {
                    "name": "fr-CA-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Autonoe": {
                    "name": "fr-CA-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Callirrhoe": {
                    "name": "fr-CA-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Charon": {
                    "name": "fr-CA-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Despina": {
                    "name": "fr-CA-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Enceladus": {
                    "name": "fr-CA-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Erinome": {
                    "name": "fr-CA-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Fenrir": {
                    "name": "fr-CA-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Gacrux": {
                    "name": "fr-CA-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Iapetus": {
                    "name": "fr-CA-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Kore": {
                    "name": "fr-CA-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Laomedeia": {
                    "name": "fr-CA-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Leda": {
                    "name": "fr-CA-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Orus": {
                    "name": "fr-CA-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Puck": {
                    "name": "fr-CA-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Pulcherrima": {
                    "name": "fr-CA-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Rasalgethi": {
                    "name": "fr-CA-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Sadachbia": {
                    "name": "fr-CA-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Sadaltager": {
                    "name": "fr-CA-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Schedar": {
                    "name": "fr-CA-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Sulafat": {
                    "name": "fr-CA-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Umbriel": {
                    "name": "fr-CA-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Vindemiatrix": {
                    "name": "fr-CA-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Zephyr": {
                    "name": "fr-CA-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Chirp3-HD-Zubenelgenubi": {
                    "name": "fr-CA-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Neural2-A": {
                    "name": "fr-CA-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Neural2-B": {
                    "name": "fr-CA-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Neural2-C": {
                    "name": "fr-CA-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Neural2-D": {
                    "name": "fr-CA-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Standard-A": {
                    "name": "fr-CA-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Standard-B": {
                    "name": "fr-CA-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Standard-C": {
                    "name": "fr-CA-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Standard-D": {
                    "name": "fr-CA-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Wavenet-A": {
                    "name": "fr-CA-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Wavenet-B": {
                    "name": "fr-CA-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Wavenet-C": {
                    "name": "fr-CA-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-CA-Wavenet-D": {
                    "name": "fr-CA-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-CA"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp-HD-D": {
                    "name": "fr-FR-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp-HD-F": {
                    "name": "fr-FR-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp-HD-O": {
                    "name": "fr-FR-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Achernar": {
                    "name": "fr-FR-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Achird": {
                    "name": "fr-FR-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Algenib": {
                    "name": "fr-FR-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Algieba": {
                    "name": "fr-FR-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Alnilam": {
                    "name": "fr-FR-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Aoede": {
                    "name": "fr-FR-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Autonoe": {
                    "name": "fr-FR-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Callirrhoe": {
                    "name": "fr-FR-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Charon": {
                    "name": "fr-FR-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Despina": {
                    "name": "fr-FR-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Enceladus": {
                    "name": "fr-FR-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Erinome": {
                    "name": "fr-FR-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Fenrir": {
                    "name": "fr-FR-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Gacrux": {
                    "name": "fr-FR-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Iapetus": {
                    "name": "fr-FR-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Kore": {
                    "name": "fr-FR-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Laomedeia": {
                    "name": "fr-FR-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Leda": {
                    "name": "fr-FR-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Orus": {
                    "name": "fr-FR-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Puck": {
                    "name": "fr-FR-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Pulcherrima": {
                    "name": "fr-FR-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Rasalgethi": {
                    "name": "fr-FR-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Sadachbia": {
                    "name": "fr-FR-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Sadaltager": {
                    "name": "fr-FR-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Schedar": {
                    "name": "fr-FR-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Sulafat": {
                    "name": "fr-FR-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Umbriel": {
                    "name": "fr-FR-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Vindemiatrix": {
                    "name": "fr-FR-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Zephyr": {
                    "name": "fr-FR-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Chirp3-HD-Zubenelgenubi": {
                    "name": "fr-FR-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Neural2-F": {
                    "name": "fr-FR-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Neural2-G": {
                    "name": "fr-FR-Neural2-G",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Polyglot-1": {
                    "name": "fr-FR-Polyglot-1",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Standard-F": {
                    "name": "fr-FR-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Standard-G": {
                    "name": "fr-FR-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Studio-A": {
                    "name": "fr-FR-Studio-A",
                    "costMultiplier": 40,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "fr-FR-Studio-D": {
                    "name": "fr-FR-Studio-D",
                    "costMultiplier": 40,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": true,
                    "replacementVoice": "?",
                    "replacementDate": "2025-04-15"
                },
                "fr-FR-Wavenet-F": {
                    "name": "fr-FR-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "fr-FR-Wavenet-G": {
                    "name": "fr-FR-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "fr",
                        "fr-FR"
                    ],
                    "replaced": false
                },
                "gl-ES-Standard-B": {
                    "name": "gl-ES-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "gl",
                        "gl-ES"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Achernar": {
                    "name": "gu-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Achird": {
                    "name": "gu-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Algenib": {
                    "name": "gu-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Algieba": {
                    "name": "gu-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Alnilam": {
                    "name": "gu-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Aoede": {
                    "name": "gu-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Autonoe": {
                    "name": "gu-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Callirrhoe": {
                    "name": "gu-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Charon": {
                    "name": "gu-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Despina": {
                    "name": "gu-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Enceladus": {
                    "name": "gu-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Erinome": {
                    "name": "gu-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Fenrir": {
                    "name": "gu-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Gacrux": {
                    "name": "gu-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Iapetus": {
                    "name": "gu-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Kore": {
                    "name": "gu-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Laomedeia": {
                    "name": "gu-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Leda": {
                    "name": "gu-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Orus": {
                    "name": "gu-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Puck": {
                    "name": "gu-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Pulcherrima": {
                    "name": "gu-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Rasalgethi": {
                    "name": "gu-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Sadachbia": {
                    "name": "gu-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Sadaltager": {
                    "name": "gu-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Schedar": {
                    "name": "gu-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Sulafat": {
                    "name": "gu-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Umbriel": {
                    "name": "gu-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "gu-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Zephyr": {
                    "name": "gu-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "gu-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Standard-A": {
                    "name": "gu-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Standard-B": {
                    "name": "gu-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Standard-C": {
                    "name": "gu-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Standard-D": {
                    "name": "gu-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Wavenet-A": {
                    "name": "gu-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Wavenet-B": {
                    "name": "gu-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Wavenet-C": {
                    "name": "gu-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "gu-IN-Wavenet-D": {
                    "name": "gu-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "gu",
                        "gu-IN"
                    ],
                    "replaced": false
                },
                "he-IL-Standard-A": {
                    "name": "he-IL-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Standard-B": {
                    "name": "he-IL-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Standard-C": {
                    "name": "he-IL-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Standard-D": {
                    "name": "he-IL-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Wavenet-A": {
                    "name": "he-IL-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Wavenet-B": {
                    "name": "he-IL-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Wavenet-C": {
                    "name": "he-IL-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "he-IL-Wavenet-D": {
                    "name": "he-IL-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "he",
                        "he-IL"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Achernar": {
                    "name": "hi-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Achird": {
                    "name": "hi-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Algenib": {
                    "name": "hi-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Algieba": {
                    "name": "hi-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Alnilam": {
                    "name": "hi-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Aoede": {
                    "name": "hi-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Autonoe": {
                    "name": "hi-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Callirrhoe": {
                    "name": "hi-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Charon": {
                    "name": "hi-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Despina": {
                    "name": "hi-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Enceladus": {
                    "name": "hi-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Erinome": {
                    "name": "hi-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Fenrir": {
                    "name": "hi-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Gacrux": {
                    "name": "hi-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Iapetus": {
                    "name": "hi-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Kore": {
                    "name": "hi-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Laomedeia": {
                    "name": "hi-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Leda": {
                    "name": "hi-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Orus": {
                    "name": "hi-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Puck": {
                    "name": "hi-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Pulcherrima": {
                    "name": "hi-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Rasalgethi": {
                    "name": "hi-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Sadachbia": {
                    "name": "hi-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Sadaltager": {
                    "name": "hi-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Schedar": {
                    "name": "hi-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Sulafat": {
                    "name": "hi-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Umbriel": {
                    "name": "hi-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "hi-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Zephyr": {
                    "name": "hi-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "hi-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Neural2-A": {
                    "name": "hi-IN-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Neural2-B": {
                    "name": "hi-IN-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Neural2-C": {
                    "name": "hi-IN-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Neural2-D": {
                    "name": "hi-IN-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-A": {
                    "name": "hi-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-B": {
                    "name": "hi-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-C": {
                    "name": "hi-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-D": {
                    "name": "hi-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-E": {
                    "name": "hi-IN-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Standard-F": {
                    "name": "hi-IN-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-A": {
                    "name": "hi-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-B": {
                    "name": "hi-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-C": {
                    "name": "hi-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-D": {
                    "name": "hi-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-E": {
                    "name": "hi-IN-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hi-IN-Wavenet-F": {
                    "name": "hi-IN-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "hi",
                        "hi-IN"
                    ],
                    "replaced": false
                },
                "hu-HU-Standard-B": {
                    "name": "hu-HU-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "hu",
                        "hu-HU"
                    ],
                    "replaced": false
                },
                "hu-HU-Wavenet-B": {
                    "name": "hu-HU-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "hu",
                        "hu-HU"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Achernar": {
                    "name": "id-ID-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Achird": {
                    "name": "id-ID-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Algenib": {
                    "name": "id-ID-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Algieba": {
                    "name": "id-ID-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Alnilam": {
                    "name": "id-ID-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Aoede": {
                    "name": "id-ID-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Autonoe": {
                    "name": "id-ID-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Callirrhoe": {
                    "name": "id-ID-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Charon": {
                    "name": "id-ID-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Despina": {
                    "name": "id-ID-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Enceladus": {
                    "name": "id-ID-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Erinome": {
                    "name": "id-ID-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Fenrir": {
                    "name": "id-ID-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Gacrux": {
                    "name": "id-ID-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Iapetus": {
                    "name": "id-ID-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Kore": {
                    "name": "id-ID-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Laomedeia": {
                    "name": "id-ID-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Leda": {
                    "name": "id-ID-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Orus": {
                    "name": "id-ID-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Puck": {
                    "name": "id-ID-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Pulcherrima": {
                    "name": "id-ID-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Rasalgethi": {
                    "name": "id-ID-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Sadachbia": {
                    "name": "id-ID-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Sadaltager": {
                    "name": "id-ID-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Schedar": {
                    "name": "id-ID-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Sulafat": {
                    "name": "id-ID-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Umbriel": {
                    "name": "id-ID-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Vindemiatrix": {
                    "name": "id-ID-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Zephyr": {
                    "name": "id-ID-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Chirp3-HD-Zubenelgenubi": {
                    "name": "id-ID-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Standard-A": {
                    "name": "id-ID-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Standard-B": {
                    "name": "id-ID-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Standard-C": {
                    "name": "id-ID-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Standard-D": {
                    "name": "id-ID-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Wavenet-A": {
                    "name": "id-ID-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Wavenet-B": {
                    "name": "id-ID-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Wavenet-C": {
                    "name": "id-ID-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "id-ID-Wavenet-D": {
                    "name": "id-ID-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "id",
                        "id-ID"
                    ],
                    "replaced": false
                },
                "is-IS-Standard-B": {
                    "name": "is-IS-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "is",
                        "is-IS"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp-HD-D": {
                    "name": "it-IT-Chirp-HD-D",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp-HD-F": {
                    "name": "it-IT-Chirp-HD-F",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp-HD-O": {
                    "name": "it-IT-Chirp-HD-O",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Achernar": {
                    "name": "it-IT-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Achird": {
                    "name": "it-IT-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Algenib": {
                    "name": "it-IT-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Algieba": {
                    "name": "it-IT-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Alnilam": {
                    "name": "it-IT-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Aoede": {
                    "name": "it-IT-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Autonoe": {
                    "name": "it-IT-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Callirrhoe": {
                    "name": "it-IT-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Charon": {
                    "name": "it-IT-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Despina": {
                    "name": "it-IT-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Enceladus": {
                    "name": "it-IT-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Erinome": {
                    "name": "it-IT-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Fenrir": {
                    "name": "it-IT-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Gacrux": {
                    "name": "it-IT-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Iapetus": {
                    "name": "it-IT-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Kore": {
                    "name": "it-IT-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Laomedeia": {
                    "name": "it-IT-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Leda": {
                    "name": "it-IT-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Orus": {
                    "name": "it-IT-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Puck": {
                    "name": "it-IT-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Pulcherrima": {
                    "name": "it-IT-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Rasalgethi": {
                    "name": "it-IT-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Sadachbia": {
                    "name": "it-IT-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Sadaltager": {
                    "name": "it-IT-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Schedar": {
                    "name": "it-IT-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Sulafat": {
                    "name": "it-IT-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Umbriel": {
                    "name": "it-IT-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Vindemiatrix": {
                    "name": "it-IT-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Zephyr": {
                    "name": "it-IT-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Chirp3-HD-Zubenelgenubi": {
                    "name": "it-IT-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Neural2-A": {
                    "name": "it-IT-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": true,
                    "replacementVoice": "it-IT-Neural2-E",
                    "replacementDate": "2025-01-27"
                },
                "it-IT-Neural2-E": {
                    "name": "it-IT-Neural2-E",
                    "costMultiplier": 4,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Neural2-F": {
                    "name": "it-IT-Neural2-F",
                    "costMultiplier": 4,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Standard-E": {
                    "name": "it-IT-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Standard-F": {
                    "name": "it-IT-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Wavenet-E": {
                    "name": "it-IT-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "it-IT-Wavenet-F": {
                    "name": "it-IT-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "it",
                        "it-IT"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Achernar": {
                    "name": "ja-JP-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Achird": {
                    "name": "ja-JP-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Algenib": {
                    "name": "ja-JP-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Algieba": {
                    "name": "ja-JP-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Alnilam": {
                    "name": "ja-JP-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Aoede": {
                    "name": "ja-JP-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Autonoe": {
                    "name": "ja-JP-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Callirrhoe": {
                    "name": "ja-JP-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Charon": {
                    "name": "ja-JP-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Despina": {
                    "name": "ja-JP-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Enceladus": {
                    "name": "ja-JP-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Erinome": {
                    "name": "ja-JP-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Fenrir": {
                    "name": "ja-JP-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Gacrux": {
                    "name": "ja-JP-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Iapetus": {
                    "name": "ja-JP-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Kore": {
                    "name": "ja-JP-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Laomedeia": {
                    "name": "ja-JP-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Leda": {
                    "name": "ja-JP-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Orus": {
                    "name": "ja-JP-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Puck": {
                    "name": "ja-JP-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Pulcherrima": {
                    "name": "ja-JP-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Rasalgethi": {
                    "name": "ja-JP-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Sadachbia": {
                    "name": "ja-JP-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Sadaltager": {
                    "name": "ja-JP-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Schedar": {
                    "name": "ja-JP-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Sulafat": {
                    "name": "ja-JP-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Umbriel": {
                    "name": "ja-JP-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Vindemiatrix": {
                    "name": "ja-JP-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Zephyr": {
                    "name": "ja-JP-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Chirp3-HD-Zubenelgenubi": {
                    "name": "ja-JP-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Neural2-B": {
                    "name": "ja-JP-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Neural2-C": {
                    "name": "ja-JP-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Neural2-D": {
                    "name": "ja-JP-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Standard-A": {
                    "name": "ja-JP-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Standard-B": {
                    "name": "ja-JP-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Standard-C": {
                    "name": "ja-JP-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Standard-D": {
                    "name": "ja-JP-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Wavenet-A": {
                    "name": "ja-JP-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Wavenet-B": {
                    "name": "ja-JP-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Wavenet-C": {
                    "name": "ja-JP-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "ja-JP-Wavenet-D": {
                    "name": "ja-JP-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ja",
                        "ja-JP"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Achernar": {
                    "name": "kn-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Achird": {
                    "name": "kn-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Algenib": {
                    "name": "kn-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Algieba": {
                    "name": "kn-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Alnilam": {
                    "name": "kn-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Aoede": {
                    "name": "kn-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Autonoe": {
                    "name": "kn-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Callirrhoe": {
                    "name": "kn-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Charon": {
                    "name": "kn-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Despina": {
                    "name": "kn-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Enceladus": {
                    "name": "kn-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Erinome": {
                    "name": "kn-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Fenrir": {
                    "name": "kn-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Gacrux": {
                    "name": "kn-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Iapetus": {
                    "name": "kn-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Kore": {
                    "name": "kn-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Laomedeia": {
                    "name": "kn-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Leda": {
                    "name": "kn-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Orus": {
                    "name": "kn-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Puck": {
                    "name": "kn-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Pulcherrima": {
                    "name": "kn-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Rasalgethi": {
                    "name": "kn-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Sadachbia": {
                    "name": "kn-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Sadaltager": {
                    "name": "kn-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Schedar": {
                    "name": "kn-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Sulafat": {
                    "name": "kn-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Umbriel": {
                    "name": "kn-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "kn-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Zephyr": {
                    "name": "kn-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "kn-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Standard-A": {
                    "name": "kn-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Standard-B": {
                    "name": "kn-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Standard-C": {
                    "name": "kn-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Standard-D": {
                    "name": "kn-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Wavenet-A": {
                    "name": "kn-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Wavenet-B": {
                    "name": "kn-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Wavenet-C": {
                    "name": "kn-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "kn-IN-Wavenet-D": {
                    "name": "kn-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "kn",
                        "kn-IN"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Achernar": {
                    "name": "ko-KR-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Achird": {
                    "name": "ko-KR-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Algenib": {
                    "name": "ko-KR-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Algieba": {
                    "name": "ko-KR-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Alnilam": {
                    "name": "ko-KR-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Aoede": {
                    "name": "ko-KR-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Autonoe": {
                    "name": "ko-KR-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Callirrhoe": {
                    "name": "ko-KR-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Charon": {
                    "name": "ko-KR-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Despina": {
                    "name": "ko-KR-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Enceladus": {
                    "name": "ko-KR-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Erinome": {
                    "name": "ko-KR-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Fenrir": {
                    "name": "ko-KR-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Gacrux": {
                    "name": "ko-KR-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Iapetus": {
                    "name": "ko-KR-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Kore": {
                    "name": "ko-KR-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Laomedeia": {
                    "name": "ko-KR-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Leda": {
                    "name": "ko-KR-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Orus": {
                    "name": "ko-KR-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Puck": {
                    "name": "ko-KR-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Pulcherrima": {
                    "name": "ko-KR-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Rasalgethi": {
                    "name": "ko-KR-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Sadachbia": {
                    "name": "ko-KR-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Sadaltager": {
                    "name": "ko-KR-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Schedar": {
                    "name": "ko-KR-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Sulafat": {
                    "name": "ko-KR-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Umbriel": {
                    "name": "ko-KR-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Vindemiatrix": {
                    "name": "ko-KR-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Zephyr": {
                    "name": "ko-KR-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Chirp3-HD-Zubenelgenubi": {
                    "name": "ko-KR-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Neural2-A": {
                    "name": "ko-KR-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Neural2-B": {
                    "name": "ko-KR-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Neural2-C": {
                    "name": "ko-KR-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Standard-A": {
                    "name": "ko-KR-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Standard-B": {
                    "name": "ko-KR-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Standard-C": {
                    "name": "ko-KR-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Standard-D": {
                    "name": "ko-KR-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Wavenet-A": {
                    "name": "ko-KR-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Wavenet-B": {
                    "name": "ko-KR-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Wavenet-C": {
                    "name": "ko-KR-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "ko-KR-Wavenet-D": {
                    "name": "ko-KR-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ko",
                        "ko-KR"
                    ],
                    "replaced": false
                },
                "lt-LT-Standard-B": {
                    "name": "lt-LT-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "lt",
                        "lt-LT"
                    ],
                    "replaced": false
                },
                "lv-LV-Standard-B": {
                    "name": "lv-LV-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "lv",
                        "lv-LV"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Achernar": {
                    "name": "ml-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Achird": {
                    "name": "ml-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Algenib": {
                    "name": "ml-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Algieba": {
                    "name": "ml-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Alnilam": {
                    "name": "ml-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Aoede": {
                    "name": "ml-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Autonoe": {
                    "name": "ml-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Callirrhoe": {
                    "name": "ml-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Charon": {
                    "name": "ml-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Despina": {
                    "name": "ml-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Enceladus": {
                    "name": "ml-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Erinome": {
                    "name": "ml-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Fenrir": {
                    "name": "ml-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Gacrux": {
                    "name": "ml-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Iapetus": {
                    "name": "ml-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Kore": {
                    "name": "ml-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Laomedeia": {
                    "name": "ml-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Leda": {
                    "name": "ml-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Orus": {
                    "name": "ml-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Puck": {
                    "name": "ml-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Pulcherrima": {
                    "name": "ml-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Rasalgethi": {
                    "name": "ml-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Sadachbia": {
                    "name": "ml-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Sadaltager": {
                    "name": "ml-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Schedar": {
                    "name": "ml-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Sulafat": {
                    "name": "ml-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Umbriel": {
                    "name": "ml-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "ml-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Zephyr": {
                    "name": "ml-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "ml-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Standard-A": {
                    "name": "ml-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Standard-B": {
                    "name": "ml-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Standard-C": {
                    "name": "ml-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Standard-D": {
                    "name": "ml-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Wavenet-A": {
                    "name": "ml-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Wavenet-B": {
                    "name": "ml-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Wavenet-C": {
                    "name": "ml-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "ml-IN-Wavenet-D": {
                    "name": "ml-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ml",
                        "ml-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Achernar": {
                    "name": "mr-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Achird": {
                    "name": "mr-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Algenib": {
                    "name": "mr-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Algieba": {
                    "name": "mr-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Alnilam": {
                    "name": "mr-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Aoede": {
                    "name": "mr-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Autonoe": {
                    "name": "mr-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Callirrhoe": {
                    "name": "mr-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Charon": {
                    "name": "mr-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Despina": {
                    "name": "mr-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Enceladus": {
                    "name": "mr-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Erinome": {
                    "name": "mr-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Fenrir": {
                    "name": "mr-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Gacrux": {
                    "name": "mr-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Iapetus": {
                    "name": "mr-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Kore": {
                    "name": "mr-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Laomedeia": {
                    "name": "mr-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Leda": {
                    "name": "mr-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Orus": {
                    "name": "mr-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Puck": {
                    "name": "mr-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Pulcherrima": {
                    "name": "mr-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Rasalgethi": {
                    "name": "mr-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Sadachbia": {
                    "name": "mr-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Sadaltager": {
                    "name": "mr-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Schedar": {
                    "name": "mr-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Sulafat": {
                    "name": "mr-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Umbriel": {
                    "name": "mr-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "mr-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Zephyr": {
                    "name": "mr-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "mr-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Standard-A": {
                    "name": "mr-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Standard-B": {
                    "name": "mr-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Standard-C": {
                    "name": "mr-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Wavenet-A": {
                    "name": "mr-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Wavenet-B": {
                    "name": "mr-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "mr-IN-Wavenet-C": {
                    "name": "mr-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "mr",
                        "mr-IN"
                    ],
                    "replaced": false
                },
                "ms-MY-Standard-A": {
                    "name": "ms-MY-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Standard-B": {
                    "name": "ms-MY-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Standard-C": {
                    "name": "ms-MY-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Standard-D": {
                    "name": "ms-MY-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Wavenet-A": {
                    "name": "ms-MY-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Wavenet-B": {
                    "name": "ms-MY-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Wavenet-C": {
                    "name": "ms-MY-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "ms-MY-Wavenet-D": {
                    "name": "ms-MY-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ms",
                        "ms-MY"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Achernar": {
                    "name": "nb-NO-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Achird": {
                    "name": "nb-NO-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Algenib": {
                    "name": "nb-NO-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Algieba": {
                    "name": "nb-NO-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Alnilam": {
                    "name": "nb-NO-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Aoede": {
                    "name": "nb-NO-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Autonoe": {
                    "name": "nb-NO-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Callirrhoe": {
                    "name": "nb-NO-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Charon": {
                    "name": "nb-NO-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Despina": {
                    "name": "nb-NO-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Enceladus": {
                    "name": "nb-NO-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Erinome": {
                    "name": "nb-NO-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Fenrir": {
                    "name": "nb-NO-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Gacrux": {
                    "name": "nb-NO-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Iapetus": {
                    "name": "nb-NO-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Kore": {
                    "name": "nb-NO-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Laomedeia": {
                    "name": "nb-NO-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Leda": {
                    "name": "nb-NO-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Orus": {
                    "name": "nb-NO-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Puck": {
                    "name": "nb-NO-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Pulcherrima": {
                    "name": "nb-NO-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Rasalgethi": {
                    "name": "nb-NO-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Sadachbia": {
                    "name": "nb-NO-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Sadaltager": {
                    "name": "nb-NO-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Schedar": {
                    "name": "nb-NO-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Sulafat": {
                    "name": "nb-NO-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Umbriel": {
                    "name": "nb-NO-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Vindemiatrix": {
                    "name": "nb-NO-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Zephyr": {
                    "name": "nb-NO-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Chirp3-HD-Zubenelgenubi": {
                    "name": "nb-NO-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Standard-F": {
                    "name": "nb-NO-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Standard-G": {
                    "name": "nb-NO-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Wavenet-F": {
                    "name": "nb-NO-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nb-NO-Wavenet-G": {
                    "name": "nb-NO-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "nb",
                        "nb-NO"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Achernar": {
                    "name": "nl-BE-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Achird": {
                    "name": "nl-BE-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Algenib": {
                    "name": "nl-BE-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Algieba": {
                    "name": "nl-BE-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Alnilam": {
                    "name": "nl-BE-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Aoede": {
                    "name": "nl-BE-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Autonoe": {
                    "name": "nl-BE-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Callirrhoe": {
                    "name": "nl-BE-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Charon": {
                    "name": "nl-BE-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Despina": {
                    "name": "nl-BE-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Enceladus": {
                    "name": "nl-BE-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Erinome": {
                    "name": "nl-BE-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Fenrir": {
                    "name": "nl-BE-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Gacrux": {
                    "name": "nl-BE-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Iapetus": {
                    "name": "nl-BE-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Kore": {
                    "name": "nl-BE-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Laomedeia": {
                    "name": "nl-BE-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Leda": {
                    "name": "nl-BE-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Orus": {
                    "name": "nl-BE-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Puck": {
                    "name": "nl-BE-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Pulcherrima": {
                    "name": "nl-BE-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Rasalgethi": {
                    "name": "nl-BE-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Sadachbia": {
                    "name": "nl-BE-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Sadaltager": {
                    "name": "nl-BE-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Schedar": {
                    "name": "nl-BE-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Sulafat": {
                    "name": "nl-BE-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Umbriel": {
                    "name": "nl-BE-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Vindemiatrix": {
                    "name": "nl-BE-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Zephyr": {
                    "name": "nl-BE-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Chirp3-HD-Zubenelgenubi": {
                    "name": "nl-BE-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Standard-C": {
                    "name": "nl-BE-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Standard-D": {
                    "name": "nl-BE-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Wavenet-C": {
                    "name": "nl-BE-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-BE-Wavenet-D": {
                    "name": "nl-BE-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "nl",
                        "nl-BE"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Achernar": {
                    "name": "nl-NL-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Achird": {
                    "name": "nl-NL-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Algenib": {
                    "name": "nl-NL-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Algieba": {
                    "name": "nl-NL-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Alnilam": {
                    "name": "nl-NL-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Aoede": {
                    "name": "nl-NL-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Autonoe": {
                    "name": "nl-NL-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Callirrhoe": {
                    "name": "nl-NL-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Charon": {
                    "name": "nl-NL-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Despina": {
                    "name": "nl-NL-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Enceladus": {
                    "name": "nl-NL-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Erinome": {
                    "name": "nl-NL-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Fenrir": {
                    "name": "nl-NL-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Gacrux": {
                    "name": "nl-NL-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Iapetus": {
                    "name": "nl-NL-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Kore": {
                    "name": "nl-NL-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Laomedeia": {
                    "name": "nl-NL-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Leda": {
                    "name": "nl-NL-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Orus": {
                    "name": "nl-NL-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Puck": {
                    "name": "nl-NL-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Pulcherrima": {
                    "name": "nl-NL-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Rasalgethi": {
                    "name": "nl-NL-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Sadachbia": {
                    "name": "nl-NL-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Sadaltager": {
                    "name": "nl-NL-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Schedar": {
                    "name": "nl-NL-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Sulafat": {
                    "name": "nl-NL-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Umbriel": {
                    "name": "nl-NL-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Vindemiatrix": {
                    "name": "nl-NL-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Zephyr": {
                    "name": "nl-NL-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Chirp3-HD-Zubenelgenubi": {
                    "name": "nl-NL-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Standard-F": {
                    "name": "nl-NL-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Standard-G": {
                    "name": "nl-NL-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Wavenet-F": {
                    "name": "nl-NL-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "nl-NL-Wavenet-G": {
                    "name": "nl-NL-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "nl",
                        "nl-NL"
                    ],
                    "replaced": false
                },
                "pa-IN-Standard-A": {
                    "name": "pa-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Standard-B": {
                    "name": "pa-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Standard-C": {
                    "name": "pa-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Standard-D": {
                    "name": "pa-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Wavenet-A": {
                    "name": "pa-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Wavenet-B": {
                    "name": "pa-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Wavenet-C": {
                    "name": "pa-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pa-IN-Wavenet-D": {
                    "name": "pa-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "pa",
                        "pa-IN"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Achernar": {
                    "name": "pl-PL-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Achird": {
                    "name": "pl-PL-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Algenib": {
                    "name": "pl-PL-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Algieba": {
                    "name": "pl-PL-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Alnilam": {
                    "name": "pl-PL-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Aoede": {
                    "name": "pl-PL-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Autonoe": {
                    "name": "pl-PL-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Callirrhoe": {
                    "name": "pl-PL-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Charon": {
                    "name": "pl-PL-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Despina": {
                    "name": "pl-PL-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Enceladus": {
                    "name": "pl-PL-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Erinome": {
                    "name": "pl-PL-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Fenrir": {
                    "name": "pl-PL-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Gacrux": {
                    "name": "pl-PL-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Iapetus": {
                    "name": "pl-PL-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Kore": {
                    "name": "pl-PL-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Laomedeia": {
                    "name": "pl-PL-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Leda": {
                    "name": "pl-PL-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Orus": {
                    "name": "pl-PL-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Puck": {
                    "name": "pl-PL-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Pulcherrima": {
                    "name": "pl-PL-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Rasalgethi": {
                    "name": "pl-PL-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Sadachbia": {
                    "name": "pl-PL-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Sadaltager": {
                    "name": "pl-PL-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Schedar": {
                    "name": "pl-PL-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Sulafat": {
                    "name": "pl-PL-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Umbriel": {
                    "name": "pl-PL-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Vindemiatrix": {
                    "name": "pl-PL-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Zephyr": {
                    "name": "pl-PL-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Chirp3-HD-Zubenelgenubi": {
                    "name": "pl-PL-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Standard-F": {
                    "name": "pl-PL-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Standard-G": {
                    "name": "pl-PL-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Wavenet-F": {
                    "name": "pl-PL-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pl-PL-Wavenet-G": {
                    "name": "pl-PL-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "pl",
                        "pl-PL"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Achernar": {
                    "name": "pt-BR-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Achird": {
                    "name": "pt-BR-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Algenib": {
                    "name": "pt-BR-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Algieba": {
                    "name": "pt-BR-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Alnilam": {
                    "name": "pt-BR-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Aoede": {
                    "name": "pt-BR-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Autonoe": {
                    "name": "pt-BR-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Callirrhoe": {
                    "name": "pt-BR-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Charon": {
                    "name": "pt-BR-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Despina": {
                    "name": "pt-BR-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Enceladus": {
                    "name": "pt-BR-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Erinome": {
                    "name": "pt-BR-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Fenrir": {
                    "name": "pt-BR-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Gacrux": {
                    "name": "pt-BR-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Iapetus": {
                    "name": "pt-BR-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Kore": {
                    "name": "pt-BR-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Laomedeia": {
                    "name": "pt-BR-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Leda": {
                    "name": "pt-BR-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Orus": {
                    "name": "pt-BR-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Puck": {
                    "name": "pt-BR-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Pulcherrima": {
                    "name": "pt-BR-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Rasalgethi": {
                    "name": "pt-BR-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Sadachbia": {
                    "name": "pt-BR-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Sadaltager": {
                    "name": "pt-BR-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Schedar": {
                    "name": "pt-BR-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Sulafat": {
                    "name": "pt-BR-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Umbriel": {
                    "name": "pt-BR-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Vindemiatrix": {
                    "name": "pt-BR-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Zephyr": {
                    "name": "pt-BR-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Chirp3-HD-Zubenelgenubi": {
                    "name": "pt-BR-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Neural2-A": {
                    "name": "pt-BR-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Neural2-B": {
                    "name": "pt-BR-Neural2-B",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Neural2-C": {
                    "name": "pt-BR-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Standard-A": {
                    "name": "pt-BR-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Standard-B": {
                    "name": "pt-BR-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Standard-C": {
                    "name": "pt-BR-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Standard-D": {
                    "name": "pt-BR-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Standard-E": {
                    "name": "pt-BR-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Wavenet-A": {
                    "name": "pt-BR-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Wavenet-B": {
                    "name": "pt-BR-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Wavenet-C": {
                    "name": "pt-BR-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Wavenet-D": {
                    "name": "pt-BR-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-BR-Wavenet-E": {
                    "name": "pt-BR-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-BR"
                    ],
                    "replaced": false
                },
                "pt-PT-Standard-E": {
                    "name": "pt-PT-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-PT"
                    ],
                    "replaced": false
                },
                "pt-PT-Standard-F": {
                    "name": "pt-PT-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "pt",
                        "pt-PT"
                    ],
                    "replaced": false
                },
                "pt-PT-Wavenet-E": {
                    "name": "pt-PT-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-PT"
                    ],
                    "replaced": false
                },
                "pt-PT-Wavenet-F": {
                    "name": "pt-PT-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "pt",
                        "pt-PT"
                    ],
                    "replaced": false
                },
                "ro-RO-Standard-B": {
                    "name": "ro-RO-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ro",
                        "ro-RO"
                    ],
                    "replaced": false
                },
                "ro-RO-Wavenet-B": {
                    "name": "ro-RO-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ro",
                        "ro-RO"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Aoede": {
                    "name": "ru-RU-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Charon": {
                    "name": "ru-RU-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Fenrir": {
                    "name": "ru-RU-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Kore": {
                    "name": "ru-RU-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Leda": {
                    "name": "ru-RU-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Orus": {
                    "name": "ru-RU-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Puck": {
                    "name": "ru-RU-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Chirp3-HD-Zephyr": {
                    "name": "ru-RU-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Standard-A": {
                    "name": "ru-RU-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Standard-B": {
                    "name": "ru-RU-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Standard-C": {
                    "name": "ru-RU-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Standard-D": {
                    "name": "ru-RU-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Standard-E": {
                    "name": "ru-RU-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Wavenet-A": {
                    "name": "ru-RU-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Wavenet-B": {
                    "name": "ru-RU-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Wavenet-C": {
                    "name": "ru-RU-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Wavenet-D": {
                    "name": "ru-RU-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "ru-RU-Wavenet-E": {
                    "name": "ru-RU-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "ru",
                        "ru-RU"
                    ],
                    "replaced": false
                },
                "sk-SK-Standard-B": {
                    "name": "sk-SK-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "sk",
                        "sk-SK"
                    ],
                    "replaced": false
                },
                "sk-SK-Wavenet-B": {
                    "name": "sk-SK-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "sk",
                        "sk-SK"
                    ],
                    "replaced": false
                },
                "sr-RS-Standard-B": {
                    "name": "sr-RS-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "sr",
                        "sr-RS"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Achernar": {
                    "name": "sv-SE-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Achird": {
                    "name": "sv-SE-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Algenib": {
                    "name": "sv-SE-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Algieba": {
                    "name": "sv-SE-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Alnilam": {
                    "name": "sv-SE-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Aoede": {
                    "name": "sv-SE-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Autonoe": {
                    "name": "sv-SE-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Callirrhoe": {
                    "name": "sv-SE-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Charon": {
                    "name": "sv-SE-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Despina": {
                    "name": "sv-SE-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Enceladus": {
                    "name": "sv-SE-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Erinome": {
                    "name": "sv-SE-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Fenrir": {
                    "name": "sv-SE-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Gacrux": {
                    "name": "sv-SE-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Iapetus": {
                    "name": "sv-SE-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Kore": {
                    "name": "sv-SE-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Laomedeia": {
                    "name": "sv-SE-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Leda": {
                    "name": "sv-SE-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Orus": {
                    "name": "sv-SE-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Puck": {
                    "name": "sv-SE-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Pulcherrima": {
                    "name": "sv-SE-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Rasalgethi": {
                    "name": "sv-SE-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Sadachbia": {
                    "name": "sv-SE-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Sadaltager": {
                    "name": "sv-SE-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Schedar": {
                    "name": "sv-SE-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Sulafat": {
                    "name": "sv-SE-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Umbriel": {
                    "name": "sv-SE-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Vindemiatrix": {
                    "name": "sv-SE-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Zephyr": {
                    "name": "sv-SE-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Chirp3-HD-Zubenelgenubi": {
                    "name": "sv-SE-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Standard-A": {
                    "name": "sv-SE-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Standard-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Standard-B": {
                    "name": "sv-SE-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Standard-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Standard-C": {
                    "name": "sv-SE-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Standard-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Standard-D": {
                    "name": "sv-SE-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Standard-G",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Standard-E": {
                    "name": "sv-SE-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Standard-G",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Standard-F": {
                    "name": "sv-SE-Standard-F",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Standard-G": {
                    "name": "sv-SE-Standard-G",
                    "costMultiplier": 1,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Wavenet-A": {
                    "name": "sv-SE-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Wavenet-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Wavenet-B": {
                    "name": "sv-SE-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Wavenet-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Wavenet-C": {
                    "name": "sv-SE-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Wavenet-G",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Wavenet-D": {
                    "name": "sv-SE-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Wavenet-F",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Wavenet-E": {
                    "name": "sv-SE-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": true,
                    "replacementVoice": "sv-SE-Wavenet-G",
                    "replacementDate": "2025-01-27"
                },
                "sv-SE-Wavenet-F": {
                    "name": "sv-SE-Wavenet-F",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sv-SE-Wavenet-G": {
                    "name": "sv-SE-Wavenet-G",
                    "costMultiplier": 4,
                    "languages": [
                        "sv",
                        "sv-SE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Achernar": {
                    "name": "sw-KE-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Achird": {
                    "name": "sw-KE-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Algenib": {
                    "name": "sw-KE-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Algieba": {
                    "name": "sw-KE-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Alnilam": {
                    "name": "sw-KE-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Aoede": {
                    "name": "sw-KE-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Autonoe": {
                    "name": "sw-KE-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Callirrhoe": {
                    "name": "sw-KE-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Charon": {
                    "name": "sw-KE-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Despina": {
                    "name": "sw-KE-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Enceladus": {
                    "name": "sw-KE-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Erinome": {
                    "name": "sw-KE-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Fenrir": {
                    "name": "sw-KE-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Gacrux": {
                    "name": "sw-KE-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Iapetus": {
                    "name": "sw-KE-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Kore": {
                    "name": "sw-KE-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Laomedeia": {
                    "name": "sw-KE-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Leda": {
                    "name": "sw-KE-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Orus": {
                    "name": "sw-KE-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Puck": {
                    "name": "sw-KE-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Pulcherrima": {
                    "name": "sw-KE-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Rasalgethi": {
                    "name": "sw-KE-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Sadachbia": {
                    "name": "sw-KE-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Sadaltager": {
                    "name": "sw-KE-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Schedar": {
                    "name": "sw-KE-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Sulafat": {
                    "name": "sw-KE-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Umbriel": {
                    "name": "sw-KE-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Vindemiatrix": {
                    "name": "sw-KE-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Zephyr": {
                    "name": "sw-KE-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "sw-KE-Chirp3-HD-Zubenelgenubi": {
                    "name": "sw-KE-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "sw",
                        "sw-KE"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Achernar": {
                    "name": "ta-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Achird": {
                    "name": "ta-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Algenib": {
                    "name": "ta-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Algieba": {
                    "name": "ta-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Alnilam": {
                    "name": "ta-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Aoede": {
                    "name": "ta-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Autonoe": {
                    "name": "ta-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Callirrhoe": {
                    "name": "ta-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Charon": {
                    "name": "ta-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Despina": {
                    "name": "ta-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Enceladus": {
                    "name": "ta-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Erinome": {
                    "name": "ta-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Fenrir": {
                    "name": "ta-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Gacrux": {
                    "name": "ta-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Iapetus": {
                    "name": "ta-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Kore": {
                    "name": "ta-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Laomedeia": {
                    "name": "ta-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Leda": {
                    "name": "ta-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Orus": {
                    "name": "ta-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Puck": {
                    "name": "ta-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Pulcherrima": {
                    "name": "ta-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Rasalgethi": {
                    "name": "ta-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Sadachbia": {
                    "name": "ta-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Sadaltager": {
                    "name": "ta-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Schedar": {
                    "name": "ta-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Sulafat": {
                    "name": "ta-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Umbriel": {
                    "name": "ta-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "ta-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Zephyr": {
                    "name": "ta-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "ta-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Standard-A": {
                    "name": "ta-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Standard-B": {
                    "name": "ta-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Standard-C": {
                    "name": "ta-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Standard-D": {
                    "name": "ta-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Wavenet-A": {
                    "name": "ta-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Wavenet-B": {
                    "name": "ta-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Wavenet-C": {
                    "name": "ta-IN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "ta-IN-Wavenet-D": {
                    "name": "ta-IN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "ta",
                        "ta-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Achernar": {
                    "name": "te-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Achird": {
                    "name": "te-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Algenib": {
                    "name": "te-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Algieba": {
                    "name": "te-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Alnilam": {
                    "name": "te-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Aoede": {
                    "name": "te-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Autonoe": {
                    "name": "te-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Callirrhoe": {
                    "name": "te-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Charon": {
                    "name": "te-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Despina": {
                    "name": "te-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Enceladus": {
                    "name": "te-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Erinome": {
                    "name": "te-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Fenrir": {
                    "name": "te-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Gacrux": {
                    "name": "te-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Iapetus": {
                    "name": "te-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Kore": {
                    "name": "te-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Laomedeia": {
                    "name": "te-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Leda": {
                    "name": "te-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Orus": {
                    "name": "te-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Puck": {
                    "name": "te-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Pulcherrima": {
                    "name": "te-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Rasalgethi": {
                    "name": "te-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Sadachbia": {
                    "name": "te-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Sadaltager": {
                    "name": "te-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Schedar": {
                    "name": "te-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Sulafat": {
                    "name": "te-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Umbriel": {
                    "name": "te-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "te-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Zephyr": {
                    "name": "te-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "te-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Standard-A": {
                    "name": "te-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Standard-B": {
                    "name": "te-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Standard-C": {
                    "name": "te-IN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "te-IN-Standard-D": {
                    "name": "te-IN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "te",
                        "te-IN"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Achernar": {
                    "name": "th-TH-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Achird": {
                    "name": "th-TH-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Algenib": {
                    "name": "th-TH-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Algieba": {
                    "name": "th-TH-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Alnilam": {
                    "name": "th-TH-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Aoede": {
                    "name": "th-TH-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Autonoe": {
                    "name": "th-TH-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Callirrhoe": {
                    "name": "th-TH-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Charon": {
                    "name": "th-TH-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Despina": {
                    "name": "th-TH-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Enceladus": {
                    "name": "th-TH-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Erinome": {
                    "name": "th-TH-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Fenrir": {
                    "name": "th-TH-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Gacrux": {
                    "name": "th-TH-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Iapetus": {
                    "name": "th-TH-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Kore": {
                    "name": "th-TH-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Laomedeia": {
                    "name": "th-TH-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Leda": {
                    "name": "th-TH-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Orus": {
                    "name": "th-TH-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Puck": {
                    "name": "th-TH-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Pulcherrima": {
                    "name": "th-TH-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Rasalgethi": {
                    "name": "th-TH-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Sadachbia": {
                    "name": "th-TH-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Sadaltager": {
                    "name": "th-TH-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Schedar": {
                    "name": "th-TH-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Sulafat": {
                    "name": "th-TH-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Umbriel": {
                    "name": "th-TH-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Vindemiatrix": {
                    "name": "th-TH-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Zephyr": {
                    "name": "th-TH-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Chirp3-HD-Zubenelgenubi": {
                    "name": "th-TH-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Neural2-C": {
                    "name": "th-TH-Neural2-C",
                    "costMultiplier": 4,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "th-TH-Standard-A": {
                    "name": "th-TH-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "th",
                        "th-TH"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Achernar": {
                    "name": "tr-TR-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Achird": {
                    "name": "tr-TR-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Algenib": {
                    "name": "tr-TR-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Algieba": {
                    "name": "tr-TR-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Alnilam": {
                    "name": "tr-TR-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Aoede": {
                    "name": "tr-TR-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Autonoe": {
                    "name": "tr-TR-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Callirrhoe": {
                    "name": "tr-TR-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Charon": {
                    "name": "tr-TR-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Despina": {
                    "name": "tr-TR-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Enceladus": {
                    "name": "tr-TR-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Erinome": {
                    "name": "tr-TR-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Fenrir": {
                    "name": "tr-TR-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Gacrux": {
                    "name": "tr-TR-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Iapetus": {
                    "name": "tr-TR-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Kore": {
                    "name": "tr-TR-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Laomedeia": {
                    "name": "tr-TR-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Leda": {
                    "name": "tr-TR-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Orus": {
                    "name": "tr-TR-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Puck": {
                    "name": "tr-TR-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Pulcherrima": {
                    "name": "tr-TR-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Rasalgethi": {
                    "name": "tr-TR-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Sadachbia": {
                    "name": "tr-TR-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Sadaltager": {
                    "name": "tr-TR-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Schedar": {
                    "name": "tr-TR-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Sulafat": {
                    "name": "tr-TR-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Umbriel": {
                    "name": "tr-TR-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Vindemiatrix": {
                    "name": "tr-TR-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Zephyr": {
                    "name": "tr-TR-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Chirp3-HD-Zubenelgenubi": {
                    "name": "tr-TR-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Standard-A": {
                    "name": "tr-TR-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Standard-B": {
                    "name": "tr-TR-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Standard-C": {
                    "name": "tr-TR-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Standard-D": {
                    "name": "tr-TR-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Standard-E": {
                    "name": "tr-TR-Standard-E",
                    "costMultiplier": 1,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Wavenet-A": {
                    "name": "tr-TR-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Wavenet-B": {
                    "name": "tr-TR-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Wavenet-C": {
                    "name": "tr-TR-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Wavenet-D": {
                    "name": "tr-TR-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "tr-TR-Wavenet-E": {
                    "name": "tr-TR-Wavenet-E",
                    "costMultiplier": 4,
                    "languages": [
                        "tr",
                        "tr-TR"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Achernar": {
                    "name": "uk-UA-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Achird": {
                    "name": "uk-UA-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Algenib": {
                    "name": "uk-UA-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Algieba": {
                    "name": "uk-UA-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Alnilam": {
                    "name": "uk-UA-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Aoede": {
                    "name": "uk-UA-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Autonoe": {
                    "name": "uk-UA-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Callirrhoe": {
                    "name": "uk-UA-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Charon": {
                    "name": "uk-UA-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Despina": {
                    "name": "uk-UA-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Enceladus": {
                    "name": "uk-UA-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Erinome": {
                    "name": "uk-UA-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Fenrir": {
                    "name": "uk-UA-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Gacrux": {
                    "name": "uk-UA-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Iapetus": {
                    "name": "uk-UA-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Kore": {
                    "name": "uk-UA-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Laomedeia": {
                    "name": "uk-UA-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Leda": {
                    "name": "uk-UA-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Orus": {
                    "name": "uk-UA-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Puck": {
                    "name": "uk-UA-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Pulcherrima": {
                    "name": "uk-UA-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Rasalgethi": {
                    "name": "uk-UA-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Sadachbia": {
                    "name": "uk-UA-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Sadaltager": {
                    "name": "uk-UA-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Schedar": {
                    "name": "uk-UA-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Sulafat": {
                    "name": "uk-UA-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Umbriel": {
                    "name": "uk-UA-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Vindemiatrix": {
                    "name": "uk-UA-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Zephyr": {
                    "name": "uk-UA-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Chirp3-HD-Zubenelgenubi": {
                    "name": "uk-UA-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Standard-B": {
                    "name": "uk-UA-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "uk-UA-Wavenet-B": {
                    "name": "uk-UA-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "uk",
                        "uk-UA"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Achernar": {
                    "name": "ur-IN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Achird": {
                    "name": "ur-IN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Algenib": {
                    "name": "ur-IN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Algieba": {
                    "name": "ur-IN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Alnilam": {
                    "name": "ur-IN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Aoede": {
                    "name": "ur-IN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Autonoe": {
                    "name": "ur-IN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Callirrhoe": {
                    "name": "ur-IN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Charon": {
                    "name": "ur-IN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Despina": {
                    "name": "ur-IN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Enceladus": {
                    "name": "ur-IN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Erinome": {
                    "name": "ur-IN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Fenrir": {
                    "name": "ur-IN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Gacrux": {
                    "name": "ur-IN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Iapetus": {
                    "name": "ur-IN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Kore": {
                    "name": "ur-IN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Laomedeia": {
                    "name": "ur-IN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Leda": {
                    "name": "ur-IN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Orus": {
                    "name": "ur-IN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Puck": {
                    "name": "ur-IN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Pulcherrima": {
                    "name": "ur-IN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Rasalgethi": {
                    "name": "ur-IN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Sadachbia": {
                    "name": "ur-IN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Sadaltager": {
                    "name": "ur-IN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Schedar": {
                    "name": "ur-IN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Sulafat": {
                    "name": "ur-IN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Umbriel": {
                    "name": "ur-IN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Vindemiatrix": {
                    "name": "ur-IN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Zephyr": {
                    "name": "ur-IN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Chirp3-HD-Zubenelgenubi": {
                    "name": "ur-IN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Standard-A": {
                    "name": "ur-IN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Standard-B": {
                    "name": "ur-IN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Wavenet-A": {
                    "name": "ur-IN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "ur-IN-Wavenet-B": {
                    "name": "ur-IN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "ur",
                        "ur-IN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Achernar": {
                    "name": "vi-VN-Chirp3-HD-Achernar",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Achird": {
                    "name": "vi-VN-Chirp3-HD-Achird",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Algenib": {
                    "name": "vi-VN-Chirp3-HD-Algenib",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Algieba": {
                    "name": "vi-VN-Chirp3-HD-Algieba",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Alnilam": {
                    "name": "vi-VN-Chirp3-HD-Alnilam",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Aoede": {
                    "name": "vi-VN-Chirp3-HD-Aoede",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Autonoe": {
                    "name": "vi-VN-Chirp3-HD-Autonoe",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Callirrhoe": {
                    "name": "vi-VN-Chirp3-HD-Callirrhoe",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Charon": {
                    "name": "vi-VN-Chirp3-HD-Charon",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Despina": {
                    "name": "vi-VN-Chirp3-HD-Despina",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Enceladus": {
                    "name": "vi-VN-Chirp3-HD-Enceladus",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Erinome": {
                    "name": "vi-VN-Chirp3-HD-Erinome",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Fenrir": {
                    "name": "vi-VN-Chirp3-HD-Fenrir",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Gacrux": {
                    "name": "vi-VN-Chirp3-HD-Gacrux",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Iapetus": {
                    "name": "vi-VN-Chirp3-HD-Iapetus",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Kore": {
                    "name": "vi-VN-Chirp3-HD-Kore",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Laomedeia": {
                    "name": "vi-VN-Chirp3-HD-Laomedeia",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Leda": {
                    "name": "vi-VN-Chirp3-HD-Leda",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Orus": {
                    "name": "vi-VN-Chirp3-HD-Orus",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Puck": {
                    "name": "vi-VN-Chirp3-HD-Puck",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Pulcherrima": {
                    "name": "vi-VN-Chirp3-HD-Pulcherrima",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Rasalgethi": {
                    "name": "vi-VN-Chirp3-HD-Rasalgethi",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Sadachbia": {
                    "name": "vi-VN-Chirp3-HD-Sadachbia",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Sadaltager": {
                    "name": "vi-VN-Chirp3-HD-Sadaltager",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Schedar": {
                    "name": "vi-VN-Chirp3-HD-Schedar",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Sulafat": {
                    "name": "vi-VN-Chirp3-HD-Sulafat",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Umbriel": {
                    "name": "vi-VN-Chirp3-HD-Umbriel",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Vindemiatrix": {
                    "name": "vi-VN-Chirp3-HD-Vindemiatrix",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Zephyr": {
                    "name": "vi-VN-Chirp3-HD-Zephyr",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Chirp3-HD-Zubenelgenubi": {
                    "name": "vi-VN-Chirp3-HD-Zubenelgenubi",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Neural2-A": {
                    "name": "vi-VN-Neural2-A",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Neural2-D": {
                    "name": "vi-VN-Neural2-D",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Standard-A": {
                    "name": "vi-VN-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Standard-B": {
                    "name": "vi-VN-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Standard-C": {
                    "name": "vi-VN-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Standard-D": {
                    "name": "vi-VN-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Wavenet-A": {
                    "name": "vi-VN-Wavenet-A",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Wavenet-B": {
                    "name": "vi-VN-Wavenet-B",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Wavenet-C": {
                    "name": "vi-VN-Wavenet-C",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "vi-VN-Wavenet-D": {
                    "name": "vi-VN-Wavenet-D",
                    "costMultiplier": 4,
                    "languages": [
                        "vi",
                        "vi-VN"
                    ],
                    "replaced": false
                },
                "yue-HK-Standard-A": {
                    "name": "yue-HK-Standard-A",
                    "costMultiplier": 1,
                    "languages": [
                        "yue",
                        "yue-HK"
                    ],
                    "replaced": false
                },
                "yue-HK-Standard-B": {
                    "name": "yue-HK-Standard-B",
                    "costMultiplier": 1,
                    "languages": [
                        "yue",
                        "yue-HK"
                    ],
                    "replaced": false
                },
                "yue-HK-Standard-C": {
                    "name": "yue-HK-Standard-C",
                    "costMultiplier": 1,
                    "languages": [
                        "yue",
                        "yue-HK"
                    ],
                    "replaced": false
                },
                "yue-HK-Standard-D": {
                    "name": "yue-HK-Standard-D",
                    "costMultiplier": 1,
                    "languages": [
                        "yue",
                        "yue-HK"
                    ],
                    "replaced": false
                }
            },
            "languages": [
                "af",
                "af-ZA",
                "am",
                "am-ET",
                "ar",
                "ar-XA",
                "bg",
                "bg-BG",
                "bn",
                "bn-IN",
                "ca",
                "ca-ES",
                "cmn",
                "cmn-CN",
                "cmn-TW",
                "cs",
                "cs-CZ",
                "da",
                "da-DK",
                "de",
                "de-DE",
                "el",
                "el-GR",
                "en",
                "en-AU",
                "en-GB",
                "en-IN",
                "en-US",
                "es",
                "es-ES",
                "es-US",
                "et",
                "et-EE",
                "eu",
                "eu-ES",
                "fi",
                "fi-FI",
                "fil",
                "fil-PH",
                "fr",
                "fr-CA",
                "fr-FR",
                "gl",
                "gl-ES",
                "gu",
                "gu-IN",
                "he",
                "he-IL",
                "hi",
                "hi-IN",
                "hu",
                "hu-HU",
                "id",
                "id-ID",
                "is",
                "is-IS",
                "it",
                "it-IT",
                "ja",
                "ja-JP",
                "kn",
                "kn-IN",
                "ko",
                "ko-KR",
                "lt",
                "lt-LT",
                "lv",
                "lv-LV",
                "ml",
                "ml-IN",
                "mr",
                "mr-IN",
                "ms",
                "ms-MY",
                "nb",
                "nb-NO",
                "nl",
                "nl-BE",
                "nl-NL",
                "pa",
                "pa-IN",
                "pl",
                "pl-PL",
                "pt",
                "pt-BR",
                "pt-PT",
                "ro",
                "ro-RO",
                "ru",
                "ru-RU",
                "sk",
                "sk-SK",
                "sr",
                "sr-RS",
                "sv",
                "sv-SE",
                "sw",
                "sw-KE",
                "ta",
                "ta-IN",
                "te",
                "te-IN",
                "th",
                "th-TH",
                "tr",
                "tr-TR",
                "uk",
                "uk-UA",
                "ur",
                "ur-IN",
                "vi",
                "vi-VN",
                "yue",
                "yue-HK"
            ],
            "type": "SPEECH",
            "defaultVoices": {
                "af": "af-ZA-Standard-A",
                "af-ZA": "af-ZA-Standard-A",
                "ar": "ar-XA-Wavenet-A",
                "ar-XA": "ar-XA-Wavenet-A",
                "bg": "bg-BG-Standard-B",
                "bg-BG": "bg-BG-Standard-B",
                "ca": "ca-ES-Standard-B",
                "ca-ES": "ca-ES-Standard-B",
                "cs": "cs-CZ-Wavenet-B",
                "cs-CZ": "cs-CZ-Wavenet-B",
                "da": "da-DK-Neural2-F",
                "da-DK": "da-DK-Neural2-F",
                "de": "de-DE-Neural2-H",
                "de-DE": "de-DE-Neural2-H",
                "el": "el-GR-Wavenet-B",
                "el-GR": "el-GR-Wavenet-B",
                "en": "en-US-Wavenet-F",
                "en-GB": "en-GB-Wavenet-N",
                "en-US": "en-US-Wavenet-F",
                "es": "es-ES-Neural2-H",
                "es-ES": "es-ES-Neural2-H",
                "es-US": "es-US-Wavenet-C",
                "fi": "fi-FI-Wavenet-B",
                "fi-FI": "fi-FI-Wavenet-B",
                "fr": "fr-FR-Neural2-F",
                "fr-CA": "fr-CA-Wavenet-B",
                "fr-FR": "fr-FR-Neural2-F",
                "hu": "hu-HU-Wavenet-B",
                "hu-HU": "hu-HU-Wavenet-B",
                "is": "is-IS-Standard-B",
                "is-IS": "is-IS-Standard-B",
                "it": "it-IT-Neural2-F",
                "it-IT": "it-IT-Neural2-F",
                "lt": "lt-LT-Standard-B",
                "lt-LT": "lt-LT-Standard-B",
                "lv": "lv-LV-Standard-B",
                "lv-LV": "lv-LV-Standard-B",
                "nb": "nb-NO-Wavenet-G",
                "nb-NO": "nb-NO-Wavenet-G",
                "nl": "nl-NL-Wavenet-F",
                "nl-NL": "nl-NL-Wavenet-F",
                "pl": "pl-PL-Wavenet-F",
                "pl-PL": "pl-PL-Wavenet-F",
                "pt": "pt-PT-Wavenet-F",
                "pt-BR": "pt-BR-Wavenet-B",
                "pt-PT": "pt-PT-Wavenet-F",
                "ro": "ro-RO-Standard-B",
                "ro-RO": "ro-RO-Standard-B",
                "ru": "ru-RU-Wavenet-D",
                "ru-RU": "ru-RU-Wavenet-D",
                "sr": "sr-RS-Standard-B",
                "sr-RS": "sr-RS-Standard-B",
                "sv": "sv-SE-Wavenet-F",
                "sv-SE": "sv-SE-Wavenet-F",
                "tr": "tr-TR-Wavenet-D",
                "tr-TR": "tr-TR-Wavenet-D",
                "uk": "uk-UA-Standard-B",
                "uk-UA": "uk-UA-Standard-B",
                "vi": "vi-VN-Neural2-A",
                "vi-VN": "vi-VN-Neural2-A"
            }
        },
        "svg-repo user interface": {
            "canonicalName": "svg-repo user interface",
            "names": [
                "svg-repo user interface",
                "svg-repo-ui"
            ],
            "languages": [
                "de",
                "en"
            ],
            "type": "I18N"
        },
        "svg-repo graphics": {
            "canonicalName": "svg-repo graphics",
            "names": [
                "svg-repo graphics",
                "svg-repo-graphics"
            ],
            "languages": [
                "af",
                "af-ZA",
                "ar",
                "ar-XA",
                "bg",
                "bg-BG",
                "ca",
                "ca-ES",
                "cs",
                "cs-CZ",
                "da",
                "da-DK",
                "de",
                "de-DE",
                "el",
                "el-GR",
                "en",
                "en-GB",
                "en-US",
                "es",
                "es-ES",
                "es-US",
                "fi",
                "fi-FI",
                "fr",
                "fr-CA",
                "fr-FR",
                "hu",
                "hu-HU",
                "is",
                "is-IS",
                "it",
                "it-IT",
                "lt",
                "lt-LT",
                "lv",
                "lv-LV",
                "nb",
                "nb-NO",
                "nl",
                "nl-NL",
                "pl",
                "pl-PL",
                "pt",
                "pt-BR",
                "pt-PT",
                "ro",
                "ro-RO",
                "ru",
                "ru-RU",
                "sr",
                "sr-RS",
                "sv",
                "sv-SE",
                "tr",
                "tr-TR",
                "uk",
                "uk-UA",
                "vi",
                "vi-VN"
            ],
            "type": "OTHER"
        },
        "tactonom-reader canned text system message service": {
            "canonicalName": "tactonom-reader canned text system message service",
            "names": [
                "tactonom-reader canned text system message service",
                "reader-canned-text"
            ],
            "languages": [
                "af-ZA",
                "cs-CZ",
                "da-DK",
                "de-DE",
                "en-US",
                "es-ES",
                "fr-FR",
                "hu-HU",
                "lt-LT",
                "lv-LV",
                "nb-NO",
                "nl-NL",
                "pl-PL",
                "pt-PT",
                "ru-RU",
                "sr-RS",
                "uk-UA"
            ],
            "type": "I18N"
        },
        "liblouis braille translator": {
            "canonicalName": "liblouis braille translator",
            "names": [
                "liblouis braille translator",
                "liblouis"
            ],
            "languages": [
                "af",
                "ar",
                "as",
                "aw",
                "awa",
                "ba",
                "be",
                "bg",
                "bh",
                "bn",
                "bo",
                "br",
                "bra",
                "ca",
                "chr",
                "ckb",
                "cmn-CN",
                "cmn-TW",
                "cop",
                "cs",
                "cy",
                "da",
                "de",
                "dra",
                "el",
                "en",
                "en-CA",
                "en-GB",
                "en-US",
                "eo",
                "es",
                "et",
                "fa",
                "fi",
                "fr",
                "ga",
                "gd",
                "gez",
                "gon",
                "gr",
                "grc",
                "gu",
                "haw",
                "hbo",
                "he",
                "hi",
                "hr",
                "hu",
                "hy",
                "ipa",
                "is",
                "it",
                "iu",
                "ja",
                "ka",
                "kh",
                "kha",
                "kk",
                "km",
                "kmr",
                "kn",
                "ko",
                "kok",
                "kru",
                "ks",
                "lg",
                "lo",
                "lt",
                "lv",
                "mi",
                "ml",
                "mn",
                "mni",
                "mr",
                "ms",
                "mt",
                "mul-IL",
                "mun",
                "mwr",
                "my",
                "nb",
                "ne",
                "nl",
                "nn",
                "np",
                "nso",
                "ny",
                "or",
                "pa",
                "pi",
                "pl",
                "pt",
                "pu",
                "ro",
                "ru",
                "rw",
                "sa",
                "sah",
                "sd",
                "se",
                "si",
                "sin",
                "sk",
                "sl",
                "sr",
                "st",
                "sv",
                "sw-KE",
                "syr",
                "ta",
                "te",
                "th",
                "tlg",
                "tn",
                "tr",
                "tt",
                "uga",
                "uk",
                "uni",
                "ur",
                "us",
                "uz",
                "ve",
                "vi",
                "xh",
                "xlu",
                "yi",
                "yue-HK",
                "zh",
                "zu"
            ],
            "type": "BRAILLE",
            "translationTables": {
                "Es-Es-G0.utb": {
                    "filename": "Es-Es-G0.utb",
                    "displayName": "Spanish computer braille",
                    "indexName": "Spanish, computer",
                    "computer": true,
                    "language": "es"
                },
                "IPA-unicode-range.uti": {
                    "filename": "IPA-unicode-range.uti",
                    "computer": false,
                    "language": "ipa"
                },
                "IPA.utb": {
                    "filename": "IPA.utb",
                    "computer": false,
                    "language": "ipa"
                },
                "Lv-Lv-g1.utb": {
                    "filename": "Lv-Lv-g1.utb",
                    "computer": false,
                    "language": "lv"
                },
                "Pl-Pl-g1.utb": {
                    "filename": "Pl-Pl-g1.utb",
                    "computer": false,
                    "language": "pl"
                },
                "afr-za-g1.ctb": {
                    "filename": "afr-za-g1.ctb",
                    "displayName": "Afrikaans uncontracted braille",
                    "nativeName": "Afrikaans onverkort",
                    "indexName": "Afrikaans, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "af",
                    "contraction": "no"
                },
                "afr-za-g2.ctb": {
                    "filename": "afr-za-g2.ctb",
                    "displayName": "Afrikaans contracted braille",
                    "nativeName": "Afrikaans verkort",
                    "indexName": "Afrikaans, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "af",
                    "contraction": "full"
                },
                "akk-borger.utb": {
                    "filename": "akk-borger.utb",
                    "displayName": "Akkadian braille according to Borger system",
                    "indexName": "Akkadian, Borger",
                    "computer": false,
                    "dots": 6,
                    "language": "xlu",
                    "contraction": "no"
                },
                "akk.utb": {
                    "filename": "akk.utb",
                    "displayName": "Akkadian braille according to U.S. system",
                    "indexName": "Akkadian, U.S.",
                    "computer": false,
                    "dots": 6,
                    "language": "xlu",
                    "contraction": "no"
                },
                "ar-ar-comp8.utb": {
                    "filename": "ar-ar-comp8.utb",
                    "displayName": "Arabic computer braille",
                    "indexName": "Arabic, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "ar"
                },
                "ar-ar-g1-core.uti": {
                    "filename": "ar-ar-g1-core.uti",
                    "computer": false,
                    "language": "ar"
                },
                "ar-ar-g1.utb": {
                    "filename": "ar-ar-g1.utb",
                    "computer": false,
                    "language": "ar"
                },
                "ar-ar-g2.ctb": {
                    "filename": "ar-ar-g2.ctb",
                    "displayName": "Arabic contracted braille",
                    "indexName": "Arabic, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "ar",
                    "contraction": "full"
                },
                "ar-ar-math.uti": {
                    "filename": "ar-ar-math.uti",
                    "computer": false,
                    "language": "ar"
                },
                "ar.tbl": {
                    "filename": "ar.tbl",
                    "displayName": "Arabic uncontracted braille",
                    "indexName": "Arabic, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "ar",
                    "contraction": "no"
                },
                "as-in-g1.utb": {
                    "filename": "as-in-g1.utb",
                    "computer": false,
                    "language": "as"
                },
                "as.tbl": {
                    "filename": "as.tbl",
                    "displayName": "Assamese braille",
                    "indexName": "Assamese",
                    "computer": false,
                    "grade": "1",
                    "language": "as"
                },
                "aw-in-g1.utb": {
                    "filename": "aw-in-g1.utb",
                    "computer": false,
                    "language": "aw"
                },
                "awa.tbl": {
                    "filename": "awa.tbl",
                    "displayName": "Awadhi braille",
                    "indexName": "Awadhi",
                    "computer": false,
                    "grade": "1",
                    "language": "awa"
                },
                "ba.utb": {
                    "filename": "ba.utb",
                    "displayName": "Bashkir braille",
                    "indexName": "Bashkir",
                    "computer": false,
                    "language": "ba"
                },
                "be-in-g1.utb": {
                    "filename": "be-in-g1.utb",
                    "computer": false,
                    "language": "be"
                },
                "bel-comp.utb": {
                    "filename": "bel-comp.utb",
                    "displayName": "Belarusian computer braille",
                    "indexName": "Belarusian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "be"
                },
                "bel-detailed.utb": {
                    "filename": "bel-detailed.utb",
                    "displayName": "Belarusian braille with indication of capitals",
                    "indexName": "Belarusian, with capitals",
                    "computer": false,
                    "dots": 6,
                    "language": "be",
                    "contraction": "no"
                },
                "bel.utb": {
                    "filename": "bel.utb",
                    "displayName": "Belarusian braille",
                    "indexName": "Belarusian",
                    "computer": false,
                    "dots": 6,
                    "language": "be",
                    "contraction": "no"
                },
                "bengali.cti": {
                    "filename": "bengali.cti",
                    "computer": false
                },
                "bg.ctb": {
                    "filename": "bg.ctb",
                    "computer": false,
                    "language": "bg"
                },
                "bg.dis": {
                    "filename": "bg.dis",
                    "computer": false,
                    "language": "bg"
                },
                "bg.tbl": {
                    "filename": "bg.tbl",
                    "displayName": "Bulgarian computer braille",
                    "indexName": "Bulgarian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "bg"
                },
                "bg.utb": {
                    "filename": "bg.utb",
                    "displayName": "Bulgarian braille",
                    "indexName": "Bulgarian",
                    "computer": false,
                    "dots": 6,
                    "language": "bg",
                    "contraction": "no"
                },
                "bh.ctb": {
                    "filename": "bh.ctb",
                    "computer": false,
                    "language": "bh"
                },
                "bh.tbl": {
                    "filename": "bh.tbl",
                    "displayName": "Bihari braille",
                    "indexName": "Bihari",
                    "computer": false,
                    "language": "bh"
                },
                "bn.tbl": {
                    "filename": "bn.tbl",
                    "displayName": "Bengali braille",
                    "indexName": "Bengali",
                    "computer": false,
                    "grade": "1",
                    "language": "bn"
                },
                "bo.ctb": {
                    "filename": "bo.ctb",
                    "computer": false,
                    "language": "bo"
                },
                "bo.tbl": {
                    "filename": "bo.tbl",
                    "displayName": "Tibetan computer braille",
                    "indexName": "Tibetan, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "bo"
                },
                "boxes.ctb": {
                    "filename": "boxes.ctb",
                    "computer": false
                },
                "br-in-g1.utb": {
                    "filename": "br-in-g1.utb",
                    "computer": false,
                    "language": "br"
                },
                "bra.tbl": {
                    "filename": "bra.tbl",
                    "displayName": "Braj braille",
                    "indexName": "Braj",
                    "computer": false,
                    "grade": "1",
                    "language": "bra"
                },
                "braille-patterns.cti": {
                    "filename": "braille-patterns.cti",
                    "computer": false
                },
                "ca-chardefs.cti": {
                    "filename": "ca-chardefs.cti",
                    "computer": false,
                    "language": "ca"
                },
                "ca-g1.ctb": {
                    "filename": "ca-g1.ctb",
                    "computer": false,
                    "language": "ca"
                },
                "ca.tbl": {
                    "filename": "ca.tbl",
                    "displayName": "Catalan braille",
                    "indexName": "Catalan",
                    "computer": false,
                    "grade": "1",
                    "language": "ca"
                },
                "chr-us-g1.ctb": {
                    "filename": "chr-us-g1.ctb",
                    "displayName": "Cherokee braille",
                    "indexName": "Cherokee",
                    "computer": false,
                    "grade": "1",
                    "language": "chr",
                    "contraction": "no"
                },
                "ckb-chardefs.cti": {
                    "filename": "ckb-chardefs.cti",
                    "computer": false,
                    "language": "ckb"
                },
                "ckb-g1.ctb": {
                    "filename": "ckb-g1.ctb",
                    "computer": false,
                    "language": "ckb"
                },
                "ckb-translation.cti": {
                    "filename": "ckb-translation.cti",
                    "computer": false,
                    "language": "ckb"
                },
                "ckb.tbl": {
                    "filename": "ckb.tbl",
                    "displayName": "Kurdish braille",
                    "indexName": "Kurdish",
                    "computer": false,
                    "grade": "1",
                    "language": "ckb"
                },
                "compress.cti": {
                    "filename": "compress.cti",
                    "computer": false
                },
                "controlchars.cti": {
                    "filename": "controlchars.cti",
                    "computer": false
                },
                "cop-eg-comp8.utb": {
                    "filename": "cop-eg-comp8.utb",
                    "displayName": "Coptic computer braille",
                    "indexName": "Coptic, computer ",
                    "computer": true,
                    "dots": 8,
                    "updated": "Mon Aug 31 00:00:00 CEST 2020",
                    "language": "cop"
                },
                "corrections.cti": {
                    "filename": "corrections.cti",
                    "computer": false
                },
                "countries.cti": {
                    "filename": "countries.cti",
                    "computer": false
                },
                "cs-chardefs.cti": {
                    "filename": "cs-chardefs.cti",
                    "computer": false,
                    "language": "cs"
                },
                "cs-comp8.utb": {
                    "filename": "cs-comp8.utb",
                    "displayName": "Czech computer braille",
                    "indexName": "Czech, computer",
                    "computer": true,
                    "grade": "0",
                    "dots": 8,
                    "language": "cs"
                },
                "cs-g1.ctb": {
                    "filename": "cs-g1.ctb",
                    "computer": false,
                    "language": "cs"
                },
                "cs-translation.cti": {
                    "filename": "cs-translation.cti",
                    "computer": false,
                    "language": "cs"
                },
                "cs.tbl": {
                    "filename": "cs.tbl",
                    "displayName": "Czech braille",
                    "indexName": "Czech",
                    "computer": false,
                    "grade": "1",
                    "language": "cs"
                },
                "cuneiform-transliterated.utb": {
                    "filename": "cuneiform-transliterated.utb",
                    "displayName": "Transliterated Cuneiform braille",
                    "indexName": "Cuneiform, transliterated",
                    "computer": false,
                    "dots": 6,
                    "language": "xlu",
                    "contraction": "no"
                },
                "cy-cy-g1.utb": {
                    "filename": "cy-cy-g1.utb",
                    "displayName": "Welsh uncontracted braille",
                    "indexName": "Welsh, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "cy",
                    "contraction": "no"
                },
                "cy-cy-g2.ctb": {
                    "filename": "cy-cy-g2.ctb",
                    "computer": false,
                    "language": "cy"
                },
                "cy.tbl": {
                    "filename": "cy.tbl",
                    "displayName": "Welsh contracted braille",
                    "indexName": "Welsh, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "cy",
                    "contraction": "full"
                },
                "da-dk-6miscChars.cti": {
                    "filename": "da-dk-6miscChars.cti",
                    "computer": false,
                    "language": "da"
                },
                "da-dk-6miscChars_1993.cti": {
                    "filename": "da-dk-6miscChars_1993.cti",
                    "computer": false,
                    "language": "da"
                },
                "da-dk-8miscChars.cti": {
                    "filename": "da-dk-8miscChars.cti",
                    "computer": false,
                    "language": "da"
                },
                "da-dk-8miscChars_1993.cti": {
                    "filename": "da-dk-8miscChars_1993.cti",
                    "computer": false,
                    "language": "da"
                },
                "da-dk-g08.ctb": {
                    "filename": "da-dk-g08.ctb",
                    "displayName": "Danish computer braille (2022 standard)",
                    "nativeName": "Dansk computer 2022",
                    "indexName": "Danish, computer, 2022",
                    "computer": true,
                    "grade": "0",
                    "dots": 8,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g08_1993.ctb": {
                    "filename": "da-dk-g08_1993.ctb",
                    "displayName": "Danish computer braille (1993 standard)",
                    "nativeName": "Dansk computer 1993",
                    "indexName": "Danish, computer, 1993",
                    "computer": true,
                    "grade": "0",
                    "dots": 8,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g16-lit_1993.ctb": {
                    "filename": "da-dk-g16-lit_1993.ctb",
                    "displayName": "Danish 6-dot uncontracted braille (1993 standard)",
                    "nativeName": "Dansk fuldskrift 6-punkt 1993",
                    "indexName": "Danish, uncontracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g16.ctb": {
                    "filename": "da-dk-g16.ctb",
                    "displayName": "Danish 6-dot uncontracted braille (2022 standard)",
                    "nativeName": "Dansk fuldskrift 6-punkt 2022",
                    "indexName": "Danish, uncontracted, 6-dot, 2022",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g16_1993.ctb": {
                    "filename": "da-dk-g16_1993.ctb",
                    "displayName": "Danish 6-dot uncontracted braille (1993 standard)",
                    "nativeName": "Dansk fuldskrift 6-punkt 1993",
                    "indexName": "Danish, uncontracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g18.ctb": {
                    "filename": "da-dk-g18.ctb",
                    "displayName": "Danish 8-dot uncontracted braille (2022 standard)",
                    "nativeName": "Dansk fuldskrift 8-punkt 2022",
                    "indexName": "Danish, uncontracted, 8-dot, 2022",
                    "computer": false,
                    "grade": "1",
                    "dots": 8,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g18_1993.ctb": {
                    "filename": "da-dk-g18_1993.ctb",
                    "displayName": "Danish 8-dot uncontracted braille (1993 standard)",
                    "nativeName": "Dansk fuldskrift 8-punkt 1993",
                    "indexName": "Danish, uncontracted, 8-dot, 1993",
                    "computer": false,
                    "grade": "1",
                    "dots": 8,
                    "language": "da",
                    "contraction": "no"
                },
                "da-dk-g26-lit_1993.ctb": {
                    "filename": "da-dk-g26-lit_1993.ctb",
                    "displayName": "Danish 6-dot contracted braille (1993 standard)",
                    "nativeName": "Dansk forkortet 6-punkt 1993",
                    "indexName": "Danish, contracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "da",
                    "contraction": "full"
                },
                "da-dk-g26.ctb": {
                    "filename": "da-dk-g26.ctb",
                    "displayName": "Danish 6-dot contracted braille (2022 standard)",
                    "nativeName": "Dansk forkortet 6-punkt 2022",
                    "indexName": "Danish, contracted, 6-dot, 2022",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "da",
                    "contraction": "full"
                },
                "da-dk-g26_1993.ctb": {
                    "filename": "da-dk-g26_1993.ctb",
                    "displayName": "Danish 6-dot contracted braille (1993 standard)",
                    "nativeName": "Dansk forkortet 6-punkt 1993",
                    "indexName": "Danish, contracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "da",
                    "contraction": "full"
                },
                "da-dk-g26l-lit_1993.ctb": {
                    "filename": "da-dk-g26l-lit_1993.ctb",
                    "displayName": "Danish 6-dot partially contracted braille (1993 standard)",
                    "nativeName": "Dansk lille forkortelse 6-punkt litterær 1993",
                    "indexName": "Danish, partially contracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "1.5",
                    "dots": 6,
                    "language": "da",
                    "contraction": "partial"
                },
                "da-dk-g26l_1993.ctb": {
                    "filename": "da-dk-g26l_1993.ctb",
                    "displayName": "Danish 6-dot partially contracted braille (1993 standard)",
                    "nativeName": "Dansk lille forkortelse 1993",
                    "indexName": "Danish, partially contracted, 6-dot, 1993",
                    "computer": false,
                    "grade": "1.5",
                    "dots": 6,
                    "language": "da",
                    "contraction": "partial"
                },
                "da-dk-g28.ctb": {
                    "filename": "da-dk-g28.ctb",
                    "displayName": "Danish 8-dot contracted braille (2022 standard)",
                    "nativeName": "Dansk forkortet 8-punkt 2022",
                    "indexName": "Danish, contracted, 8-dot, 2022",
                    "computer": false,
                    "grade": "2",
                    "dots": 8,
                    "language": "da",
                    "contraction": "full"
                },
                "da-dk-g28_1993.ctb": {
                    "filename": "da-dk-g28_1993.ctb",
                    "displayName": "Danish 8-dot contracted braille (1993 standard)",
                    "nativeName": "Dansk forkortet 8-punkt 1993",
                    "indexName": "Danish, contracted, 8-dot, 1993",
                    "computer": false,
                    "grade": "2",
                    "dots": 8,
                    "language": "da",
                    "contraction": "full"
                },
                "da-dk-g28l_1993.ctb": {
                    "filename": "da-dk-g28l_1993.ctb",
                    "displayName": "Danish 8-dot partially contracted braille (1993 standard)",
                    "nativeName": "Dansk lille forkortelse 8-punkt 1993",
                    "indexName": "Danish, partially contracted, 8-dot, 1993",
                    "computer": false,
                    "grade": "1.5",
                    "dots": 8,
                    "language": "da",
                    "contraction": "partial"
                },
                "da-dk-octobraille.dis": {
                    "filename": "da-dk-octobraille.dis",
                    "computer": false,
                    "language": "da"
                },
                "da-dk-octobraille_1993.dis": {
                    "filename": "da-dk-octobraille_1993.dis",
                    "computer": false,
                    "language": "da"
                },
                "de-accents-detailed.cti": {
                    "filename": "de-accents-detailed.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-accents.cti": {
                    "filename": "de-accents.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-chardefs6.cti": {
                    "filename": "de-chardefs6.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-chardefs8.cti": {
                    "filename": "de-chardefs8.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-chess.ctb": {
                    "filename": "de-chess.ctb",
                    "computer": false,
                    "language": "de"
                },
                "de-comp6.utb": {
                    "filename": "de-comp6.utb",
                    "displayName": "German 6-dot computer braille",
                    "nativeName": "Deutsches 6-Punkte Computerbraille",
                    "indexName": "German, computer, 6-dot",
                    "computer": true,
                    "dots": 6,
                    "language": "de"
                },
                "de-de-comp8.ctb": {
                    "filename": "de-de-comp8.ctb",
                    "displayName": "German 8-dot computer braille",
                    "nativeName": "Eurobraille",
                    "indexName": "German, computer, 8-dot",
                    "computer": true,
                    "dots": 8,
                    "language": "de"
                },
                "de-de.dis": {
                    "filename": "de-de.dis",
                    "computer": false,
                    "language": "de"
                },
                "de-eurobrl6.dis": {
                    "filename": "de-eurobrl6.dis",
                    "computer": false,
                    "language": "de"
                },
                "de-eurobrl6u.dis": {
                    "filename": "de-eurobrl6u.dis",
                    "computer": false,
                    "language": "de"
                },
                "de-g0-core.uti": {
                    "filename": "de-g0-core.uti",
                    "computer": false,
                    "language": "de"
                },
                "de-g0-detailed.utb": {
                    "filename": "de-g0-detailed.utb",
                    "displayName": "German uncontracted braille with indication of capitals",
                    "nativeName": "Deutsche Basisschrift",
                    "indexName": "German, uncontracted, with capitals",
                    "computer": false,
                    "grade": "0",
                    "language": "de",
                    "contraction": "no"
                },
                "de-g0.utb": {
                    "filename": "de-g0.utb",
                    "displayName": "German uncontracted braille",
                    "nativeName": "Deutsche Basisschrift",
                    "indexName": "German, uncontracted",
                    "computer": false,
                    "grade": "0",
                    "language": "de",
                    "contraction": "no"
                },
                "de-g1-core.cti": {
                    "filename": "de-g1-core.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-g1-detailed.ctb": {
                    "filename": "de-g1-detailed.ctb",
                    "displayName": "German partially contracted braille with indication of capitals",
                    "nativeName": "Deutsche Vollschrift",
                    "indexName": "German, partially contracted, with capitals",
                    "computer": false,
                    "grade": "1",
                    "language": "de",
                    "contraction": "partial"
                },
                "de-g1.ctb": {
                    "filename": "de-g1.ctb",
                    "displayName": "German partially contracted braille",
                    "nativeName": "Deutsche Vollschrift",
                    "indexName": "German, partially contracted",
                    "computer": false,
                    "grade": "1",
                    "language": "de",
                    "contraction": "partial"
                },
                "de-g2-core.cti": {
                    "filename": "de-g2-core.cti",
                    "computer": false,
                    "language": "de"
                },
                "de-g2-detailed.ctb": {
                    "filename": "de-g2-detailed.ctb",
                    "displayName": "German contracted braille with indication of capitals",
                    "nativeName": "Deutsche Kurzschrift",
                    "indexName": "German, contracted, with capitals",
                    "computer": false,
                    "grade": "2",
                    "language": "de",
                    "contraction": "full"
                },
                "de-g2.ctb": {
                    "filename": "de-g2.ctb",
                    "displayName": "German contracted braille",
                    "nativeName": "Deutsche Kurzschrift",
                    "indexName": "German, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "de",
                    "contraction": "full"
                },
                "devanagari.cti": {
                    "filename": "devanagari.cti",
                    "computer": false
                },
                "digits6Dots.uti": {
                    "filename": "digits6Dots.uti",
                    "computer": false
                },
                "digits6DotsPlusDot6.uti": {
                    "filename": "digits6DotsPlusDot6.uti",
                    "computer": false
                },
                "digits8Dots.uti": {
                    "filename": "digits8Dots.uti",
                    "computer": false
                },
                "dra.ctb": {
                    "filename": "dra.ctb",
                    "computer": false,
                    "language": "dra"
                },
                "dra.tbl": {
                    "filename": "dra.tbl",
                    "displayName": "Dravidian computer braille",
                    "indexName": "Dravidian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "dra"
                },
                "el.ctb": {
                    "filename": "el.ctb",
                    "displayName": "Greek braille",
                    "nativeName": "ελληνικό σύστημα μπράιγ",
                    "indexName": "Greek",
                    "computer": false,
                    "dots": 6,
                    "language": "el",
                    "contraction": "full"
                },
                "en-GB-g2.ctb": {
                    "filename": "en-GB-g2.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-chardefs.cti": {
                    "filename": "en-chardefs.cti",
                    "computer": false,
                    "language": "en"
                },
                "en-chess.ctb": {
                    "filename": "en-chess.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-gb-comp8.ctb": {
                    "filename": "en-gb-comp8.ctb",
                    "displayName": "English computer braille as used in the U.K.",
                    "indexName": "English, U.K., computer",
                    "computer": true,
                    "dots": 8,
                    "language": "en-GB"
                },
                "en-gb-g1.utb": {
                    "filename": "en-gb-g1.utb",
                    "displayName": "English uncontracted braille as used in the U.K.",
                    "nativeName": "British English grade 1",
                    "indexName": "English, U.K., uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "en-GB",
                    "contraction": "no"
                },
                "en-in-g1.ctb": {
                    "filename": "en-in-g1.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-nabcc.utb": {
                    "filename": "en-nabcc.utb",
                    "displayName": "North American Braille Computer Code",
                    "indexName": "English, U.S., computer, NABCC",
                    "computer": true,
                    "dots": 8,
                    "language": "en"
                },
                "en-ueb-chardefs.uti": {
                    "filename": "en-ueb-chardefs.uti",
                    "computer": false,
                    "language": "en"
                },
                "en-ueb-g1.ctb": {
                    "filename": "en-ueb-g1.ctb",
                    "displayName": "Unified English uncontracted braille",
                    "nativeName": "Unified English braille, grade 1",
                    "indexName": "English, unified, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "en",
                    "contraction": "no"
                },
                "en-ueb-g2.ctb": {
                    "filename": "en-ueb-g2.ctb",
                    "displayName": "Unified English contracted braille",
                    "nativeName": "Unified English braille, grade 2",
                    "indexName": "English, unified, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "en",
                    "contraction": "full"
                },
                "en-ueb-math.ctb": {
                    "filename": "en-ueb-math.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-us-brf.dis": {
                    "filename": "en-us-brf.dis",
                    "computer": false,
                    "language": "en"
                },
                "en-us-comp6.ctb": {
                    "filename": "en-us-comp6.ctb",
                    "displayName": "English 6-dot computer braille as used in the U.S.",
                    "nativeName": "U.S. English Computer Braille Code (CBC)",
                    "indexName": "English, U.S., computer, 6-dot",
                    "computer": true,
                    "dots": 6,
                    "language": "en-US"
                },
                "en-us-comp8-ext.utb": {
                    "filename": "en-us-comp8-ext.utb",
                    "computer": false,
                    "language": "en"
                },
                "en-us-comp8.ctb": {
                    "filename": "en-us-comp8.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-us-compbrl.uti": {
                    "filename": "en-us-compbrl.uti",
                    "computer": false,
                    "language": "en"
                },
                "en-us-emphasis.uti": {
                    "filename": "en-us-emphasis.uti",
                    "computer": false,
                    "language": "en"
                },
                "en-us-g1.ctb": {
                    "filename": "en-us-g1.ctb",
                    "displayName": "English uncontracted braille as used in the U.S.",
                    "nativeName": "U.S. English grade 1 (EBAE)",
                    "indexName": "English, U.S., uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "en-US",
                    "contraction": "no"
                },
                "en-us-g2.ctb": {
                    "filename": "en-us-g2.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-us-interline.ctb": {
                    "filename": "en-us-interline.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en-us-mathtext.ctb": {
                    "filename": "en-us-mathtext.ctb",
                    "computer": false,
                    "language": "en"
                },
                "en_CA.ctb": {
                    "filename": "en_CA.ctb",
                    "computer": false,
                    "language": "en-CA"
                },
                "en_CA.tbl": {
                    "filename": "en_CA.tbl",
                    "displayName": "English computer braille as used in Canada",
                    "indexName": "English, Canada, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "en-CA"
                },
                "en_GB.tbl": {
                    "filename": "en_GB.tbl",
                    "displayName": "English contracted braille as used in the U.K.",
                    "nativeName": "British English grade 2",
                    "indexName": "English, U.K., contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "en-GB",
                    "contraction": "full"
                },
                "en_US-comp8-ext.tbl": {
                    "filename": "en_US-comp8-ext.tbl",
                    "displayName": "English 8-dot computer braille as used in the U.S.",
                    "nativeName": "U.S. English 8-dot computer braille for Windows",
                    "indexName": "English, U.S., computer, 8-dot",
                    "computer": true,
                    "dots": 8,
                    "language": "en-US"
                },
                "en_US.tbl": {
                    "filename": "en_US.tbl",
                    "displayName": "English contracted braille as used in the U.S.",
                    "nativeName": "U.S. English grade 2 (EBAE)",
                    "indexName": "English, U.S., contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "en-US",
                    "contraction": "full"
                },
                "eo-g1-x-system.ctb": {
                    "filename": "eo-g1-x-system.ctb",
                    "displayName": "Esperanto x-system braille",
                    "indexName": "Esperanto x-system",
                    "computer": false,
                    "grade": "1",
                    "language": "eo"
                },
                "eo-g1.ctb": {
                    "filename": "eo-g1.ctb",
                    "computer": false,
                    "language": "eo"
                },
                "eo.tbl": {
                    "filename": "eo.tbl",
                    "displayName": "Esperanto braille",
                    "indexName": "Esperanto",
                    "computer": false,
                    "grade": "1",
                    "language": "eo"
                },
                "es-chardefs.cti": {
                    "filename": "es-chardefs.cti",
                    "computer": false,
                    "language": "es"
                },
                "es-g1.ctb": {
                    "filename": "es-g1.ctb",
                    "computer": false,
                    "language": "es"
                },
                "es-g2.ctb": {
                    "filename": "es-g2.ctb",
                    "displayName": "Spanish contracted braille",
                    "indexName": "Spanish, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "es",
                    "contraction": "full"
                },
                "es-new.dis": {
                    "filename": "es-new.dis",
                    "computer": false,
                    "language": "es"
                },
                "es-old.dis": {
                    "filename": "es-old.dis",
                    "computer": false,
                    "language": "es"
                },
                "es.tbl": {
                    "filename": "es.tbl",
                    "displayName": "Spanish uncontracted braille",
                    "indexName": "Spanish, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "es",
                    "contraction": "no"
                },
                "et-g0.utb": {
                    "filename": "et-g0.utb",
                    "computer": false,
                    "language": "et"
                },
                "et.ctb": {
                    "filename": "et.ctb",
                    "computer": false,
                    "language": "et"
                },
                "et.tbl": {
                    "filename": "et.tbl",
                    "displayName": "Estonian computer braille",
                    "indexName": "Estonian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "et"
                },
                "ethio-g1.ctb": {
                    "filename": "ethio-g1.ctb",
                    "computer": false
                },
                "eurodefs.cti": {
                    "filename": "eurodefs.cti",
                    "computer": false
                },
                "fa-ir-comp8.ctb": {
                    "filename": "fa-ir-comp8.ctb",
                    "displayName": "Persian computer braille",
                    "indexName": "Persian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "fa"
                },
                "fa-ir-g1.utb": {
                    "filename": "fa-ir-g1.utb",
                    "displayName": "Persian braille",
                    "indexName": "Persian",
                    "computer": false,
                    "grade": "1",
                    "language": "fa",
                    "contraction": "no"
                },
                "fi-fi-8dot.ctb": {
                    "filename": "fi-fi-8dot.ctb",
                    "displayName": "Finnish computer braille",
                    "indexName": "Finnish, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "fi"
                },
                "fi.utb": {
                    "filename": "fi.utb",
                    "displayName": "Finnish braille",
                    "nativeName": "Suomenkielinen 6-pisteen pistekirjoitustaulukko",
                    "indexName": "Finnish",
                    "computer": false,
                    "dots": 6,
                    "updated": "Mon Jun 17 00:00:00 CEST 2024",
                    "language": "fi",
                    "contraction": "no"
                },
                "fil-g2.ctb": {
                    "filename": "fil-g2.ctb",
                    "displayName": "Filipino contracted braille",
                    "nativeName": "Filipino braille, grado 2",
                    "indexName": "Filipino, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "tlg",
                    "contraction": "full"
                },
                "fr-bfu-comp6.utb": {
                    "filename": "fr-bfu-comp6.utb",
                    "displayName": "French uncontracted braille",
                    "indexName": "French, uncontracted",
                    "computer": false,
                    "dots": 6,
                    "updated": "Sun Feb 21 00:00:00 CET 2021",
                    "language": "fr",
                    "contraction": "no"
                },
                "fr-bfu-comp68.cti": {
                    "filename": "fr-bfu-comp68.cti",
                    "computer": false,
                    "language": "fr"
                },
                "fr-bfu-comp8.utb": {
                    "filename": "fr-bfu-comp8.utb",
                    "displayName": "French computer braille",
                    "indexName": "French, computer",
                    "computer": true,
                    "dots": 8,
                    "updated": "Sun Mar 04 00:00:00 CET 2018",
                    "language": "fr"
                },
                "fr-bfu-g2.ctb": {
                    "filename": "fr-bfu-g2.ctb",
                    "displayName": "French contracted braille",
                    "indexName": "French, contracted",
                    "computer": false,
                    "grade": "2",
                    "updated": "Wed May 16 00:00:00 CEST 2018",
                    "language": "fr",
                    "contraction": "full"
                },
                "ga-g1.utb": {
                    "filename": "ga-g1.utb",
                    "displayName": "Irish uncontracted braille",
                    "indexName": "Irish, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "ga",
                    "contraction": "no"
                },
                "ga-g2.ctb": {
                    "filename": "ga-g2.ctb",
                    "displayName": "Irish contracted braille",
                    "indexName": "Irish, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "ga",
                    "contraction": "full"
                },
                "gd.ctb": {
                    "filename": "gd.ctb",
                    "computer": false,
                    "language": "gd"
                },
                "gd.tbl": {
                    "filename": "gd.tbl",
                    "displayName": "Scottish Gaelic computer braille",
                    "indexName": "Scottish Gaelic, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "gd"
                },
                "gez.tbl": {
                    "filename": "gez.tbl",
                    "displayName": "Ethiopic braille",
                    "indexName": "Ethiopic",
                    "computer": false,
                    "grade": "1",
                    "language": "gez"
                },
                "gon.ctb": {
                    "filename": "gon.ctb",
                    "computer": false,
                    "language": "gon"
                },
                "gon.tbl": {
                    "filename": "gon.tbl",
                    "displayName": "Gondi braille",
                    "indexName": "Gondi",
                    "computer": false,
                    "language": "gon"
                },
                "gr-pl-comp8.uti": {
                    "filename": "gr-pl-comp8.uti",
                    "computer": false,
                    "language": "gr"
                },
                "grc-international-common.uti": {
                    "filename": "grc-international-common.uti",
                    "computer": false,
                    "language": "grc"
                },
                "grc-international-composed.uti": {
                    "filename": "grc-international-composed.uti",
                    "computer": false,
                    "language": "grc"
                },
                "grc-international-decomposed.uti": {
                    "filename": "grc-international-decomposed.uti",
                    "computer": false,
                    "language": "grc"
                },
                "grc-international-en-composed.utb": {
                    "filename": "grc-international-en-composed.utb",
                    "displayName": "Greek internationalized braille with single-cell accented letters as used by English speakers",
                    "indexName": "Greek, international, English, composed",
                    "computer": false,
                    "dots": 6,
                    "language": "en",
                    "contraction": "no"
                },
                "grc-international-en.utb": {
                    "filename": "grc-international-en.utb",
                    "displayName": "Greek internationalized braille with 2-cell accented letters as used by English speakers",
                    "indexName": "Greek, international, English, decomposed",
                    "computer": false,
                    "dots": 6,
                    "language": "en",
                    "contraction": "no"
                },
                "grc-international-es.utb": {
                    "filename": "grc-international-es.utb",
                    "displayName": "Spanish braille for Greek text",
                    "indexName": "Greek, international, Spanish",
                    "computer": false,
                    "dots": 8,
                    "language": "es",
                    "contraction": "no"
                },
                "gu-in-g1.utb": {
                    "filename": "gu-in-g1.utb",
                    "computer": false,
                    "language": "gu"
                },
                "gu.tbl": {
                    "filename": "gu.tbl",
                    "displayName": "Gujarati braille",
                    "indexName": "Gujarati",
                    "computer": false,
                    "grade": "1",
                    "language": "gu"
                },
                "gujarati.cti": {
                    "filename": "gujarati.cti",
                    "computer": false
                },
                "gurumuki.cti": {
                    "filename": "gurumuki.cti",
                    "computer": false,
                    "updated": "Mon May 23 00:00:00 CEST 2022"
                },
                "haw-us-g1.ctb": {
                    "filename": "haw-us-g1.ctb",
                    "displayName": "Hawaiian braille",
                    "indexName": "Hawaiian",
                    "computer": false,
                    "grade": "1",
                    "language": "haw",
                    "contraction": "no"
                },
                "hbo.utb": {
                    "filename": "hbo.utb",
                    "displayName": "Biblical Hebrew braille",
                    "indexName": "Hebrew, Biblical",
                    "computer": false,
                    "dots": 6,
                    "language": "hbo",
                    "contraction": "no"
                },
                "he-IL-comp8.utb": {
                    "filename": "he-IL-comp8.utb",
                    "displayName": "Hebrew computer braille",
                    "indexName": "Hebrew, modern, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "he"
                },
                "he-IL.utb": {
                    "filename": "he-IL.utb",
                    "displayName": "Israeli braille",
                    "indexName": "Hebrew, modern",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "mul-IL",
                    "contraction": "no"
                },
                "hi-in-g1.utb": {
                    "filename": "hi-in-g1.utb",
                    "computer": false,
                    "language": "hi"
                },
                "hi.tbl": {
                    "filename": "hi.tbl",
                    "displayName": "Hindi braille",
                    "indexName": "Hindi",
                    "computer": false,
                    "grade": "1",
                    "language": "hi"
                },
                "hr-chardefs.cti": {
                    "filename": "hr-chardefs.cti",
                    "computer": false,
                    "language": "hr"
                },
                "hr-comp8.tbl": {
                    "filename": "hr-comp8.tbl",
                    "displayName": "Croatian computer braille",
                    "indexName": "Croatian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "hr"
                },
                "hr-comp8.utb": {
                    "filename": "hr-comp8.utb",
                    "computer": false,
                    "language": "hr"
                },
                "hr-digits.uti": {
                    "filename": "hr-digits.uti",
                    "computer": false,
                    "language": "hr"
                },
                "hr-g1.ctb": {
                    "filename": "hr-g1.ctb",
                    "computer": false,
                    "language": "hr"
                },
                "hr-g1.tbl": {
                    "filename": "hr-g1.tbl",
                    "displayName": "Croatian braille",
                    "indexName": "Croatian",
                    "computer": false,
                    "grade": "1",
                    "language": "hr"
                },
                "hr-translation.cti": {
                    "filename": "hr-translation.cti",
                    "computer": false,
                    "language": "hr"
                },
                "hu-backtranslate-correction.dis": {
                    "filename": "hu-backtranslate-correction.dis",
                    "computer": false,
                    "language": "hu"
                },
                "hu-backtranslate-word-corrections.cti": {
                    "filename": "hu-backtranslate-word-corrections.cti",
                    "computer": false,
                    "language": "hu"
                },
                "hu-chardefs.cti": {
                    "filename": "hu-chardefs.cti",
                    "computer": false,
                    "language": "hu"
                },
                "hu-exceptionwords.cti": {
                    "filename": "hu-exceptionwords.cti",
                    "computer": false,
                    "language": "hu"
                },
                "hu-hu-comp8.ctb": {
                    "filename": "hu-hu-comp8.ctb",
                    "displayName": "Hungarian computer braille",
                    "indexName": "Hungarian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "hu"
                },
                "hu-hu-g1.ctb": {
                    "filename": "hu-hu-g1.ctb",
                    "computer": false,
                    "language": "hu"
                },
                "hu-hu-g1_braille_input.cti": {
                    "filename": "hu-hu-g1_braille_input.cti",
                    "computer": false,
                    "language": "hu"
                },
                "hu-hu-g2.ctb": {
                    "filename": "hu-hu-g2.ctb",
                    "displayName": "Hungarian contracted braille",
                    "indexName": "Hungarian, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "hu",
                    "contraction": "full"
                },
                "hu-hu-g2_exceptions.cti": {
                    "filename": "hu-hu-g2_exceptions.cti",
                    "computer": false,
                    "language": "hu"
                },
                "hu.tbl": {
                    "filename": "hu.tbl",
                    "displayName": "Hungarian partially contracted braille",
                    "indexName": "Hungarian, partially contracted",
                    "computer": false,
                    "grade": "1",
                    "language": "hu",
                    "contraction": "partial"
                },
                "hy.ctb": {
                    "filename": "hy.ctb",
                    "computer": false,
                    "language": "hy"
                },
                "hy.tbl": {
                    "filename": "hy.tbl",
                    "displayName": "Armenian computer braille",
                    "indexName": "Armenian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "hy"
                },
                "is-chardefs6.cti": {
                    "filename": "is-chardefs6.cti",
                    "computer": false,
                    "language": "is"
                },
                "is-chardefs8.cti": {
                    "filename": "is-chardefs8.cti",
                    "computer": false,
                    "language": "is"
                },
                "is.ctb": {
                    "filename": "is.ctb",
                    "computer": false,
                    "language": "is"
                },
                "is.tbl": {
                    "filename": "is.tbl",
                    "displayName": "Icelandic braille",
                    "indexName": "Icelandic",
                    "computer": false,
                    "dots": 6,
                    "language": "is"
                },
                "it-it-comp6.utb": {
                    "filename": "it-it-comp6.utb",
                    "computer": false,
                    "language": "it"
                },
                "it-it-comp8.utb": {
                    "filename": "it-it-comp8.utb",
                    "displayName": "Italian computer braille",
                    "indexName": "Italian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "it"
                },
                "it.tbl": {
                    "filename": "it.tbl",
                    "displayName": "Italian braille",
                    "indexName": "Italian",
                    "computer": false,
                    "dots": 6,
                    "language": "it"
                },
                "iu-ca-g1.ctb": {
                    "filename": "iu-ca-g1.ctb",
                    "displayName": "Inuktitut braille",
                    "indexName": "Inuktitut",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "iu",
                    "contraction": "no"
                },
                "ja-kantenji-ucs2.utb": {
                    "filename": "ja-kantenji-ucs2.utb",
                    "displayName": "Kantenji",
                    "indexName": "Japanese, Kantenji",
                    "computer": false,
                    "grade": "1",
                    "dots": 8,
                    "language": "ja",
                    "contraction": "no"
                },
                "ja-kantenji.utb": {
                    "filename": "ja-kantenji.utb",
                    "displayName": "Kantenji",
                    "indexName": "Japanese, Kantenji",
                    "computer": false,
                    "grade": "1",
                    "dots": 8,
                    "language": "ja",
                    "contraction": "no"
                },
                "ka-in-g1.utb": {
                    "filename": "ka-in-g1.utb",
                    "computer": false,
                    "language": "ka"
                },
                "ka.utb": {
                    "filename": "ka.utb",
                    "displayName": "Georgian braille",
                    "indexName": "Georgian",
                    "computer": false,
                    "dots": 6,
                    "language": "ka"
                },
                "kannada.cti": {
                    "filename": "kannada.cti",
                    "computer": false
                },
                "kh-in-g1.utb": {
                    "filename": "kh-in-g1.utb",
                    "computer": false,
                    "language": "kh"
                },
                "kha.tbl": {
                    "filename": "kha.tbl",
                    "displayName": "Khasi braille",
                    "indexName": "Khasi",
                    "computer": false,
                    "grade": "1",
                    "language": "kha"
                },
                "kk.utb": {
                    "filename": "kk.utb",
                    "displayName": "Kazakh braille",
                    "indexName": "Kazakh",
                    "computer": false,
                    "dots": 6,
                    "language": "kk",
                    "contraction": "no"
                },
                "km-g1.utb": {
                    "filename": "km-g1.utb",
                    "displayName": "Khmer braille",
                    "indexName": "Khmer",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "updated": "Tue Nov 17 00:00:00 CET 2020",
                    "language": "km",
                    "contraction": "no"
                },
                "kmr.tbl": {
                    "filename": "kmr.tbl",
                    "displayName": "Northern Kurdish braille",
                    "nativeName": "niwisen kuran kurmanci",
                    "indexName": "Northern Kurdish",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "language": "kmr",
                    "contraction": "no"
                },
                "kn.tbl": {
                    "filename": "kn.tbl",
                    "displayName": "Kannada braille",
                    "indexName": "Kannada",
                    "computer": false,
                    "grade": "1",
                    "language": "kn"
                },
                "ko-2006-g1.ctb": {
                    "filename": "ko-2006-g1.ctb",
                    "displayName": "Korean uncontracted braille (2006 standard)",
                    "indexName": "Korean, uncontracted, 2006",
                    "computer": false,
                    "grade": "1",
                    "language": "ko",
                    "contraction": "no"
                },
                "ko-2006-g2.ctb": {
                    "filename": "ko-2006-g2.ctb",
                    "displayName": "Korean contracted braille (2006 standard)",
                    "indexName": "Korean, contracted, 2006",
                    "computer": false,
                    "grade": "2",
                    "language": "ko",
                    "contraction": "full"
                },
                "ko-2006.cti": {
                    "filename": "ko-2006.cti",
                    "computer": false,
                    "language": "ko"
                },
                "ko-chars.cti": {
                    "filename": "ko-chars.cti",
                    "computer": false,
                    "language": "ko"
                },
                "ko-g1-rules.cti": {
                    "filename": "ko-g1-rules.cti",
                    "computer": false,
                    "language": "ko"
                },
                "ko-g1.ctb": {
                    "filename": "ko-g1.ctb",
                    "displayName": "Korean uncontracted braille",
                    "indexName": "Korean, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "ko",
                    "contraction": "no"
                },
                "ko-g2-rules.cti": {
                    "filename": "ko-g2-rules.cti",
                    "computer": false,
                    "language": "ko"
                },
                "ko-g2.ctb": {
                    "filename": "ko-g2.ctb",
                    "displayName": "Korean contracted braille",
                    "indexName": "Korean, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "ko",
                    "contraction": "full"
                },
                "ko.cti": {
                    "filename": "ko.cti",
                    "computer": false,
                    "language": "ko"
                },
                "kok.ctb": {
                    "filename": "kok.ctb",
                    "computer": false,
                    "language": "kok"
                },
                "kok.tbl": {
                    "filename": "kok.tbl",
                    "displayName": "Konkani braille",
                    "indexName": "Konkani",
                    "computer": false,
                    "language": "kok"
                },
                "kru.ctb": {
                    "filename": "kru.ctb",
                    "computer": false,
                    "language": "kru"
                },
                "kru.tbl": {
                    "filename": "kru.tbl",
                    "displayName": "Kurukh braille",
                    "indexName": "Kurukh",
                    "computer": false,
                    "language": "kru"
                },
                "ks-in-g1.utb": {
                    "filename": "ks-in-g1.utb",
                    "computer": false,
                    "language": "ks"
                },
                "latinLetterDef6Dots.uti": {
                    "filename": "latinLetterDef6Dots.uti",
                    "computer": false
                },
                "latinLetterDef8Dots.uti": {
                    "filename": "latinLetterDef8Dots.uti",
                    "computer": false
                },
                "latinLowercase.uti": {
                    "filename": "latinLowercase.uti",
                    "computer": false
                },
                "latinUppercaseComp6.uti": {
                    "filename": "latinUppercaseComp6.uti",
                    "computer": false
                },
                "lg-ug-g1.utb": {
                    "filename": "lg-ug-g1.utb",
                    "displayName": "Luganda braille",
                    "indexName": "Luganda",
                    "computer": false,
                    "dots": 6,
                    "language": "lg",
                    "contraction": "no"
                },
                "litdigits6Dots.uti": {
                    "filename": "litdigits6Dots.uti",
                    "computer": false
                },
                "litdigits6DotsPlusDot6.uti": {
                    "filename": "litdigits6DotsPlusDot6.uti",
                    "computer": false
                },
                "lo-g1.utb": {
                    "filename": "lo-g1.utb",
                    "displayName": "Lao braille",
                    "indexName": "Lao",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "updated": "Mon May 08 00:00:00 CEST 2023",
                    "language": "lo",
                    "contraction": "no"
                },
                "loweredDigits6Dots.uti": {
                    "filename": "loweredDigits6Dots.uti",
                    "computer": false
                },
                "loweredDigits8Dots.uti": {
                    "filename": "loweredDigits8Dots.uti",
                    "computer": false
                },
                "lt-6dot.tbl": {
                    "filename": "lt-6dot.tbl",
                    "displayName": "Lithuanian 6-dot braille",
                    "indexName": "Lithuanian, 6-dot",
                    "computer": false,
                    "dots": 6,
                    "language": "lt",
                    "contraction": "no"
                },
                "lt-6dot.utb": {
                    "filename": "lt-6dot.utb",
                    "computer": false,
                    "language": "lt"
                },
                "lt.ctb": {
                    "filename": "lt.ctb",
                    "computer": false,
                    "language": "lt"
                },
                "lt.tbl": {
                    "filename": "lt.tbl",
                    "displayName": "Lithuanian 8-dot braille",
                    "indexName": "Lithuanian, 8-dot",
                    "computer": false,
                    "dots": 8,
                    "language": "lt",
                    "contraction": "no"
                },
                "lv.tbl": {
                    "filename": "lv.tbl",
                    "displayName": "Latvian braille",
                    "indexName": "Latvian",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "lv"
                },
                "malayalam.cti": {
                    "filename": "malayalam.cti",
                    "computer": false
                },
                "mao-nz-g1.ctb": {
                    "filename": "mao-nz-g1.ctb",
                    "displayName": "Maori braille",
                    "indexName": "Maori",
                    "computer": false,
                    "grade": "1",
                    "language": "mi",
                    "contraction": "no"
                },
                "marburg_single_cell_defs.cti": {
                    "filename": "marburg_single_cell_defs.cti",
                    "computer": false
                },
                "marburg_unicode_defs.cti": {
                    "filename": "marburg_unicode_defs.cti",
                    "computer": false
                },
                "ml-in-g1.utb": {
                    "filename": "ml-in-g1.utb",
                    "computer": false,
                    "language": "ml"
                },
                "ml.tbl": {
                    "filename": "ml.tbl",
                    "displayName": "Malayalam braille",
                    "indexName": "Malayalam",
                    "computer": false,
                    "grade": "1",
                    "language": "ml"
                },
                "mn-MN-common.cti": {
                    "filename": "mn-MN-common.cti",
                    "computer": false,
                    "language": "mn"
                },
                "mn-MN-g1.utb": {
                    "filename": "mn-MN-g1.utb",
                    "displayName": "Mongolian uncontracted braille",
                    "indexName": "Mongolian, uncontracted",
                    "computer": false,
                    "dots": 8,
                    "language": "mn",
                    "contraction": "no"
                },
                "mn-MN-g2.ctb": {
                    "filename": "mn-MN-g2.ctb",
                    "displayName": "Mongolian contracted braille",
                    "indexName": "Mongolian, contracted",
                    "computer": false,
                    "dots": 8,
                    "language": "mn",
                    "contraction": "full"
                },
                "mn-in-g1.utb": {
                    "filename": "mn-in-g1.utb",
                    "computer": false,
                    "language": "mn"
                },
                "mni.tbl": {
                    "filename": "mni.tbl",
                    "displayName": "Manipuri braille",
                    "indexName": "Manipuri",
                    "computer": false,
                    "grade": "1",
                    "language": "mni"
                },
                "mr-in-g1.utb": {
                    "filename": "mr-in-g1.utb",
                    "computer": false,
                    "language": "mr"
                },
                "mr.tbl": {
                    "filename": "mr.tbl",
                    "displayName": "Marathi braille",
                    "indexName": "Marathi",
                    "computer": false,
                    "grade": "1",
                    "language": "mr"
                },
                "ms-my-g2.ctb": {
                    "filename": "ms-my-g2.ctb",
                    "displayName": "Malay braille",
                    "indexName": "Malay",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "ms",
                    "contraction": "full"
                },
                "mt.ctb": {
                    "filename": "mt.ctb",
                    "computer": false,
                    "language": "mt"
                },
                "mt.tbl": {
                    "filename": "mt.tbl",
                    "displayName": "Maltese computer braille",
                    "indexName": "Maltese, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "mt"
                },
                "mun.ctb": {
                    "filename": "mun.ctb",
                    "computer": false,
                    "language": "mun"
                },
                "mun.tbl": {
                    "filename": "mun.tbl",
                    "displayName": "Munda braille",
                    "indexName": "Munda",
                    "computer": false,
                    "language": "mun"
                },
                "mwr.ctb": {
                    "filename": "mwr.ctb",
                    "computer": false,
                    "language": "mwr"
                },
                "mwr.tbl": {
                    "filename": "mwr.tbl",
                    "displayName": "Marwari braille",
                    "indexName": "Marwari",
                    "computer": false,
                    "language": "mwr"
                },
                "my-g1.utb": {
                    "filename": "my-g1.utb",
                    "displayName": "Burmese uncontracted braille",
                    "indexName": "Burmese, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "updated": "Tue Nov 17 00:00:00 CET 2020",
                    "language": "my",
                    "contraction": "no"
                },
                "my-g2.ctb": {
                    "filename": "my-g2.ctb",
                    "displayName": "Burmese contracted braille",
                    "indexName": "Burmese, contracted",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "updated": "Tue Nov 17 00:00:00 CET 2020",
                    "language": "my",
                    "contraction": "full"
                },
                "ne.ctb": {
                    "filename": "ne.ctb",
                    "computer": false,
                    "language": "ne"
                },
                "ne.tbl": {
                    "filename": "ne.tbl",
                    "displayName": "Nepali braille",
                    "indexName": "Nepali",
                    "computer": false,
                    "grade": "1",
                    "language": "ne"
                },
                "nemethdefs.cti": {
                    "filename": "nemethdefs.cti",
                    "computer": false
                },
                "nl-BE.dis": {
                    "filename": "nl-BE.dis",
                    "computer": false,
                    "language": "nl"
                },
                "nl-NL-g0.utb": {
                    "filename": "nl-NL-g0.utb",
                    "displayName": "Dutch braille",
                    "indexName": "Dutch",
                    "computer": false,
                    "grade": "0",
                    "language": "nl",
                    "contraction": "no"
                },
                "nl-chardefs.uti": {
                    "filename": "nl-chardefs.uti",
                    "computer": false,
                    "language": "nl"
                },
                "nl-comp8.utb": {
                    "filename": "nl-comp8.utb",
                    "displayName": "Dutch computer braille",
                    "indexName": "Dutch, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "nl"
                },
                "nl-print.dis": {
                    "filename": "nl-print.dis",
                    "computer": false,
                    "language": "nl"
                },
                "nl-unicode.dis": {
                    "filename": "nl-unicode.dis",
                    "computer": false,
                    "language": "nl"
                },
                "no-no-8dot-fallback-6dot-g0.utb": {
                    "filename": "no-no-8dot-fallback-6dot-g0.utb",
                    "displayName": "Norwegian 8-dot uncontracted braille with 6-dot fallback",
                    "nativeName": "Norsk litterær punktskrift, 8-punkt med 6-punktsdefinisjoner i reserve",
                    "indexName": "Norwegian, uncontracted, 8-dot, 6-dot fallback",
                    "computer": false,
                    "grade": "0",
                    "dots": 8,
                    "language": "nn",
                    "contraction": "no"
                },
                "no-no-8dot.utb": {
                    "filename": "no-no-8dot.utb",
                    "displayName": "Norwegian 8-dot uncontracted braille",
                    "nativeName": "Norsk litterær punktskrift, 8-punkt",
                    "indexName": "Norwegian, uncontracted, 8-dot",
                    "computer": false,
                    "grade": "0",
                    "dots": 8,
                    "language": "nn",
                    "contraction": "no"
                },
                "no-no-braillo-047-01.dis": {
                    "filename": "no-no-braillo-047-01.dis",
                    "computer": false,
                    "language": "nb"
                },
                "no-no-chardefs6.uti": {
                    "filename": "no-no-chardefs6.uti",
                    "computer": false,
                    "language": "nb"
                },
                "no-no-comp8.ctb": {
                    "filename": "no-no-comp8.ctb",
                    "displayName": "Norwegian computer braille",
                    "nativeName": "Norsk datapunktskrift, 8-punkt",
                    "indexName": "Norwegian, computer",
                    "computer": true,
                    "grade": "0",
                    "dots": 8,
                    "language": "nn"
                },
                "no-no-g0.utb": {
                    "filename": "no-no-g0.utb",
                    "displayName": "Norwegian 6-dot uncontracted braille",
                    "nativeName": "Norsk litterær punktskrift, 6-punkt, fullskrift",
                    "indexName": "Norwegian, uncontracted, 6-dot",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "language": "nn",
                    "contraction": "no"
                },
                "no-no-g1.ctb": {
                    "filename": "no-no-g1.ctb",
                    "displayName": "Norwegian grade 1 contracted braille",
                    "nativeName": "Norsk litterær punktskrift, 6-punkt, kortskrift nivå 1",
                    "indexName": "Norwegian, contracted, grade 1",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "nn",
                    "contraction": "partial"
                },
                "no-no-g2.ctb": {
                    "filename": "no-no-g2.ctb",
                    "displayName": "Norwegian grade 2 contracted braille",
                    "nativeName": "Norsk litterær punktskrift, 6-punkt, kortskrift nivå 2",
                    "indexName": "Norwegian, contracted, grade 2",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "nn",
                    "contraction": "partial"
                },
                "no-no-g3.ctb": {
                    "filename": "no-no-g3.ctb",
                    "displayName": "Norwegian grade 3 contracted braille",
                    "nativeName": "Norsk litterær punktskrift, 6-punkt, kortskrift nivå 3",
                    "indexName": "Norwegian, contracted, grade 3",
                    "computer": false,
                    "grade": "3",
                    "dots": 6,
                    "language": "nn",
                    "contraction": "full"
                },
                "no-no-generic.ctb": {
                    "filename": "no-no-generic.ctb",
                    "computer": false,
                    "language": "nb"
                },
                "no-no-generic.dis": {
                    "filename": "no-no-generic.dis",
                    "computer": false,
                    "language": "nb"
                },
                "no-no-latinLetterDef6Dots_diacritics.uti": {
                    "filename": "no-no-latinLetterDef6Dots_diacritics.uti",
                    "computer": false,
                    "language": "nb"
                },
                "no-no.dis": {
                    "filename": "no-no.dis",
                    "computer": false,
                    "language": "nb"
                },
                "np-in-g1.utb": {
                    "filename": "np-in-g1.utb",
                    "computer": false,
                    "language": "np"
                },
                "nso-za-g1.utb": {
                    "filename": "nso-za-g1.utb",
                    "displayName": "Sepedi uncontracted braille",
                    "indexName": "Sepedi, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "nso",
                    "contraction": "no"
                },
                "nso-za-g2.ctb": {
                    "filename": "nso-za-g2.ctb",
                    "displayName": "Sepedi contracted braille",
                    "indexName": "Sepedi, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "nso",
                    "contraction": "full"
                },
                "ny-mw.utb": {
                    "filename": "ny-mw.utb",
                    "displayName": "Chichewa braille",
                    "indexName": "Chichewa",
                    "computer": false,
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "ny",
                    "contraction": "no"
                },
                "or-in-g1.utb": {
                    "filename": "or-in-g1.utb",
                    "computer": false,
                    "language": "or"
                },
                "or.tbl": {
                    "filename": "or.tbl",
                    "displayName": "Oriya braille",
                    "indexName": "Oriya",
                    "computer": false,
                    "grade": "1",
                    "language": "or"
                },
                "oriya.cti": {
                    "filename": "oriya.cti",
                    "computer": false
                },
                "pa.tbl": {
                    "filename": "pa.tbl",
                    "displayName": "Punjabi braille",
                    "indexName": "Punjabi",
                    "computer": false,
                    "grade": "1",
                    "language": "pa"
                },
                "pi.ctb": {
                    "filename": "pi.ctb",
                    "computer": false,
                    "language": "pi"
                },
                "pi.tbl": {
                    "filename": "pi.tbl",
                    "displayName": "Pali braille",
                    "indexName": "Pali",
                    "computer": false,
                    "language": "pi"
                },
                "pl-custom-math.utb": {
                    "filename": "pl-custom-math.utb",
                    "displayName": "Custom Polish math notation, 6-dot (temporary)",
                    "nativeName": "Niestandardowy polski zapis matematyczny, 6-kropkowy (tymczasowy)",
                    "indexName": "Polish, custom math, 6-dot",
                    "computer": false,
                    "dots": 6,
                    "updated": "Wed Feb 21 00:00:00 CET 2024",
                    "language": "pl"
                },
                "pl-pl-comp8.ctb": {
                    "filename": "pl-pl-comp8.ctb",
                    "displayName": "Polish computer braille",
                    "indexName": "Polish, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "pl"
                },
                "pl.tbl": {
                    "filename": "pl.tbl",
                    "displayName": "Polish braille",
                    "indexName": "Polish",
                    "computer": false,
                    "dots": 6,
                    "language": "pl",
                    "contraction": "no"
                },
                "printables.cti": {
                    "filename": "printables.cti",
                    "computer": false
                },
                "pt-pt-comp8.ctb": {
                    "filename": "pt-pt-comp8.ctb",
                    "displayName": "Portuguese computer braille",
                    "indexName": "Portuguese, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "pt"
                },
                "pt-pt-g1.utb": {
                    "filename": "pt-pt-g1.utb",
                    "displayName": "Portuguese uncontracted braille",
                    "indexName": "Portuguese, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "pt",
                    "contraction": "no"
                },
                "pt-pt-g2.ctb": {
                    "filename": "pt-pt-g2.ctb",
                    "computer": false,
                    "language": "pt"
                },
                "pt.tbl": {
                    "filename": "pt.tbl",
                    "displayName": "Portuguese contracted braille",
                    "indexName": "Portuguese, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "pt",
                    "contraction": "full"
                },
                "pu-in-g1.utb": {
                    "filename": "pu-in-g1.utb",
                    "computer": false,
                    "language": "pu"
                },
                "ro-g0.utb": {
                    "filename": "ro-g0.utb",
                    "displayName": "Romanian braille",
                    "indexName": "Romanian, uncontracted",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "language": "ro",
                    "contraction": "no"
                },
                "ro.ctb": {
                    "filename": "ro.ctb",
                    "computer": false,
                    "language": "ro"
                },
                "ro.tbl": {
                    "filename": "ro.tbl",
                    "displayName": "Romanian computer braille",
                    "indexName": "Romanian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "ro"
                },
                "ru-brf.dis": {
                    "filename": "ru-brf.dis",
                    "computer": false,
                    "language": "ru"
                },
                "ru-compbrl.ctb": {
                    "filename": "ru-compbrl.ctb",
                    "displayName": "Russian braille for program sources",
                    "indexName": "Russian, for program sources",
                    "computer": false,
                    "grade": "0",
                    "language": "ru",
                    "contraction": "no"
                },
                "ru-letters.dis": {
                    "filename": "ru-letters.dis",
                    "computer": false,
                    "language": "ru"
                },
                "ru-litbrl-detailed.utb": {
                    "filename": "ru-litbrl-detailed.utb",
                    "displayName": "Russian braille with indication of capitals",
                    "indexName": "Russian, with capitals",
                    "computer": false,
                    "dots": 6,
                    "language": "ru",
                    "contraction": "no"
                },
                "ru-litbrl.ctb": {
                    "filename": "ru-litbrl.ctb",
                    "displayName": "Russian braille",
                    "indexName": "Russian",
                    "computer": false,
                    "dots": 6,
                    "language": "ru",
                    "contraction": "no"
                },
                "ru-ru-g1.ctb": {
                    "filename": "ru-ru-g1.ctb",
                    "displayName": "Russian contracted braille",
                    "indexName": "Russian, contracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "ru",
                    "contraction": "partial"
                },
                "ru-unicode.dis": {
                    "filename": "ru-unicode.dis",
                    "computer": false,
                    "language": "ru"
                },
                "ru.ctb": {
                    "filename": "ru.ctb",
                    "displayName": "Russian computer braille",
                    "indexName": "Russian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "ru"
                },
                "rw-rw-g1.utb": {
                    "filename": "rw-rw-g1.utb",
                    "displayName": "Kinyarwanda braille",
                    "indexName": "Kinyarwanda",
                    "computer": false,
                    "language": "rw",
                    "contraction": "no"
                },
                "sa-in-g1.utb": {
                    "filename": "sa-in-g1.utb",
                    "computer": false,
                    "language": "sa"
                },
                "sa.tbl": {
                    "filename": "sa.tbl",
                    "displayName": "Sanskrit braille",
                    "indexName": "Sanskrit",
                    "computer": false,
                    "grade": "1",
                    "language": "sa"
                },
                "sah.utb": {
                    "filename": "sah.utb",
                    "displayName": "Yakut braille",
                    "indexName": "Yakut",
                    "computer": false,
                    "dots": 6,
                    "language": "sah",
                    "contraction": "no"
                },
                "sd.tbl": {
                    "filename": "sd.tbl",
                    "displayName": "Sindhi braille",
                    "indexName": "Sindhi",
                    "computer": false,
                    "grade": "1",
                    "language": "sd"
                },
                "se-se.ctb": {
                    "filename": "se-se.ctb",
                    "computer": false,
                    "language": "se"
                },
                "se-se.dis": {
                    "filename": "se-se.dis",
                    "computer": false,
                    "language": "se"
                },
                "si-in-g1.utb": {
                    "filename": "si-in-g1.utb",
                    "computer": false,
                    "language": "si"
                },
                "sin.cti": {
                    "filename": "sin.cti",
                    "computer": false,
                    "language": "sin"
                },
                "sin.utb": {
                    "filename": "sin.utb",
                    "computer": false,
                    "language": "sin"
                },
                "sk-g1.ctb": {
                    "filename": "sk-g1.ctb",
                    "displayName": "Slovak braille",
                    "indexName": "Slovak",
                    "computer": false,
                    "dots": 6,
                    "language": "sk",
                    "contraction": "no"
                },
                "sk-sk-g1.utb": {
                    "filename": "sk-sk-g1.utb",
                    "computer": false,
                    "language": "sk"
                },
                "sk-sk.utb": {
                    "filename": "sk-sk.utb",
                    "computer": false,
                    "language": "sk"
                },
                "sl-si-comp8.ctb": {
                    "filename": "sl-si-comp8.ctb",
                    "displayName": "Slovenian computer braille",
                    "indexName": "Slovenian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "sl"
                },
                "sl-si-g1.utb": {
                    "filename": "sl-si-g1.utb",
                    "computer": false,
                    "language": "sl"
                },
                "sl.tbl": {
                    "filename": "sl.tbl",
                    "displayName": "Slovenian braille",
                    "indexName": "Slovenian",
                    "computer": false,
                    "grade": "1",
                    "language": "sl"
                },
                "sot-za-g1.ctb": {
                    "filename": "sot-za-g1.ctb",
                    "displayName": "Sesotho uncontracted braille",
                    "indexName": "Sesotho, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "st",
                    "contraction": "no"
                },
                "sot-za-g2.ctb": {
                    "filename": "sot-za-g2.ctb",
                    "displayName": "Sesotho contracted braille",
                    "indexName": "Sesotho, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "st",
                    "contraction": "full"
                },
                "spaces.uti": {
                    "filename": "spaces.uti",
                    "computer": false
                },
                "sr-Cyrl.ctb": {
                    "filename": "sr-Cyrl.ctb",
                    "displayName": "Serbian braille for Cyrillic script",
                    "indexName": "Serbian, Cyrillic",
                    "computer": false,
                    "language": "sr",
                    "contraction": "no"
                },
                "sr-common.cti": {
                    "filename": "sr-common.cti",
                    "computer": false,
                    "language": "sr"
                },
                "sr-cyrletters.cti": {
                    "filename": "sr-cyrletters.cti",
                    "computer": false,
                    "language": "sr"
                },
                "sr-g1.ctb": {
                    "filename": "sr-g1.ctb",
                    "displayName": "Serbian braille",
                    "indexName": "Serbian",
                    "computer": false,
                    "language": "sr",
                    "contraction": "no"
                },
                "sr-latletters.cti": {
                    "filename": "sr-latletters.cti",
                    "computer": false,
                    "language": "sr"
                },
                "sv-1989.ctb": {
                    "filename": "sv-1989.ctb",
                    "displayName": "Swedish computer braille (1989 standard)",
                    "indexName": "Swedish, computer, 1989",
                    "computer": true,
                    "dots": 8,
                    "language": "sv"
                },
                "sv-1996.ctb": {
                    "filename": "sv-1996.ctb",
                    "displayName": "Swedish computer braille (1996 standard)",
                    "indexName": "Swedish, computer, 1996",
                    "computer": true,
                    "dots": 8,
                    "language": "sv"
                },
                "sv-g0.utb": {
                    "filename": "sv-g0.utb",
                    "displayName": "Swedish uncontracted braille",
                    "nativeName": "Svensk 6-punkts fullskrift",
                    "indexName": "Swedish, uncontracted",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "language": "sv",
                    "contraction": "no"
                },
                "sv-g1.ctb": {
                    "filename": "sv-g1.ctb",
                    "displayName": "Swedish partially contracted braille",
                    "nativeName": "Svensk 6-punkts förkortningstabell nivå 1",
                    "indexName": "Swedish, partially contracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "sv",
                    "contraction": "partial"
                },
                "sv-g2.ctb": {
                    "filename": "sv-g2.ctb",
                    "displayName": "Swedish contracted braille",
                    "nativeName": "Svensk 6-punkts förkortningstabell nivå 2",
                    "indexName": "Swedish, contracted",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "language": "sv",
                    "contraction": "full"
                },
                "sw-ke-g1-2.ctb": {
                    "filename": "sw-ke-g1-2.ctb",
                    "displayName": "Swahili grade 1.2 contracted braille",
                    "indexName": "Swahili, contracted, grade 1.2",
                    "computer": false,
                    "grade": "1.2",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "partial"
                },
                "sw-ke-g1-3.ctb": {
                    "filename": "sw-ke-g1-3.ctb",
                    "displayName": "Swahili grade 1.3 contracted braille",
                    "indexName": "Swahili, contracted, grade 1.3",
                    "computer": false,
                    "grade": "1.3",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "partial"
                },
                "sw-ke-g1-4.ctb": {
                    "filename": "sw-ke-g1-4.ctb",
                    "displayName": "Swahili grade 1.4 contracted braille",
                    "indexName": "Swahili, contracted, grade 1.4",
                    "computer": false,
                    "grade": "1.4",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "partial"
                },
                "sw-ke-g1-5.ctb": {
                    "filename": "sw-ke-g1-5.ctb",
                    "displayName": "Swahili grade 1.5 contracted braille",
                    "indexName": "Swahili, contracted, grade 1.5",
                    "computer": false,
                    "grade": "1.5",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "partial"
                },
                "sw-ke-g1.utb": {
                    "filename": "sw-ke-g1.utb",
                    "displayName": "Swahili uncontracted braille",
                    "indexName": "Swahili, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "no"
                },
                "sw-ke-g2.ctb": {
                    "filename": "sw-ke-g2.ctb",
                    "displayName": "Swahili grade 2 contracted braille",
                    "indexName": "Swahili, contracted, grade 2",
                    "computer": false,
                    "grade": "2",
                    "updated": "Sun Jan 01 00:00:00 CET 3922",
                    "language": "sw-KE",
                    "contraction": "full"
                },
                "syc.utb": {
                    "filename": "syc.utb",
                    "displayName": "Syriac braille",
                    "indexName": "Syriac",
                    "computer": false,
                    "dots": 6,
                    "language": "syr",
                    "contraction": "no"
                },
                "ta-ta-g1.ctb": {
                    "filename": "ta-ta-g1.ctb",
                    "displayName": "Tamil braille",
                    "indexName": "Tamil",
                    "computer": false,
                    "grade": "1",
                    "language": "ta",
                    "contraction": "no"
                },
                "ta.ctb": {
                    "filename": "ta.ctb",
                    "computer": false,
                    "language": "ta"
                },
                "ta.tbl": {
                    "filename": "ta.tbl",
                    "displayName": "Tamil computer braille",
                    "indexName": "Tamil, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "ta"
                },
                "tamil.cti": {
                    "filename": "tamil.cti",
                    "computer": false
                },
                "te-in-g1.utb": {
                    "filename": "te-in-g1.utb",
                    "computer": false,
                    "language": "te"
                },
                "te.tbl": {
                    "filename": "te.tbl",
                    "displayName": "Telugu braille",
                    "indexName": "Telugu",
                    "computer": false,
                    "grade": "1",
                    "language": "te"
                },
                "telugu.cti": {
                    "filename": "telugu.cti",
                    "computer": false
                },
                "text_nabcc.dis": {
                    "filename": "text_nabcc.dis",
                    "computer": false
                },
                "th-comp8-backward.utb": {
                    "filename": "th-comp8-backward.utb",
                    "displayName": "Thai computer braille",
                    "indexName": "Thai, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "th"
                },
                "th-g0.utb": {
                    "filename": "th-g0.utb",
                    "displayName": "Thai uncontracted braille",
                    "indexName": "Thai, uncontracted",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "language": "th",
                    "contraction": "no"
                },
                "th-g1.utb": {
                    "filename": "th-g1.utb",
                    "displayName": "Thai partially contracted braille",
                    "indexName": "Thai, partially contracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "th",
                    "contraction": "partial"
                },
                "tr-g1.ctb": {
                    "filename": "tr-g1.ctb",
                    "displayName": "Turkish uncontracted braille",
                    "indexName": "Turkish, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "tr",
                    "contraction": "no"
                },
                "tr-g2.ctb": {
                    "filename": "tr-g2.ctb",
                    "computer": false,
                    "language": "tr"
                },
                "tr-g2.tbl": {
                    "filename": "tr-g2.tbl",
                    "displayName": "Turkish contracted braille",
                    "indexName": "Turkish, contracted",
                    "computer": false,
                    "grade": "2",
                    "dots": 8,
                    "language": "tr",
                    "contraction": "full"
                },
                "tr.ctb": {
                    "filename": "tr.ctb",
                    "computer": false,
                    "language": "tr"
                },
                "tr.tbl": {
                    "filename": "tr.tbl",
                    "displayName": "Turkish computer braille",
                    "indexName": "Turkish, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "tr"
                },
                "tsn-za-g1.ctb": {
                    "filename": "tsn-za-g1.ctb",
                    "displayName": "Setswana uncontracted braille",
                    "indexName": "Setswana, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "tn",
                    "contraction": "no"
                },
                "tsn-za-g2.ctb": {
                    "filename": "tsn-za-g2.ctb",
                    "displayName": "Setswana contracted braille",
                    "indexName": "Setswana, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "tn",
                    "contraction": "full"
                },
                "tt.utb": {
                    "filename": "tt.utb",
                    "displayName": "Tatar braille",
                    "indexName": "Tatar",
                    "computer": false,
                    "dots": 6,
                    "language": "tt",
                    "contraction": "no"
                },
                "uga.utb": {
                    "filename": "uga.utb",
                    "displayName": "Ugaritic braille",
                    "indexName": "Ugaritic",
                    "computer": false,
                    "dots": 6,
                    "language": "uga",
                    "contraction": "no"
                },
                "uk-comp.utb": {
                    "filename": "uk-comp.utb",
                    "displayName": "Ukrainian computer braille",
                    "indexName": "Ukrainian, computer",
                    "computer": true,
                    "dots": 8,
                    "language": "uk"
                },
                "uk-detailed.utb": {
                    "filename": "uk-detailed.utb",
                    "displayName": "Ukrainian braille with indication of capitals",
                    "indexName": "Ukrainian, with capitals",
                    "computer": false,
                    "dots": 6,
                    "language": "uk",
                    "contraction": "no"
                },
                "uk.utb": {
                    "filename": "uk.utb",
                    "displayName": "Ukrainian braille",
                    "indexName": "Ukrainian",
                    "computer": false,
                    "language": "uk"
                },
                "ukchardefs.cti": {
                    "filename": "ukchardefs.cti",
                    "computer": false
                },
                "ukmaths_single_cell_defs.cti": {
                    "filename": "ukmaths_single_cell_defs.cti",
                    "computer": false
                },
                "ukmaths_unicode_defs.cti": {
                    "filename": "ukmaths_unicode_defs.cti",
                    "computer": false
                },
                "uni-text.dis": {
                    "filename": "uni-text.dis",
                    "computer": false,
                    "language": "uni"
                },
                "unicode-braille.utb": {
                    "filename": "unicode-braille.utb",
                    "computer": false
                },
                "unicode-without-blank.dis": {
                    "filename": "unicode-without-blank.dis",
                    "computer": false
                },
                "unicode.dis": {
                    "filename": "unicode.dis",
                    "computer": false
                },
                "ur-pk-g1.utb": {
                    "filename": "ur-pk-g1.utb",
                    "displayName": "Urdu uncontracted braille",
                    "indexName": "Urdu, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "updated": "Mon Jan 01 00:00:00 CET 3923",
                    "language": "ur",
                    "contraction": "no"
                },
                "ur-pk-g2.ctb": {
                    "filename": "ur-pk-g2.ctb",
                    "displayName": "Urdu contracted braille",
                    "indexName": "Urdu, contracted",
                    "computer": false,
                    "grade": "2",
                    "updated": "Mon Jan 01 00:00:00 CET 3923",
                    "language": "ur",
                    "contraction": "full"
                },
                "us-table.dis": {
                    "filename": "us-table.dis",
                    "computer": false,
                    "language": "us"
                },
                "uz-g1.utb": {
                    "filename": "uz-g1.utb",
                    "displayName": "Uzbek braille",
                    "indexName": "Uzbek",
                    "computer": false,
                    "language": "uz"
                },
                "ve-za-g1.utb": {
                    "filename": "ve-za-g1.utb",
                    "displayName": "Tshivenda uncontracted braille",
                    "indexName": "Tshivenda, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "ve",
                    "contraction": "no"
                },
                "ve-za-g2.ctb": {
                    "filename": "ve-za-g2.ctb",
                    "displayName": "Tshivenda contracted braille",
                    "indexName": "Tshivenda, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "ve",
                    "contraction": "full"
                },
                "vi-cb8.utb": {
                    "filename": "vi-cb8.utb",
                    "displayName": "Vietnamese computer braille",
                    "indexName": "Vietnamese, computer",
                    "computer": true,
                    "dots": 8,
                    "updated": "Tue Jan 17 00:00:00 CET 2023",
                    "language": "vi",
                    "contraction": "no"
                },
                "vi-charsdef.uti": {
                    "filename": "vi-charsdef.uti",
                    "computer": false,
                    "language": "vi"
                },
                "vi-lettersdef.uti": {
                    "filename": "vi-lettersdef.uti",
                    "computer": false,
                    "language": "vi"
                },
                "vi-puncsdef.uti": {
                    "filename": "vi-puncsdef.uti",
                    "computer": false,
                    "language": "vi"
                },
                "vi-saigon-g1.ctb": {
                    "filename": "vi-saigon-g1.ctb",
                    "displayName": "Vietnamese Saigon braille",
                    "indexName": "Vietnamese, Saigon, contracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "updated": "Mon Jan 16 00:00:00 CET 2023",
                    "language": "vi",
                    "contraction": "full"
                },
                "vi-vn-g0.utb": {
                    "filename": "vi-vn-g0.utb",
                    "displayName": "Vietnamese uncontracted braille",
                    "indexName": "Vietnamese, uncontracted",
                    "computer": false,
                    "grade": "0",
                    "dots": 6,
                    "updated": "Tue Jan 17 00:00:00 CET 2023",
                    "language": "vi",
                    "contraction": "no"
                },
                "vi-vn-g1.ctb": {
                    "filename": "vi-vn-g1.ctb",
                    "displayName": "Vietnamese partially contracted braille",
                    "indexName": "Vietnamese, partially contracted",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "updated": "Mon Jan 16 00:00:00 CET 2023",
                    "language": "vi",
                    "contraction": "partial"
                },
                "vi-vn-g2.ctb": {
                    "filename": "vi-vn-g2.ctb",
                    "displayName": "Vietnamese contracted braille",
                    "indexName": "Vietnamese, contracted",
                    "computer": false,
                    "grade": "2",
                    "dots": 6,
                    "updated": "Mon Jan 16 00:00:00 CET 2023",
                    "language": "vi",
                    "contraction": "full"
                },
                "wiskunde-chardefs.cti": {
                    "filename": "wiskunde-chardefs.cti",
                    "computer": false
                },
                "wordcx.dis": {
                    "filename": "wordcx.dis",
                    "computer": false
                },
                "xh-za-g1.utb": {
                    "filename": "xh-za-g1.utb",
                    "displayName": "isiXhosa uncontracted braille",
                    "indexName": "isiXhosa, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "xh",
                    "contraction": "no"
                },
                "xh-za-g2.ctb": {
                    "filename": "xh-za-g2.ctb",
                    "displayName": "isiXhosa contracted braille",
                    "indexName": "isiXhosa, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "xh",
                    "contraction": "full"
                },
                "yi.utb": {
                    "filename": "yi.utb",
                    "displayName": "Yiddish braille",
                    "indexName": "Yiddish",
                    "computer": false,
                    "grade": "1",
                    "dots": 6,
                    "language": "yi",
                    "contraction": "no"
                },
                "zh-chn.ctb": {
                    "filename": "zh-chn.ctb",
                    "computer": false,
                    "language": "zh"
                },
                "zh-hk.ctb": {
                    "filename": "zh-hk.ctb",
                    "displayName": "Cantonese braille",
                    "indexName": "Cantonese",
                    "computer": false,
                    "language": "yue-HK"
                },
                "zh-tw.ctb": {
                    "filename": "zh-tw.ctb",
                    "displayName": "Taiwanese bopomofo braille",
                    "nativeName": "Taiwan zhuyin",
                    "indexName": "Mandarin, Taiwan, bopomofo",
                    "computer": false,
                    "language": "cmn-TW"
                },
                "zh_CHN.tbl": {
                    "filename": "zh_CHN.tbl",
                    "displayName": "Chinese current braille without tones, for simplified Chinese characters",
                    "indexName": "Mandarin, mainland China, without tones",
                    "computer": false,
                    "language": "cmn-CN"
                },
                "zhcn-cbs.ctb": {
                    "filename": "zhcn-cbs.ctb",
                    "displayName": "Chinese common braille, for simplified Chinese characters",
                    "indexName": "Mandarin, mainland China, common braille scheme",
                    "computer": false,
                    "language": "cmn-CN"
                },
                "zhcn-g1.ctb": {
                    "filename": "zhcn-g1.ctb",
                    "displayName": "Chinese current braille with tones",
                    "indexName": "Mandarin, mainland China, with tones",
                    "computer": false,
                    "language": "cmn-CN"
                },
                "zhcn-g2.ctb": {
                    "filename": "zhcn-g2.ctb",
                    "displayName": "Chinese double-phonic braille",
                    "indexName": "Mandarin, mainland China, double-phonic",
                    "computer": false,
                    "language": "cmn-CN"
                },
                "zu-za-g1.utb": {
                    "filename": "zu-za-g1.utb",
                    "displayName": "isiZulu uncontracted braille",
                    "indexName": "isiZulu, uncontracted",
                    "computer": false,
                    "grade": "1",
                    "language": "zu",
                    "contraction": "no"
                },
                "zu-za-g2.ctb": {
                    "filename": "zu-za-g2.ctb",
                    "displayName": "isiZulu contracted braille",
                    "indexName": "isiZulu, contracted",
                    "computer": false,
                    "grade": "2",
                    "language": "zu",
                    "contraction": "full"
                }
            },
            "defaultTranslationTables": {
                "af": {
                    "6dot": "afr-za-g1.ctb"
                },
                "ar": {
                    "8dot": "ar-ar-comp8.utb"
                },
                "bg": {
                    "6dot": "bg.utb",
                    "8dot": "bg.ctb"
                },
                "ca": {
                    "6dot": "ca.tbl"
                },
                "cs": {
                    "6dot": "cs-g1.ctb",
                    "8dot": "cs-comp8.utb"
                },
                "da": {
                    "6dot": "da-dk-g16.ctb",
                    "8dot": "da-dk-g18.ctb"
                },
                "de": {
                    "6dot": "de-g0.utb",
                    "8dot": "de-de-comp8.ctb"
                },
                "el": {
                    "6dot": "el.ctb"
                },
                "en": {
                    "6dot": "en-us-comp6.ctb",
                    "8dot": "en-us-comp8.ctb"
                },
                "es": {
                    "8dot": "Es-Es-G0.utb"
                },
                "fi": {
                    "6dot": "fi.utb",
                    "8dot": "fi-fi-8dot.ctb"
                },
                "fr": {
                    "6dot": "fr-bfu-comp6.utb",
                    "8dot": "fr-bfu-comp8.utb"
                },
                "hu": {
                    "6dot": "hu-hu-g1.ctb",
                    "8dot": "hu-hu-comp8.ctb"
                },
                "is": {
                    "8dot": "is.ctb"
                },
                "it": {
                    "6dot": "it-it-comp6.utb",
                    "8dot": "it-it-comp8.utb"
                },
                "lt": {
                    "6dot": "lt-6dot.tbl",
                    "8dot": "lt.ctb"
                },
                "lv": {
                    "6dot": "Lv-Lv-g1.utb"
                },
                "nb": {
                    "6dot": "no-no-g0.utb",
                    "8dot": "no-no-comp8.ctb"
                },
                "nl": {
                    "6dot": "nl-NL-g0.utb",
                    "8dot": "nl-comp8.utb"
                },
                "nn": {
                    "8dot": "no-no-comp8.ctb"
                },
                "pl": {
                    "6dot": "Pl-Pl-g1.utb",
                    "8dot": "pl-pl-comp8.ctb"
                },
                "pt": {
                    "6dot": "pt-pt-g1.utb",
                    "8dot": "pt-pt-comp8.ctb"
                },
                "ro": {
                    "6dot": "ro-g0.utb",
                    "8dot": "ro.ctb"
                },
                "ru": {
                    "6dot": "ru-litbrl.ctb",
                    "8dot": "ru.ctb"
                },
                "sr": {
                    "6dot": "sr-g1.ctb"
                },
                "sv": {
                    "6dot": "sv-g0.utb",
                    "8dot": "se-se.ctb"
                },
                "tr": {
                    "6dot": "tr-g1.ctb",
                    "8dot": "tr.ctb"
                },
                "uk": {
                    "6dot": "uk.utb",
                    "8dot": "uk-comp.utb"
                },
                "vi": {
                    "6dot": "vi-vn-g0.utb",
                    "8dot": "vi-cb8.utb"
                }
            },
            "defaultDisplayTables": {
                "af": "unicode.dis",
                "ar": "unicode.dis",
                "bg": "unicode.dis",
                "ca": "unicode.dis",
                "cs": "unicode.dis",
                "da": "unicode.dis",
                "de": "unicode.dis",
                "el": "unicode.dis",
                "en": "unicode.dis",
                "es": "unicode.dis",
                "fi": "unicode.dis",
                "fr": "unicode.dis",
                "hu": "unicode.dis",
                "is": "unicode.dis",
                "it": "unicode.dis",
                "lt": "unicode.dis",
                "lv": "unicode.dis",
                "nb": "unicode.dis",
                "nl": "nl-unicode.dis",
                "nn": "unicode.dis",
                "pl": "unicode.dis",
                "pt": "unicode.dis",
                "ro": "unicode.dis",
                "ru": "ru-unicode.dis",
                "sr": "unicode.dis",
                "sv": "unicode.dis",
                "tr": "unicode.dis",
                "uk": "ru-unicode.dis",
                "vi": "unicode.dis"
            },
            "displayTables": [
                "bg.dis",
                "da-dk-octobraille_1993.dis",
                "da-dk-octobraille.dis",
                "de-de.dis",
                "de-eurobrl6.dis",
                "de-eurobrl6u.dis",
                "en-us-brf.dis",
                "es-new.dis",
                "es-old.dis",
                "hu-backtranslate-correction.dis",
                "nl-BE.dis",
                "nl-print.dis",
                "nl-unicode.dis",
                "no-no-braillo-047-01.dis",
                "no-no.dis",
                "no-no-generic.dis",
                "ru-brf.dis",
                "ru-letters.dis",
                "ru-unicode.dis",
                "se-se.dis",
                "text_nabcc.dis",
                "unicode.dis",
                "unicode-without-blank.dis",
                "uni-text.dis",
                "us-table.dis",
                "wordcx.dis"
            ],
            "hyphenationDictionaries": {
                "da-dk-g2.dic": "UTF-8",
                "de-g1-core-patterns.dic": "UTF-8",
                "de-g2-core-patterns.dic": "UTF-8",
                "hyph_cs_CZ.dic": "UTF-8",
                "hyph_da_DK.dic": "UTF-8",
                "hyph_de_DE.dic": "ISO8859-1",
                "hyph_en_US.dic": "ISO8859-1",
                "hyph_eo.dic": "UTF-8",
                "hyph_es_ES.dic": "ISO8859-1",
                "hyph_fr_FR.dic": "ISO8859-1",
                "hyph_hu_HU.dic": "UTF-8",
                "hyph_it_IT.dic": "ISO8859-1",
                "hyph_nb_NO.dic": "ISO8859-1",
                "hyph_nl_NL.dic": "ISO8859-1",
                "hyph_nn_NO.dic": "ISO8859-1",
                "hyph_pl_PL.dic": "ISO8859-2",
                "hyph_pt_PT.dic": "ISO8859-1",
                "hyph_ru.dic": "UTF-8",
                "hyph_sv_SE.dic": "ISO8859-1"
            },
            "selectedTables": {
                "af": {
                    "0": {
                        "filename": "afr-za-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "af"
                    },
                    "1": {
                        "filename": "afr-za-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "af"
                    }
                },
                "ar": {
                    "0": {
                        "filename": "ar-ar-comp8.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 0,
                        "language": "ar"
                    },
                    "1": {
                        "filename": "ar-ar-g1.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "ar"
                    },
                    "2": {
                        "filename": "ar-ar-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "ar"
                    }
                },
                "bg": {
                    "0": {
                        "filename": "bg.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "bg"
                    },
                    "1": {
                        "filename": "bg.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 1,
                        "language": "bg"
                    }
                },
                "ca": {
                    "0": {
                        "filename": "ca-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "ca"
                    }
                },
                "cs": {
                    "0": {
                        "filename": "cs-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "cs"
                    },
                    "1": {
                        "filename": "cs-comp8.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 1,
                        "language": "cs"
                    }
                },
                "da": {
                    "0": {
                        "filename": "da-dk-g16.ctb",
                        "displayName": "2022 standard",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "da"
                    },
                    "1": {
                        "filename": "da-dk-g26.ctb",
                        "displayName": "2022 standard",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "da"
                    },
                    "2": {
                        "filename": "da-dk-g08.ctb",
                        "displayName": "computer 2022 standard",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 2,
                        "language": "da"
                    },
                    "3": {
                        "filename": "da-dk-g18.ctb",
                        "displayName": "2022 standard",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 3,
                        "language": "da"
                    },
                    "4": {
                        "filename": "da-dk-g28.ctb",
                        "displayName": "2022 standard",
                        "computer": false,
                        "grade": "2",
                        "dots": 8,
                        "sort": 4,
                        "language": "da"
                    }
                },
                "de": {
                    "0": {
                        "filename": "de-g0.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "de"
                    },
                    "1": {
                        "filename": "de-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "de"
                    },
                    "2": {
                        "filename": "de-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "de"
                    },
                    "3": {
                        "filename": "de-comp6.utb",
                        "displayName": "Schweiz. Bibl. für Blinde",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 3,
                        "language": "de"
                    },
                    "4": {
                        "filename": "de-de-comp8.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 4,
                        "language": "de"
                    },
                    "5": {
                        "filename": "de-g0-detailed.utb",
                        "displayName": "Mit Großbuchstaben",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 5,
                        "language": "de"
                    },
                    "6": {
                        "filename": "de-g1-detailed.ctb",
                        "displayName": "Mit Großbuchstaben",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 6,
                        "language": "de"
                    },
                    "7": {
                        "filename": "de-g2-detailed.ctb",
                        "displayName": "Mit Großbuchstaben",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 7,
                        "language": "de"
                    }
                },
                "dra": {
                    "0": {
                        "filename": "dra.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 0,
                        "language": "dra"
                    }
                },
                "el": {
                    "0": {
                        "filename": "el.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "el"
                    },
                    "1": {
                        "filename": "grc-international-composed.uti",
                        "displayName": "composed accents",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "el"
                    },
                    "2": {
                        "filename": "grc-international-decomposed.uti",
                        "displayName": "decomposed accents",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 2,
                        "language": "el"
                    }
                },
                "en": {
                    "0": {
                        "filename": "en-ueb-g1.ctb",
                        "displayName": "Unified English",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "en"
                    },
                    "1": {
                        "filename": "en-ueb-g2.ctb",
                        "displayName": "Unified English",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "en"
                    },
                    "2": {
                        "filename": "en-us-comp6.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 2,
                        "language": "en"
                    },
                    "3": {
                        "filename": "en-us-comp8.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 3,
                        "language": "en"
                    },
                    "4": {
                        "filename": "en-us-comp8-ext.utb",
                        "displayName": "for Windows",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 4,
                        "language": "en"
                    },
                    "5": {
                        "filename": "en-us-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 5,
                        "language": "en"
                    },
                    "6": {
                        "filename": "en-us-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 8,
                        "sort": 6,
                        "language": "en"
                    },
                    "7": {
                        "filename": "en-gb-g1.utb",
                        "displayName": "United Kingdom ",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 7,
                        "language": "en"
                    },
                    "8": {
                        "filename": "en-GB-g2.ctb",
                        "displayName": "United Kingdom ",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 8,
                        "language": "en"
                    },
                    "9": {
                        "filename": "en-gb-comp8.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 9,
                        "language": "en"
                    },
                    "10": {
                        "filename": "en_CA.ctb",
                        "displayName": "Canada ",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 10,
                        "language": "en"
                    },
                    "11": {
                        "filename": "en-in-g1.ctb",
                        "displayName": "India ",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 11,
                        "language": "en"
                    }
                },
                "es": {
                    "0": {
                        "filename": "Es-Es-G0.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 0,
                        "language": "es"
                    },
                    "1": {
                        "filename": "es-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "es"
                    },
                    "2": {
                        "filename": "es-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "es"
                    }
                },
                "fi": {
                    "0": {
                        "filename": "fi.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "fi"
                    },
                    "1": {
                        "filename": "fi-fi-8dot.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 1,
                        "language": "fi"
                    }
                },
                "fr": {
                    "0": {
                        "filename": "fr-bfu-comp6.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "fr"
                    },
                    "1": {
                        "filename": "fr-bfu-comp8.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 1,
                        "language": "fr"
                    },
                    "2": {
                        "filename": "fr-bfu-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "fr"
                    }
                },
                "hu": {
                    "0": {
                        "filename": "hu-hu-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "hu"
                    },
                    "1": {
                        "filename": "hu-hu-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "hu"
                    },
                    "2": {
                        "filename": "hu-hu-comp8.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 2,
                        "language": "hu"
                    }
                },
                "is": {
                    "0": {
                        "filename": "is.tbl",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "is"
                    },
                    "1": {
                        "filename": "is.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 1,
                        "language": "is"
                    }
                },
                "it": {
                    "0": {
                        "filename": "it-it-comp6.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "it"
                    },
                    "1": {
                        "filename": "it-it-comp8.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "it"
                    }
                },
                "kha": {
                    "0": {
                        "filename": "kha.tbl",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "kha"
                    }
                },
                "lt": {
                    "0": {
                        "filename": "lt-6dot.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "lt"
                    },
                    "1": {
                        "filename": "lt.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 1,
                        "language": "lt"
                    }
                },
                "lv": {
                    "0": {
                        "filename": "Lv-Lv-g1.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "lv"
                    }
                },
                "nb": {
                    "0": {
                        "filename": "no-no-g0.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "nb"
                    },
                    "1": {
                        "filename": "no-no-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "nb"
                    },
                    "2": {
                        "filename": "no-no-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "nb"
                    },
                    "3": {
                        "filename": "no-no-g3.ctb",
                        "computer": false,
                        "grade": "3",
                        "dots": 6,
                        "sort": 3,
                        "language": "nb"
                    },
                    "4": {
                        "filename": "no-no-comp8.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 4,
                        "language": "nb"
                    },
                    "5": {
                        "filename": "no-no-8dot-fallback-6dot-g0.utb",
                        "displayName": "fallback",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 5,
                        "language": "nb"
                    }
                },
                "nl": {
                    "0": {
                        "filename": "nl-unicode.dis,nl-NL-g0.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "nl"
                    },
                    "1": {
                        "filename": "nl-unicode.dis,nl-comp8.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 1,
                        "language": "nl"
                    }
                },
                "pl": {
                    "0": {
                        "filename": "Pl-Pl-g1.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "pl"
                    },
                    "1": {
                        "filename": "pl-pl-comp8.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "pl"
                    }
                },
                "pt": {
                    "0": {
                        "filename": "pt-pt-g1.utb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "pt"
                    },
                    "1": {
                        "filename": "pt-pt-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "pt"
                    },
                    "2": {
                        "filename": "pt-pt-comp8.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 2,
                        "language": "pt"
                    }
                },
                "ro": {
                    "0": {
                        "filename": "ro-g0.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "ro"
                    },
                    "1": {
                        "filename": "ro.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 1,
                        "language": "ro"
                    }
                },
                "ru": {
                    "0": {
                        "filename": "ru-unicode.dis,ru-litbrl.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "ru"
                    },
                    "1": {
                        "filename": "ru-unicode.dis,ru-litbrl-detailed.utb",
                        "displayName": "with capitals",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 1,
                        "language": "ru"
                    },
                    "2": {
                        "filename": "ru-unicode.dis,ru-ru-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 2,
                        "language": "ru"
                    },
                    "3": {
                        "filename": "ru-unicode.dis,ru-compbrl.ctb",
                        "displayName": "for program sources",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 3,
                        "language": "ru"
                    },
                    "4": {
                        "filename": "ru.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 8,
                        "sort": 4,
                        "language": "ru"
                    }
                },
                "sr": {
                    "0": {
                        "filename": "sr-g1.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "sr"
                    }
                },
                "sv": {
                    "0": {
                        "filename": "sv-g0.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "sv"
                    },
                    "1": {
                        "filename": "sv-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "sv"
                    },
                    "2": {
                        "filename": "sv-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "sv"
                    },
                    "3": {
                        "filename": "se-se.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 3,
                        "language": "sv"
                    }
                },
                "tr": {
                    "0": {
                        "filename": "tr-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 0,
                        "language": "tr"
                    },
                    "1": {
                        "filename": "tr-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 1,
                        "language": "tr"
                    },
                    "2": {
                        "filename": "tr.ctb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 2,
                        "language": "tr"
                    }
                },
                "uk": {
                    "0": {
                        "filename": "ru-unicode.dis,uk.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "uk"
                    },
                    "1": {
                        "filename": "ru-unicode.dis,uk-detailed.utb",
                        "displayName": "with capitals",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 1,
                        "language": "uk"
                    },
                    "2": {
                        "filename": "ru-unicode.dis,uk-comp.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 2,
                        "language": "uk"
                    }
                },
                "vi": {
                    "0": {
                        "filename": "vi-vn-g0.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 6,
                        "sort": 0,
                        "language": "vi"
                    },
                    "1": {
                        "filename": "vi-vn-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 1,
                        "language": "vi"
                    },
                    "2": {
                        "filename": "vi-vn-g2.ctb",
                        "computer": false,
                        "grade": "2",
                        "dots": 6,
                        "sort": 2,
                        "language": "vi"
                    },
                    "3": {
                        "filename": "vi-cb8.utb",
                        "computer": false,
                        "grade": "0",
                        "dots": 8,
                        "sort": 3,
                        "language": "vi"
                    },
                    "4": {
                        "filename": "vi-saigon-g1.ctb",
                        "computer": false,
                        "grade": "1",
                        "dots": 6,
                        "sort": 4,
                        "language": "vi"
                    }
                }
            }
        },
        "Amazon Translate": {
            "canonicalName": "Amazon Translate",
            "names": [
                "Amazon Translate",
                "amazon-translate"
            ],
            "languages": [
                "af",
                "am",
                "ar",
                "az",
                "bg",
                "bn",
                "bs",
                "ca",
                "cs",
                "cy",
                "da",
                "de",
                "el",
                "en",
                "es",
                "es-MX",
                "et",
                "fa",
                "fa-AF",
                "fi",
                "fr",
                "fr-CA",
                "ga",
                "gu",
                "ha",
                "he",
                "hi",
                "hr",
                "ht",
                "hu",
                "hy",
                "id",
                "is",
                "it",
                "ja",
                "ka",
                "kk",
                "kn",
                "ko",
                "lt",
                "lv",
                "mk",
                "ml",
                "mn",
                "mr",
                "ms",
                "mt",
                "nb",
                "nl",
                "pa",
                "pl",
                "ps",
                "pt",
                "pt-PT",
                "ro",
                "ru",
                "si",
                "sk",
                "sl",
                "so",
                "sq",
                "sr",
                "sv",
                "sw",
                "ta",
                "te",
                "th",
                "tl",
                "tr",
                "uk",
                "ur",
                "uz",
                "vi",
                "zh",
                "zh-TW"
            ],
            "type": "TRANSLATION"
        },
        "Speech Rule Engine": {
            "canonicalName": "Speech Rule Engine",
            "names": [
                "Speech Rule Engine",
                "sre"
            ],
            "languages": [
                "af",
                "ca",
                "da",
                "de",
                "en",
                "es",
                "fr",
                "hi",
                "it",
                "nb",
                "nn",
                "sv"
            ],
            "type": "OTHER"
        }
    }
};

export { servicesAndLanguages };